(() => {
  var e = {
      3615: (e, t, r) => {
        "use strict";
        var n = r(1385),
          o = r(8974);
        function i(e) {
          return (
            (i =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            i(e)
          );
        }
        function s(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              "value" in n && (n.writable = !0),
              Object.defineProperty(
                e,
                ((o = n.key),
                (s = void 0),
                (s = (function (e, t) {
                  if ("object" !== i(e) || null === e) return e;
                  var r = e[Symbol.toPrimitive];
                  if (void 0 !== r) {
                    var n = r.call(e, t || "default");
                    if ("object" !== i(n)) return n;
                    throw new TypeError(
                      "@@toPrimitive must return a primitive value."
                    );
                  }
                  return ("string" === t ? String : Number)(e);
                })(o, "string")),
                "symbol" === i(s) ? s : String(s)),
                n
              );
          }
          var o, s;
        }
        function a(e, t, r) {
          return (
            t && s(e.prototype, t),
            r && s(e, r),
            Object.defineProperty(e, "prototype", { writable: !1 }),
            e
          );
        }
        var l,
          c,
          u = r(9852).codes,
          d = u.ERR_AMBIGUOUS_ARGUMENT,
          p = u.ERR_INVALID_ARG_TYPE,
          f = u.ERR_INVALID_ARG_VALUE,
          h = u.ERR_INVALID_RETURN_VALUE,
          m = u.ERR_MISSING_ARGS,
          g = r(2763),
          y = r(6818).inspect,
          v = r(6818).types,
          w = v.isPromise,
          b = v.isRegExp,
          A = r(8267)(),
          S = r(1723)(),
          E = r(2264)("RegExp.prototype.test");
        new Map();
        function x() {
          var e = r(2954);
          (l = e.isDeepEqual), (c = e.isDeepStrictEqual);
        }
        var T = !1,
          O = (e.exports = k),
          P = {};
        function j(e) {
          if (e.message instanceof Error) throw e.message;
          throw new g(e);
        }
        function M(e, t, r, n) {
          if (!r) {
            var o = !1;
            if (0 === t)
              (o = !0), (n = "No value argument passed to `assert.ok()`");
            else if (n instanceof Error) throw n;
            var i = new g({
              actual: r,
              expected: !0,
              message: n,
              operator: "==",
              stackStartFn: e,
            });
            throw ((i.generatedMessage = o), i);
          }
        }
        function k() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
            t[r] = arguments[r];
          M.apply(void 0, [k, t.length].concat(t));
        }
        (O.fail = function e(t, r, i, s, a) {
          var l,
            c = arguments.length;
          if (0 === c) l = "Failed";
          else if (1 === c) (i = t), (t = void 0);
          else {
            if (!1 === T)
              (T = !0),
                (n.emitWarning ? n.emitWarning : o.warn.bind(o))(
                  "assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.",
                  "DeprecationWarning",
                  "DEP0094"
                );
            2 === c && (s = "!=");
          }
          if (i instanceof Error) throw i;
          var u = {
            actual: t,
            expected: r,
            operator: void 0 === s ? "fail" : s,
            stackStartFn: a || e,
          };
          void 0 !== i && (u.message = i);
          var d = new g(u);
          throw (l && ((d.message = l), (d.generatedMessage = !0)), d);
        }),
          (O.AssertionError = g),
          (O.ok = k),
          (O.equal = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            t != r &&
              j({
                actual: t,
                expected: r,
                message: n,
                operator: "==",
                stackStartFn: e,
              });
          }),
          (O.notEqual = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            t == r &&
              j({
                actual: t,
                expected: r,
                message: n,
                operator: "!=",
                stackStartFn: e,
              });
          }),
          (O.deepEqual = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            void 0 === l && x(),
              l(t, r) ||
                j({
                  actual: t,
                  expected: r,
                  message: n,
                  operator: "deepEqual",
                  stackStartFn: e,
                });
          }),
          (O.notDeepEqual = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            void 0 === l && x(),
              l(t, r) &&
                j({
                  actual: t,
                  expected: r,
                  message: n,
                  operator: "notDeepEqual",
                  stackStartFn: e,
                });
          }),
          (O.deepStrictEqual = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            void 0 === l && x(),
              c(t, r) ||
                j({
                  actual: t,
                  expected: r,
                  message: n,
                  operator: "deepStrictEqual",
                  stackStartFn: e,
                });
          }),
          (O.notDeepStrictEqual = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            void 0 === l && x();
            c(t, r) &&
              j({
                actual: t,
                expected: r,
                message: n,
                operator: "notDeepStrictEqual",
                stackStartFn: e,
              });
          }),
          (O.strictEqual = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            S(t, r) ||
              j({
                actual: t,
                expected: r,
                message: n,
                operator: "strictEqual",
                stackStartFn: e,
              });
          }),
          (O.notStrictEqual = function e(t, r, n) {
            if (arguments.length < 2) throw new m("actual", "expected");
            S(t, r) &&
              j({
                actual: t,
                expected: r,
                message: n,
                operator: "notStrictEqual",
                stackStartFn: e,
              });
          });
        var I = a(function e(t, r, n) {
          var o = this;
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            r.forEach(function (e) {
              e in t &&
                (void 0 !== n &&
                "string" == typeof n[e] &&
                b(t[e]) &&
                E(t[e], n[e])
                  ? (o[e] = n[e])
                  : (o[e] = t[e]));
            });
        });
        function C(e, t, r, n) {
          if ("function" != typeof t) {
            if (b(t)) return E(t, e);
            if (2 === arguments.length)
              throw new p("expected", ["Function", "RegExp"], t);
            if ("object" !== i(e) || null === e) {
              var o = new g({
                actual: e,
                expected: t,
                message: r,
                operator: "deepStrictEqual",
                stackStartFn: n,
              });
              throw ((o.operator = n.name), o);
            }
            var s = Object.keys(t);
            if (t instanceof Error) s.push("name", "message");
            else if (0 === s.length)
              throw new f("error", t, "may not be an empty object");
            return (
              void 0 === l && x(),
              s.forEach(function (o) {
                ("string" == typeof e[o] && b(t[o]) && E(t[o], e[o])) ||
                  (function (e, t, r, n, o, i) {
                    if (!(r in e) || !c(e[r], t[r])) {
                      if (!n) {
                        var s = new I(e, o),
                          a = new I(t, o, e),
                          l = new g({
                            actual: s,
                            expected: a,
                            operator: "deepStrictEqual",
                            stackStartFn: i,
                          });
                        throw (
                          ((l.actual = e),
                          (l.expected = t),
                          (l.operator = i.name),
                          l)
                        );
                      }
                      j({
                        actual: e,
                        expected: t,
                        message: n,
                        operator: i.name,
                        stackStartFn: i,
                      });
                    }
                  })(e, t, o, r, s, n);
              }),
              !0
            );
          }
          return (
            (void 0 !== t.prototype && e instanceof t) ||
            (!Error.isPrototypeOf(t) && !0 === t.call({}, e))
          );
        }
        function L(e) {
          if ("function" != typeof e) throw new p("fn", "Function", e);
          try {
            e();
          } catch (e) {
            return e;
          }
          return P;
        }
        function B(e) {
          return (
            w(e) ||
            (null !== e &&
              "object" === i(e) &&
              "function" == typeof e.then &&
              "function" == typeof e.catch)
          );
        }
        function D(e) {
          return Promise.resolve().then(function () {
            var t;
            if ("function" == typeof e) {
              if (!B((t = e())))
                throw new h("instance of Promise", "promiseFn", t);
            } else {
              if (!B(e)) throw new p("promiseFn", ["Function", "Promise"], e);
              t = e;
            }
            return Promise.resolve()
              .then(function () {
                return t;
              })
              .then(function () {
                return P;
              })
              .catch(function (e) {
                return e;
              });
          });
        }
        function _(e, t, r, n) {
          if ("string" == typeof r) {
            if (4 === arguments.length)
              throw new p(
                "error",
                ["Object", "Error", "Function", "RegExp"],
                r
              );
            if ("object" === i(t) && null !== t) {
              if (t.message === r)
                throw new d(
                  "error/message",
                  'The error message "'.concat(
                    t.message,
                    '" is identical to the message.'
                  )
                );
            } else if (t === r)
              throw new d(
                "error/message",
                'The error "'.concat(t, '" is identical to the message.')
              );
            (n = r), (r = void 0);
          } else if (null != r && "object" !== i(r) && "function" != typeof r)
            throw new p("error", ["Object", "Error", "Function", "RegExp"], r);
          if (t === P) {
            var o = "";
            r && r.name && (o += " (".concat(r.name, ")")),
              (o += n ? ": ".concat(n) : ".");
            var s = "rejects" === e.name ? "rejection" : "exception";
            j({
              actual: void 0,
              expected: r,
              operator: e.name,
              message: "Missing expected ".concat(s).concat(o),
              stackStartFn: e,
            });
          }
          if (r && !C(t, r, n, e)) throw t;
        }
        function z(e, t, r, n) {
          if (t !== P) {
            if (
              ("string" == typeof r && ((n = r), (r = void 0)), !r || C(t, r))
            ) {
              var o = n ? ": ".concat(n) : ".",
                i = "doesNotReject" === e.name ? "rejection" : "exception";
              j({
                actual: t,
                expected: r,
                operator: e.name,
                message:
                  "Got unwanted ".concat(i).concat(o, "\n") +
                  'Actual message: "'.concat(t && t.message, '"'),
                stackStartFn: e,
              });
            }
            throw t;
          }
        }
        function F(e, t, r, n, o) {
          if (!b(t)) throw new p("regexp", "RegExp", t);
          var s = "match" === o;
          if ("string" != typeof e || E(t, e) !== s) {
            if (r instanceof Error) throw r;
            var a = !r;
            r =
              r ||
              ("string" != typeof e
                ? 'The "string" argument must be of type string. Received type ' +
                  "".concat(i(e), " (").concat(y(e), ")")
                : (s
                    ? "The input did not match the regular expression "
                    : "The input was expected to not match the regular expression ") +
                  "".concat(y(t), ". Input:\n\n").concat(y(e), "\n"));
            var l = new g({
              actual: e,
              expected: t,
              message: r,
              operator: o,
              stackStartFn: n,
            });
            throw ((l.generatedMessage = a), l);
          }
        }
        function N() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
            t[r] = arguments[r];
          M.apply(void 0, [N, t.length].concat(t));
        }
        (O.throws = function e(t) {
          for (
            var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1;
            o < r;
            o++
          )
            n[o - 1] = arguments[o];
          _.apply(void 0, [e, L(t)].concat(n));
        }),
          (O.rejects = function e(t) {
            for (
              var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1;
              o < r;
              o++
            )
              n[o - 1] = arguments[o];
            return D(t).then(function (t) {
              return _.apply(void 0, [e, t].concat(n));
            });
          }),
          (O.doesNotThrow = function e(t) {
            for (
              var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1;
              o < r;
              o++
            )
              n[o - 1] = arguments[o];
            z.apply(void 0, [e, L(t)].concat(n));
          }),
          (O.doesNotReject = function e(t) {
            for (
              var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1;
              o < r;
              o++
            )
              n[o - 1] = arguments[o];
            return D(t).then(function (t) {
              return z.apply(void 0, [e, t].concat(n));
            });
          }),
          (O.ifError = function e(t) {
            if (null != t) {
              var r = "ifError got unwanted exception: ";
              "object" === i(t) && "string" == typeof t.message
                ? 0 === t.message.length && t.constructor
                  ? (r += t.constructor.name)
                  : (r += t.message)
                : (r += y(t));
              var n = new g({
                  actual: t,
                  expected: null,
                  operator: "ifError",
                  message: r,
                  stackStartFn: e,
                }),
                o = t.stack;
              if ("string" == typeof o) {
                var s = o.split("\n");
                s.shift();
                for (var a = n.stack.split("\n"), l = 0; l < s.length; l++) {
                  var c = a.indexOf(s[l]);
                  if (-1 !== c) {
                    a = a.slice(0, c);
                    break;
                  }
                }
                n.stack = "".concat(a.join("\n"), "\n").concat(s.join("\n"));
              }
              throw n;
            }
          }),
          (O.match = function e(t, r, n) {
            F(t, r, n, e, "match");
          }),
          (O.doesNotMatch = function e(t, r, n) {
            F(t, r, n, e, "doesNotMatch");
          }),
          (O.strict = A(N, O, {
            equal: O.strictEqual,
            deepEqual: O.deepStrictEqual,
            notEqual: O.notStrictEqual,
            notDeepEqual: O.notDeepStrictEqual,
          })),
          (O.strict.strict = O.strict);
      },
      2763: (e, t, r) => {
        "use strict";
        var n = r(1385);
        function o(e, t) {
          var r = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t &&
              (n = n.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })),
              r.push.apply(r, n);
          }
          return r;
        }
        function i(e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2
              ? o(Object(r), !0).forEach(function (t) {
                  s(e, t, r[t]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
              : o(Object(r)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(r, t)
                  );
                });
          }
          return e;
        }
        function s(e, t, r) {
          return (
            (t = l(t)) in e
              ? Object.defineProperty(e, t, {
                  value: r,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (e[t] = r),
            e
          );
        }
        function a(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              "value" in n && (n.writable = !0),
              Object.defineProperty(e, l(n.key), n);
          }
        }
        function l(e) {
          var t = (function (e, t) {
            if ("object" !== g(e) || null === e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
              var n = r.call(e, t || "default");
              if ("object" !== g(n)) return n;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === t ? String : Number)(e);
          })(e, "string");
          return "symbol" === g(t) ? t : String(t);
        }
        function c(e, t) {
          if (t && ("object" === g(t) || "function" == typeof t)) return t;
          if (void 0 !== t)
            throw new TypeError(
              "Derived constructors may only return object or undefined"
            );
          return u(e);
        }
        function u(e) {
          if (void 0 === e)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return e;
        }
        function d(e) {
          var t = "function" == typeof Map ? new Map() : void 0;
          return (
            (d = function (e) {
              if (
                null === e ||
                ((r = e),
                -1 === Function.toString.call(r).indexOf("[native code]"))
              )
                return e;
              var r;
              if ("function" != typeof e)
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, n);
              }
              function n() {
                return p(e, arguments, m(this).constructor);
              }
              return (
                (n.prototype = Object.create(e.prototype, {
                  constructor: {
                    value: n,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                h(n, e)
              );
            }),
            d(e)
          );
        }
        function p(e, t, r) {
          return (
            (p = f()
              ? Reflect.construct.bind()
              : function (e, t, r) {
                  var n = [null];
                  n.push.apply(n, t);
                  var o = new (Function.bind.apply(e, n))();
                  return r && h(o, r.prototype), o;
                }),
            p.apply(null, arguments)
          );
        }
        function f() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () {})
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        }
        function h(e, t) {
          return (
            (h = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (e, t) {
                  return (e.__proto__ = t), e;
                }),
            h(e, t)
          );
        }
        function m(e) {
          return (
            (m = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                }),
            m(e)
          );
        }
        function g(e) {
          return (
            (g =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            g(e)
          );
        }
        var y = r(6818).inspect,
          v = r(9852).codes.ERR_INVALID_ARG_TYPE;
        function w(e, t, r) {
          return (
            (void 0 === r || r > e.length) && (r = e.length),
            e.substring(r - t.length, r) === t
          );
        }
        var b = "",
          A = "",
          S = "",
          E = "",
          x = {
            deepStrictEqual: "Expected values to be strictly deep-equal:",
            strictEqual: "Expected values to be strictly equal:",
            strictEqualObject:
              'Expected "actual" to be reference-equal to "expected":',
            deepEqual: "Expected values to be loosely deep-equal:",
            equal: "Expected values to be loosely equal:",
            notDeepStrictEqual:
              'Expected "actual" not to be strictly deep-equal to:',
            notStrictEqual: 'Expected "actual" to be strictly unequal to:',
            notStrictEqualObject:
              'Expected "actual" not to be reference-equal to "expected":',
            notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
            notEqual: 'Expected "actual" to be loosely unequal to:',
            notIdentical: "Values identical but not reference-equal:",
          };
        function T(e) {
          var t = Object.keys(e),
            r = Object.create(Object.getPrototypeOf(e));
          return (
            t.forEach(function (t) {
              r[t] = e[t];
            }),
            Object.defineProperty(r, "message", { value: e.message }),
            r
          );
        }
        function O(e) {
          return y(e, {
            compact: !1,
            customInspect: !1,
            depth: 1e3,
            maxArrayLength: 1 / 0,
            showHidden: !1,
            breakLength: 1 / 0,
            showProxy: !1,
            sorted: !0,
            getters: !0,
          });
        }
        function P(e, t, r) {
          var o = "",
            i = "",
            s = 0,
            a = "",
            l = !1,
            c = O(e),
            u = c.split("\n"),
            d = O(t).split("\n"),
            p = 0,
            f = "";
          if (
            ("strictEqual" === r &&
              "object" === g(e) &&
              "object" === g(t) &&
              null !== e &&
              null !== t &&
              (r = "strictEqualObject"),
            1 === u.length && 1 === d.length && u[0] !== d[0])
          ) {
            var h = u[0].length + d[0].length;
            if (h <= 10) {
              if (
                !(
                  ("object" === g(e) && null !== e) ||
                  ("object" === g(t) && null !== t) ||
                  (0 === e && 0 === t)
                )
              )
                return (
                  "".concat(x[r], "\n\n") +
                  "".concat(u[0], " !== ").concat(d[0], "\n")
                );
            } else if ("strictEqualObject" !== r) {
              if (h < (n.stderr && n.stderr.isTTY ? n.stderr.columns : 80)) {
                for (; u[0][p] === d[0][p]; ) p++;
                p > 2 &&
                  ((f = "\n  ".concat(
                    (function (e, t) {
                      if (((t = Math.floor(t)), 0 == e.length || 0 == t))
                        return "";
                      var r = e.length * t;
                      for (t = Math.floor(Math.log(t) / Math.log(2)); t; )
                        (e += e), t--;
                      return e + e.substring(0, r - e.length);
                    })(" ", p),
                    "^"
                  )),
                  (p = 0));
              }
            }
          }
          for (
            var m = u[u.length - 1], y = d[d.length - 1];
            m === y &&
            (p++ < 2 ? (a = "\n  ".concat(m).concat(a)) : (o = m),
            u.pop(),
            d.pop(),
            0 !== u.length && 0 !== d.length);

          )
            (m = u[u.length - 1]), (y = d[d.length - 1]);
          var v = Math.max(u.length, d.length);
          if (0 === v) {
            var T = c.split("\n");
            if (T.length > 30)
              for (T[26] = "".concat(b, "...").concat(E); T.length > 27; )
                T.pop();
            return "".concat(x.notIdentical, "\n\n").concat(T.join("\n"), "\n");
          }
          p > 3 && ((a = "\n".concat(b, "...").concat(E).concat(a)), (l = !0)),
            "" !== o && ((a = "\n  ".concat(o).concat(a)), (o = ""));
          var P = 0,
            j =
              x[r] +
              "\n"
                .concat(A, "+ actual")
                .concat(E, " ")
                .concat(S, "- expected")
                .concat(E),
            M = " ".concat(b, "...").concat(E, " Lines skipped");
          for (p = 0; p < v; p++) {
            var k = p - s;
            if (u.length < p + 1)
              k > 1 &&
                p > 2 &&
                (k > 4
                  ? ((i += "\n".concat(b, "...").concat(E)), (l = !0))
                  : k > 3 && ((i += "\n  ".concat(d[p - 2])), P++),
                (i += "\n  ".concat(d[p - 1])),
                P++),
                (s = p),
                (o += "\n".concat(S, "-").concat(E, " ").concat(d[p])),
                P++;
            else if (d.length < p + 1)
              k > 1 &&
                p > 2 &&
                (k > 4
                  ? ((i += "\n".concat(b, "...").concat(E)), (l = !0))
                  : k > 3 && ((i += "\n  ".concat(u[p - 2])), P++),
                (i += "\n  ".concat(u[p - 1])),
                P++),
                (s = p),
                (i += "\n".concat(A, "+").concat(E, " ").concat(u[p])),
                P++;
            else {
              var I = d[p],
                C = u[p],
                L = C !== I && (!w(C, ",") || C.slice(0, -1) !== I);
              L && w(I, ",") && I.slice(0, -1) === C && ((L = !1), (C += ",")),
                L
                  ? (k > 1 &&
                      p > 2 &&
                      (k > 4
                        ? ((i += "\n".concat(b, "...").concat(E)), (l = !0))
                        : k > 3 && ((i += "\n  ".concat(u[p - 2])), P++),
                      (i += "\n  ".concat(u[p - 1])),
                      P++),
                    (s = p),
                    (i += "\n".concat(A, "+").concat(E, " ").concat(C)),
                    (o += "\n".concat(S, "-").concat(E, " ").concat(I)),
                    (P += 2))
                  : ((i += o),
                    (o = ""),
                    (1 !== k && 0 !== p) || ((i += "\n  ".concat(C)), P++));
            }
            if (P > 20 && p < v - 2)
              return (
                ""
                  .concat(j)
                  .concat(M, "\n")
                  .concat(i, "\n")
                  .concat(b, "...")
                  .concat(E)
                  .concat(o, "\n") + "".concat(b, "...").concat(E)
              );
          }
          return ""
            .concat(j)
            .concat(l ? M : "", "\n")
            .concat(i)
            .concat(o)
            .concat(a)
            .concat(f);
        }
        var j = (function (e, t) {
          !(function (e, t) {
            if ("function" != typeof t && null !== t)
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            (e.prototype = Object.create(t && t.prototype, {
              constructor: { value: e, writable: !0, configurable: !0 },
            })),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              t && h(e, t);
          })(w, e);
          var r,
            o,
            s,
            l,
            d,
            p =
              ((r = w),
              (o = f()),
              function () {
                var e,
                  t = m(r);
                if (o) {
                  var n = m(this).constructor;
                  e = Reflect.construct(t, arguments, n);
                } else e = t.apply(this, arguments);
                return c(this, e);
              });
          function w(e) {
            var t;
            if (
              ((function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, w),
              "object" !== g(e) || null === e)
            )
              throw new v("options", "Object", e);
            var r = e.message,
              o = e.operator,
              i = e.stackStartFn,
              s = e.actual,
              a = e.expected,
              l = Error.stackTraceLimit;
            if (((Error.stackTraceLimit = 0), null != r))
              t = p.call(this, String(r));
            else if (
              (n.stderr &&
                n.stderr.isTTY &&
                (n.stderr &&
                n.stderr.getColorDepth &&
                1 !== n.stderr.getColorDepth()
                  ? ((b = "[34m"), (A = "[32m"), (E = "[39m"), (S = "[31m"))
                  : ((b = ""), (A = ""), (E = ""), (S = ""))),
              "object" === g(s) &&
                null !== s &&
                "object" === g(a) &&
                null !== a &&
                "stack" in s &&
                s instanceof Error &&
                "stack" in a &&
                a instanceof Error &&
                ((s = T(s)), (a = T(a))),
              "deepStrictEqual" === o || "strictEqual" === o)
            )
              t = p.call(this, P(s, a, o));
            else if ("notDeepStrictEqual" === o || "notStrictEqual" === o) {
              var d = x[o],
                f = O(s).split("\n");
              if (
                ("notStrictEqual" === o &&
                  "object" === g(s) &&
                  null !== s &&
                  (d = x.notStrictEqualObject),
                f.length > 30)
              )
                for (f[26] = "".concat(b, "...").concat(E); f.length > 27; )
                  f.pop();
              t =
                1 === f.length
                  ? p.call(this, "".concat(d, " ").concat(f[0]))
                  : p.call(
                      this,
                      "".concat(d, "\n\n").concat(f.join("\n"), "\n")
                    );
            } else {
              var h = O(s),
                m = "",
                y = x[o];
              "notDeepEqual" === o || "notEqual" === o
                ? (h = "".concat(x[o], "\n\n").concat(h)).length > 1024 &&
                  (h = "".concat(h.slice(0, 1021), "..."))
                : ((m = "".concat(O(a))),
                  h.length > 512 && (h = "".concat(h.slice(0, 509), "...")),
                  m.length > 512 && (m = "".concat(m.slice(0, 509), "...")),
                  "deepEqual" === o || "equal" === o
                    ? (h = ""
                        .concat(y, "\n\n")
                        .concat(h, "\n\nshould equal\n\n"))
                    : (m = " ".concat(o, " ").concat(m))),
                (t = p.call(this, "".concat(h).concat(m)));
            }
            return (
              (Error.stackTraceLimit = l),
              (t.generatedMessage = !r),
              Object.defineProperty(u(t), "name", {
                value: "AssertionError [ERR_ASSERTION]",
                enumerable: !1,
                writable: !0,
                configurable: !0,
              }),
              (t.code = "ERR_ASSERTION"),
              (t.actual = s),
              (t.expected = a),
              (t.operator = o),
              Error.captureStackTrace && Error.captureStackTrace(u(t), i),
              t.stack,
              (t.name = "AssertionError"),
              c(t)
            );
          }
          return (
            (s = w),
            (l = [
              {
                key: "toString",
                value: function () {
                  return ""
                    .concat(this.name, " [")
                    .concat(this.code, "]: ")
                    .concat(this.message);
                },
              },
              {
                key: t,
                value: function (e, t) {
                  return y(
                    this,
                    i(i({}, t), {}, { customInspect: !1, depth: 0 })
                  );
                },
              },
            ]) && a(s.prototype, l),
            d && a(s, d),
            Object.defineProperty(s, "prototype", { writable: !1 }),
            w
          );
        })(d(Error), y.custom);
        e.exports = j;
      },
      9852: (e, t, r) => {
        "use strict";
        function n(e) {
          return (
            (n =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            n(e)
          );
        }
        function o(e, t) {
          for (var r = 0; r < t.length; r++) {
            var o = t[r];
            (o.enumerable = o.enumerable || !1),
              (o.configurable = !0),
              "value" in o && (o.writable = !0),
              Object.defineProperty(
                e,
                ((i = o.key),
                (s = void 0),
                (s = (function (e, t) {
                  if ("object" !== n(e) || null === e) return e;
                  var r = e[Symbol.toPrimitive];
                  if (void 0 !== r) {
                    var o = r.call(e, t || "default");
                    if ("object" !== n(o)) return o;
                    throw new TypeError(
                      "@@toPrimitive must return a primitive value."
                    );
                  }
                  return ("string" === t ? String : Number)(e);
                })(i, "string")),
                "symbol" === n(s) ? s : String(s)),
                o
              );
          }
          var i, s;
        }
        function i(e, t) {
          return (
            (i = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (e, t) {
                  return (e.__proto__ = t), e;
                }),
            i(e, t)
          );
        }
        function s(e) {
          var t = (function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {})
                ),
                !0
              );
            } catch (e) {
              return !1;
            }
          })();
          return function () {
            var r,
              o = a(e);
            if (t) {
              var i = a(this).constructor;
              r = Reflect.construct(o, arguments, i);
            } else r = o.apply(this, arguments);
            return (function (e, t) {
              if (t && ("object" === n(t) || "function" == typeof t)) return t;
              if (void 0 !== t)
                throw new TypeError(
                  "Derived constructors may only return object or undefined"
                );
              return (function (e) {
                if (void 0 === e)
                  throw new ReferenceError(
                    "this hasn't been initialised - super() hasn't been called"
                  );
                return e;
              })(e);
            })(this, r);
          };
        }
        function a(e) {
          return (
            (a = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                }),
            a(e)
          );
        }
        var l,
          c,
          u = {};
        function d(e, t, r) {
          r || (r = Error);
          var n = (function (r) {
            !(function (e, t) {
              if ("function" != typeof t && null !== t)
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              (e.prototype = Object.create(t && t.prototype, {
                constructor: { value: e, writable: !0, configurable: !0 },
              })),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                t && i(e, t);
            })(u, r);
            var n,
              a,
              l,
              c = s(u);
            function u(r, n, o) {
              var i;
              return (
                (function (e, t) {
                  if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function");
                })(this, u),
                (i = c.call(
                  this,
                  (function (e, r, n) {
                    return "string" == typeof t ? t : t(e, r, n);
                  })(r, n, o)
                )),
                (i.code = e),
                i
              );
            }
            return (
              (n = u),
              a && o(n.prototype, a),
              l && o(n, l),
              Object.defineProperty(n, "prototype", { writable: !1 }),
              n
            );
          })(r);
          u[e] = n;
        }
        function p(e, t) {
          if (Array.isArray(e)) {
            var r = e.length;
            return (
              (e = e.map(function (e) {
                return String(e);
              })),
              r > 2
                ? "one of "
                    .concat(t, " ")
                    .concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1]
                : 2 === r
                ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1])
                : "of ".concat(t, " ").concat(e[0])
            );
          }
          return "of ".concat(t, " ").concat(String(e));
        }
        d(
          "ERR_AMBIGUOUS_ARGUMENT",
          'The "%s" argument is ambiguous. %s',
          TypeError
        ),
          d(
            "ERR_INVALID_ARG_TYPE",
            function (e, t, o) {
              var i, s, a, c;
              if (
                (void 0 === l && (l = r(3615)),
                l("string" == typeof e, "'name' must be a string"),
                "string" == typeof t &&
                ((s = "not "), t.substr(!a || a < 0 ? 0 : +a, s.length) === s)
                  ? ((i = "must not be"), (t = t.replace(/^not /, "")))
                  : (i = "must be"),
                (function (e, t, r) {
                  return (
                    (void 0 === r || r > e.length) && (r = e.length),
                    e.substring(r - t.length, r) === t
                  );
                })(e, " argument"))
              )
                c = "The ".concat(e, " ").concat(i, " ").concat(p(t, "type"));
              else {
                var u = (function (e, t, r) {
                  return (
                    "number" != typeof r && (r = 0),
                    !(r + t.length > e.length) && -1 !== e.indexOf(t, r)
                  );
                })(e, ".")
                  ? "property"
                  : "argument";
                c = 'The "'
                  .concat(e, '" ')
                  .concat(u, " ")
                  .concat(i, " ")
                  .concat(p(t, "type"));
              }
              return (c += ". Received type ".concat(n(o)));
            },
            TypeError
          ),
          d(
            "ERR_INVALID_ARG_VALUE",
            function (e, t) {
              var n =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : "is invalid";
              void 0 === c && (c = r(6818));
              var o = c.inspect(t);
              return (
                o.length > 128 && (o = "".concat(o.slice(0, 128), "...")),
                "The argument '"
                  .concat(e, "' ")
                  .concat(n, ". Received ")
                  .concat(o)
              );
            },
            TypeError,
            RangeError
          ),
          d(
            "ERR_INVALID_RETURN_VALUE",
            function (e, t, r) {
              var o;
              return (
                (o =
                  r && r.constructor && r.constructor.name
                    ? "instance of ".concat(r.constructor.name)
                    : "type ".concat(n(r))),
                "Expected "
                  .concat(e, ' to be returned from the "')
                  .concat(t, '"') + " function but got ".concat(o, ".")
              );
            },
            TypeError
          ),
          d(
            "ERR_MISSING_ARGS",
            function () {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              void 0 === l && (l = r(3615)),
                l(t.length > 0, "At least one arg needs to be specified");
              var o = "The ",
                i = t.length;
              switch (
                ((t = t.map(function (e) {
                  return '"'.concat(e, '"');
                })),
                i)
              ) {
                case 1:
                  o += "".concat(t[0], " argument");
                  break;
                case 2:
                  o += "".concat(t[0], " and ").concat(t[1], " arguments");
                  break;
                default:
                  (o += t.slice(0, i - 1).join(", ")),
                    (o += ", and ".concat(t[i - 1], " arguments"));
              }
              return "".concat(o, " must be specified");
            },
            TypeError
          ),
          (e.exports.codes = u);
      },
      2954: (e, t, r) => {
        "use strict";
        function n(e, t) {
          return (
            (function (e) {
              if (Array.isArray(e)) return e;
            })(e) ||
            (function (e, t) {
              var r =
                null == e
                  ? null
                  : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                    e["@@iterator"];
              if (null != r) {
                var n,
                  o,
                  i,
                  s,
                  a = [],
                  l = !0,
                  c = !1;
                try {
                  if (((i = (r = r.call(e)).next), 0 === t)) {
                    if (Object(r) !== r) return;
                    l = !1;
                  } else
                    for (
                      ;
                      !(l = (n = i.call(r)).done) &&
                      (a.push(n.value), a.length !== t);
                      l = !0
                    );
                } catch (e) {
                  (c = !0), (o = e);
                } finally {
                  try {
                    if (
                      !l &&
                      null != r.return &&
                      ((s = r.return()), Object(s) !== s)
                    )
                      return;
                  } finally {
                    if (c) throw o;
                  }
                }
                return a;
              }
            })(e, t) ||
            (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return o(e, t);
              var r = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === r && e.constructor && (r = e.constructor.name);
              if ("Map" === r || "Set" === r) return Array.from(e);
              if (
                "Arguments" === r ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
              )
                return o(e, t);
            })(e, t) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function o(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
          return n;
        }
        function i(e) {
          return (
            (i =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            i(e)
          );
        }
        var s = void 0 !== /a/g.flags,
          a = function (e) {
            var t = [];
            return (
              e.forEach(function (e) {
                return t.push(e);
              }),
              t
            );
          },
          l = function (e) {
            var t = [];
            return (
              e.forEach(function (e, r) {
                return t.push([r, e]);
              }),
              t
            );
          },
          c = Object.is ? Object.is : r(3354),
          u = Object.getOwnPropertySymbols
            ? Object.getOwnPropertySymbols
            : function () {
                return [];
              },
          d = Number.isNaN ? Number.isNaN : r(9836);
        function p(e) {
          return e.call.bind(e);
        }
        var f = p(Object.prototype.hasOwnProperty),
          h = p(Object.prototype.propertyIsEnumerable),
          m = p(Object.prototype.toString),
          g = r(6818).types,
          y = g.isAnyArrayBuffer,
          v = g.isArrayBufferView,
          w = g.isDate,
          b = g.isMap,
          A = g.isRegExp,
          S = g.isSet,
          E = g.isNativeError,
          x = g.isBoxedPrimitive,
          T = g.isNumberObject,
          O = g.isStringObject,
          P = g.isBooleanObject,
          j = g.isBigIntObject,
          M = g.isSymbolObject,
          k = g.isFloat32Array,
          I = g.isFloat64Array;
        function C(e) {
          if (0 === e.length || e.length > 10) return !0;
          for (var t = 0; t < e.length; t++) {
            var r = e.charCodeAt(t);
            if (r < 48 || r > 57) return !0;
          }
          return 10 === e.length && e >= Math.pow(2, 32);
        }
        function L(e) {
          return Object.keys(e)
            .filter(C)
            .concat(u(e).filter(Object.prototype.propertyIsEnumerable.bind(e)));
        }
        function B(e, t) {
          if (e === t) return 0;
          for (
            var r = e.length, n = t.length, o = 0, i = Math.min(r, n);
            o < i;
            ++o
          )
            if (e[o] !== t[o]) {
              (r = e[o]), (n = t[o]);
              break;
            }
          return r < n ? -1 : n < r ? 1 : 0;
        }
        var D = 0,
          _ = 1,
          z = 2,
          F = 3;
        function N(e, t, r, n) {
          if (e === t) return 0 !== e || !r || c(e, t);
          if (r) {
            if ("object" !== i(e)) return "number" == typeof e && d(e) && d(t);
            if ("object" !== i(t) || null === e || null === t) return !1;
            if (Object.getPrototypeOf(e) !== Object.getPrototypeOf(t))
              return !1;
          } else {
            if (null === e || "object" !== i(e))
              return (null === t || "object" !== i(t)) && e == t;
            if (null === t || "object" !== i(t)) return !1;
          }
          var o,
            a,
            l,
            u,
            p = m(e);
          if (p !== m(t)) return !1;
          if (Array.isArray(e)) {
            if (e.length !== t.length) return !1;
            var f = L(e),
              h = L(t);
            return f.length === h.length && G(e, t, r, n, _, f);
          }
          if ("[object Object]" === p && ((!b(e) && b(t)) || (!S(e) && S(t))))
            return !1;
          if (w(e)) {
            if (
              !w(t) ||
              Date.prototype.getTime.call(e) !== Date.prototype.getTime.call(t)
            )
              return !1;
          } else if (A(e)) {
            if (
              !A(t) ||
              ((l = e),
              (u = t),
              !(s
                ? l.source === u.source && l.flags === u.flags
                : RegExp.prototype.toString.call(l) ===
                  RegExp.prototype.toString.call(u)))
            )
              return !1;
          } else if (E(e) || e instanceof Error) {
            if (e.message !== t.message || e.name !== t.name) return !1;
          } else {
            if (v(e)) {
              if (r || (!k(e) && !I(e))) {
                if (
                  !(function (e, t) {
                    return (
                      e.byteLength === t.byteLength &&
                      0 ===
                        B(
                          new Uint8Array(e.buffer, e.byteOffset, e.byteLength),
                          new Uint8Array(t.buffer, t.byteOffset, t.byteLength)
                        )
                    );
                  })(e, t)
                )
                  return !1;
              } else if (
                !(function (e, t) {
                  if (e.byteLength !== t.byteLength) return !1;
                  for (var r = 0; r < e.byteLength; r++)
                    if (e[r] !== t[r]) return !1;
                  return !0;
                })(e, t)
              )
                return !1;
              var g = L(e),
                C = L(t);
              return g.length === C.length && G(e, t, r, n, D, g);
            }
            if (S(e)) return !(!S(t) || e.size !== t.size) && G(e, t, r, n, z);
            if (b(e)) return !(!b(t) || e.size !== t.size) && G(e, t, r, n, F);
            if (y(e)) {
              if (
                ((a = t),
                (o = e).byteLength !== a.byteLength ||
                  0 !== B(new Uint8Array(o), new Uint8Array(a)))
              )
                return !1;
            } else if (
              x(e) &&
              !(function (e, t) {
                return T(e)
                  ? T(t) &&
                      c(
                        Number.prototype.valueOf.call(e),
                        Number.prototype.valueOf.call(t)
                      )
                  : O(e)
                  ? O(t) &&
                    String.prototype.valueOf.call(e) ===
                      String.prototype.valueOf.call(t)
                  : P(e)
                  ? P(t) &&
                    Boolean.prototype.valueOf.call(e) ===
                      Boolean.prototype.valueOf.call(t)
                  : j(e)
                  ? j(t) &&
                    BigInt.prototype.valueOf.call(e) ===
                      BigInt.prototype.valueOf.call(t)
                  : M(t) &&
                    Symbol.prototype.valueOf.call(e) ===
                      Symbol.prototype.valueOf.call(t);
              })(e, t)
            )
              return !1;
          }
          return G(e, t, r, n, D);
        }
        function R(e, t) {
          return t.filter(function (t) {
            return h(e, t);
          });
        }
        function G(e, t, r, o, s, c) {
          if (5 === arguments.length) {
            c = Object.keys(e);
            var d = Object.keys(t);
            if (c.length !== d.length) return !1;
          }
          for (var p = 0; p < c.length; p++) if (!f(t, c[p])) return !1;
          if (r && 5 === arguments.length) {
            var m = u(e);
            if (0 !== m.length) {
              var g = 0;
              for (p = 0; p < m.length; p++) {
                var y = m[p];
                if (h(e, y)) {
                  if (!h(t, y)) return !1;
                  c.push(y), g++;
                } else if (h(t, y)) return !1;
              }
              var v = u(t);
              if (m.length !== v.length && R(t, v).length !== g) return !1;
            } else {
              var w = u(t);
              if (0 !== w.length && 0 !== R(t, w).length) return !1;
            }
          }
          if (
            0 === c.length &&
            (s === D || (s === _ && 0 === e.length) || 0 === e.size)
          )
            return !0;
          if (void 0 === o)
            o = { val1: new Map(), val2: new Map(), position: 0 };
          else {
            var b = o.val1.get(e);
            if (void 0 !== b) {
              var A = o.val2.get(t);
              if (void 0 !== A) return b === A;
            }
            o.position++;
          }
          o.val1.set(e, o.position), o.val2.set(t, o.position);
          var S = (function (e, t, r, o, s, c) {
            var u = 0;
            if (c === z) {
              if (
                !(function (e, t, r, n) {
                  for (var o = null, s = a(e), l = 0; l < s.length; l++) {
                    var c = s[l];
                    if ("object" === i(c) && null !== c)
                      null === o && (o = new Set()), o.add(c);
                    else if (!t.has(c)) {
                      if (r) return !1;
                      if (!U(e, t, c)) return !1;
                      null === o && (o = new Set()), o.add(c);
                    }
                  }
                  if (null !== o) {
                    for (var u = a(t), d = 0; d < u.length; d++) {
                      var p = u[d];
                      if ("object" === i(p) && null !== p) {
                        if (!q(o, p, r, n)) return !1;
                      } else if (!r && !e.has(p) && !q(o, p, r, n)) return !1;
                    }
                    return 0 === o.size;
                  }
                  return !0;
                })(e, t, r, s)
              )
                return !1;
            } else if (c === F) {
              if (
                !(function (e, t, r, o) {
                  for (var s = null, a = l(e), c = 0; c < a.length; c++) {
                    var u = n(a[c], 2),
                      d = u[0],
                      p = u[1];
                    if ("object" === i(d) && null !== d)
                      null === s && (s = new Set()), s.add(d);
                    else {
                      var f = t.get(d);
                      if ((void 0 === f && !t.has(d)) || !N(p, f, r, o)) {
                        if (r) return !1;
                        if (!$(e, t, d, p, o)) return !1;
                        null === s && (s = new Set()), s.add(d);
                      }
                    }
                  }
                  if (null !== s) {
                    for (var h = l(t), m = 0; m < h.length; m++) {
                      var g = n(h[m], 2),
                        y = g[0],
                        v = g[1];
                      if ("object" === i(y) && null !== y) {
                        if (!Y(s, e, y, v, r, o)) return !1;
                      } else if (
                        !(
                          r ||
                          (e.has(y) && N(e.get(y), v, !1, o)) ||
                          Y(s, e, y, v, !1, o)
                        )
                      )
                        return !1;
                    }
                    return 0 === s.size;
                  }
                  return !0;
                })(e, t, r, s)
              )
                return !1;
            } else if (c === _)
              for (; u < e.length; u++) {
                if (!f(e, u)) {
                  if (f(t, u)) return !1;
                  for (var d = Object.keys(e); u < d.length; u++) {
                    var p = d[u];
                    if (!f(t, p) || !N(e[p], t[p], r, s)) return !1;
                  }
                  return d.length === Object.keys(t).length;
                }
                if (!f(t, u) || !N(e[u], t[u], r, s)) return !1;
              }
            for (u = 0; u < o.length; u++) {
              var h = o[u];
              if (!N(e[h], t[h], r, s)) return !1;
            }
            return !0;
          })(e, t, r, c, o, s);
          return o.val1.delete(e), o.val2.delete(t), S;
        }
        function q(e, t, r, n) {
          for (var o = a(e), i = 0; i < o.length; i++) {
            var s = o[i];
            if (N(t, s, r, n)) return e.delete(s), !0;
          }
          return !1;
        }
        function V(e) {
          switch (i(e)) {
            case "undefined":
              return null;
            case "object":
              return;
            case "symbol":
              return !1;
            case "string":
              e = +e;
            case "number":
              if (d(e)) return !1;
          }
          return !0;
        }
        function U(e, t, r) {
          var n = V(r);
          return null != n ? n : t.has(n) && !e.has(n);
        }
        function $(e, t, r, n, o) {
          var i = V(r);
          if (null != i) return i;
          var s = t.get(i);
          return (
            !((void 0 === s && !t.has(i)) || !N(n, s, !1, o)) &&
            !e.has(i) &&
            N(n, s, !1, o)
          );
        }
        function Y(e, t, r, n, o, i) {
          for (var s = a(e), l = 0; l < s.length; l++) {
            var c = s[l];
            if (N(r, c, o, i) && N(n, t.get(c), o, i)) return e.delete(c), !0;
          }
          return !1;
        }
        e.exports = {
          isDeepEqual: function (e, t) {
            return N(e, t, false);
          },
          isDeepStrictEqual: function (e, t) {
            return N(e, t, true);
          },
        };
      },
      2264: (e, t, r) => {
        "use strict";
        var n = r(9718),
          o = r(2756),
          i = o(n("String.prototype.indexOf"));
        e.exports = function (e, t) {
          var r = n(e, !!t);
          return "function" == typeof r && i(e, ".prototype.") > -1 ? o(r) : r;
        };
      },
      2756: (e, t, r) => {
        "use strict";
        var n = r(9932),
          o = r(9718),
          i = r(6930),
          s = r(4114),
          a = o("%Function.prototype.apply%"),
          l = o("%Function.prototype.call%"),
          c = o("%Reflect.apply%", !0) || n.call(l, a),
          u = r(70),
          d = o("%Math.max%");
        e.exports = function (e) {
          if ("function" != typeof e) throw new s("a function is required");
          var t = c(n, l, arguments);
          return i(t, 1 + d(0, e.length - (arguments.length - 1)), !0);
        };
        var p = function () {
          return c(n, a, arguments);
        };
        u ? u(e.exports, "apply", { value: p }) : (e.exports.apply = p);
      },
      8974: (e, t, r) => {
        var n = r(6818),
          o = r(3615);
        function i() {
          return new Date().getTime();
        }
        var s,
          a = Array.prototype.slice,
          l = {};
        s =
          void 0 !== r.g && r.g.console
            ? r.g.console
            : "undefined" != typeof window && window.console
            ? window.console
            : {};
        for (
          var c = [
              [function () {}, "log"],
              [
                function () {
                  s.log.apply(s, arguments);
                },
                "info",
              ],
              [
                function () {
                  s.log.apply(s, arguments);
                },
                "warn",
              ],
              [
                function () {
                  s.warn.apply(s, arguments);
                },
                "error",
              ],
              [
                function (e) {
                  l[e] = i();
                },
                "time",
              ],
              [
                function (e) {
                  var t = l[e];
                  if (!t) throw new Error("No such label: " + e);
                  delete l[e];
                  var r = i() - t;
                  s.log(e + ": " + r + "ms");
                },
                "timeEnd",
              ],
              [
                function () {
                  var e = new Error();
                  (e.name = "Trace"),
                    (e.message = n.format.apply(null, arguments)),
                    s.error(e.stack);
                },
                "trace",
              ],
              [
                function (e) {
                  s.log(n.inspect(e) + "\n");
                },
                "dir",
              ],
              [
                function (e) {
                  if (!e) {
                    var t = a.call(arguments, 1);
                    o.ok(!1, n.format.apply(null, t));
                  }
                },
                "assert",
              ],
            ],
            u = 0;
          u < c.length;
          u++
        ) {
          var d = c[u],
            p = d[0],
            f = d[1];
          s[f] || (s[f] = p);
        }
        e.exports = s;
      },
      9089: (e) => {
        "use strict";
        e.exports = function (e) {
          var t = [];
          return (
            (t.toString = function () {
              return this.map(function (t) {
                var r = "",
                  n = void 0 !== t[5];
                return (
                  t[4] && (r += "@supports (".concat(t[4], ") {")),
                  t[2] && (r += "@media ".concat(t[2], " {")),
                  n &&
                    (r += "@layer".concat(
                      t[5].length > 0 ? " ".concat(t[5]) : "",
                      " {"
                    )),
                  (r += e(t)),
                  n && (r += "}"),
                  t[2] && (r += "}"),
                  t[4] && (r += "}"),
                  r
                );
              }).join("");
            }),
            (t.i = function (e, r, n, o, i) {
              "string" == typeof e && (e = [[null, e, void 0]]);
              var s = {};
              if (n)
                for (var a = 0; a < this.length; a++) {
                  var l = this[a][0];
                  null != l && (s[l] = !0);
                }
              for (var c = 0; c < e.length; c++) {
                var u = [].concat(e[c]);
                (n && s[u[0]]) ||
                  (void 0 !== i &&
                    (void 0 === u[5] ||
                      (u[1] = "@layer"
                        .concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {")
                        .concat(u[1], "}")),
                    (u[5] = i)),
                  r &&
                    (u[2]
                      ? ((u[1] = "@media "
                          .concat(u[2], " {")
                          .concat(u[1], "}")),
                        (u[2] = r))
                      : (u[2] = r)),
                  o &&
                    (u[4]
                      ? ((u[1] = "@supports ("
                          .concat(u[4], ") {")
                          .concat(u[1], "}")),
                        (u[4] = o))
                      : (u[4] = "".concat(o))),
                  t.push(u));
              }
            }),
            t
          );
        };
      },
      6492: (e) => {
        "use strict";
        e.exports = function (e, t) {
          return (
            t || (t = {}),
            e
              ? ((e = String(e.__esModule ? e.default : e)),
                /^['"].*['"]$/.test(e) && (e = e.slice(1, -1)),
                t.hash && (e += t.hash),
                /["'() \t\n]|(%20)/.test(e) || t.needQuotes
                  ? '"'.concat(
                      e.replace(/"/g, '\\"').replace(/\n/g, "\\n"),
                      '"'
                    )
                  : e)
              : e
          );
        };
      },
      9248: (e) => {
        "use strict";
        e.exports = function (e) {
          return e[1];
        };
      },
      1828: (e, t, r) => {
        "use strict";
        var n = r(70),
          o = r(4121),
          i = r(4114),
          s = r(7570);
        e.exports = function (e, t, r) {
          if (!e || ("object" != typeof e && "function" != typeof e))
            throw new i("`obj` must be an object or a function`");
          if ("string" != typeof t && "symbol" != typeof t)
            throw new i("`property` must be a string or a symbol`");
          if (
            arguments.length > 3 &&
            "boolean" != typeof arguments[3] &&
            null !== arguments[3]
          )
            throw new i(
              "`nonEnumerable`, if provided, must be a boolean or null"
            );
          if (
            arguments.length > 4 &&
            "boolean" != typeof arguments[4] &&
            null !== arguments[4]
          )
            throw new i(
              "`nonWritable`, if provided, must be a boolean or null"
            );
          if (
            arguments.length > 5 &&
            "boolean" != typeof arguments[5] &&
            null !== arguments[5]
          )
            throw new i(
              "`nonConfigurable`, if provided, must be a boolean or null"
            );
          if (arguments.length > 6 && "boolean" != typeof arguments[6])
            throw new i("`loose`, if provided, must be a boolean");
          var a = arguments.length > 3 ? arguments[3] : null,
            l = arguments.length > 4 ? arguments[4] : null,
            c = arguments.length > 5 ? arguments[5] : null,
            u = arguments.length > 6 && arguments[6],
            d = !!s && s(e, t);
          if (n)
            n(e, t, {
              configurable: null === c && d ? d.configurable : !c,
              enumerable: null === a && d ? d.enumerable : !a,
              value: r,
              writable: null === l && d ? d.writable : !l,
            });
          else {
            if (!u && (a || l || c))
              throw new o(
                "This environment does not support defining a property as non-configurable, non-writable, or non-enumerable."
              );
            e[t] = r;
          }
        };
      },
      5935: (e, t, r) => {
        "use strict";
        var n = r(9722),
          o = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
          i = Object.prototype.toString,
          s = Array.prototype.concat,
          a = r(1828),
          l = r(6177)(),
          c = function (e, t, r, n) {
            if (t in e)
              if (!0 === n) {
                if (e[t] === r) return;
              } else if (
                "function" != typeof (o = n) ||
                "[object Function]" !== i.call(o) ||
                !n()
              )
                return;
            var o;
            l ? a(e, t, r, !0) : a(e, t, r);
          },
          u = function (e, t) {
            var r = arguments.length > 2 ? arguments[2] : {},
              i = n(t);
            o && (i = s.call(i, Object.getOwnPropertySymbols(t)));
            for (var a = 0; a < i.length; a += 1) c(e, i[a], t[i[a]], r[i[a]]);
          };
        (u.supportsDescriptors = !!l), (e.exports = u);
      },
      70: (e, t, r) => {
        "use strict";
        var n = r(9718)("%Object.defineProperty%", !0) || !1;
        if (n)
          try {
            n({}, "a", { value: 1 });
          } catch (e) {
            n = !1;
          }
        e.exports = n;
      },
      8208: (e) => {
        "use strict";
        e.exports = EvalError;
      },
      6788: (e) => {
        "use strict";
        e.exports = Error;
      },
      5785: (e) => {
        "use strict";
        e.exports = RangeError;
      },
      7369: (e) => {
        "use strict";
        e.exports = ReferenceError;
      },
      4121: (e) => {
        "use strict";
        e.exports = SyntaxError;
      },
      4114: (e) => {
        "use strict";
        e.exports = TypeError;
      },
      9394: (e) => {
        "use strict";
        e.exports = URIError;
      },
      755: (e, t, r) => {
        "use strict";
        var n = r(403),
          o = Object.prototype.toString,
          i = Object.prototype.hasOwnProperty;
        e.exports = function (e, t, r) {
          if (!n(t)) throw new TypeError("iterator must be a function");
          var s;
          arguments.length >= 3 && (s = r),
            "[object Array]" === o.call(e)
              ? (function (e, t, r) {
                  for (var n = 0, o = e.length; n < o; n++)
                    i.call(e, n) &&
                      (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                })(e, t, s)
              : "string" == typeof e
              ? (function (e, t, r) {
                  for (var n = 0, o = e.length; n < o; n++)
                    null == r
                      ? t(e.charAt(n), n, e)
                      : t.call(r, e.charAt(n), n, e);
                })(e, t, s)
              : (function (e, t, r) {
                  for (var n in e)
                    i.call(e, n) &&
                      (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                })(e, t, s);
        };
      },
      5712: (e) => {
        "use strict";
        var t = Object.prototype.toString,
          r = Math.max,
          n = function (e, t) {
            for (var r = [], n = 0; n < e.length; n += 1) r[n] = e[n];
            for (var o = 0; o < t.length; o += 1) r[o + e.length] = t[o];
            return r;
          };
        e.exports = function (e) {
          var o = this;
          if ("function" != typeof o || "[object Function]" !== t.apply(o))
            throw new TypeError(
              "Function.prototype.bind called on incompatible " + o
            );
          for (
            var i,
              s = (function (e, t) {
                for (
                  var r = [], n = t || 0, o = 0;
                  n < e.length;
                  n += 1, o += 1
                )
                  r[o] = e[n];
                return r;
              })(arguments, 1),
              a = r(0, o.length - s.length),
              l = [],
              c = 0;
            c < a;
            c++
          )
            l[c] = "$" + c;
          if (
            ((i = Function(
              "binder",
              "return function (" +
                (function (e, t) {
                  for (var r = "", n = 0; n < e.length; n += 1)
                    (r += e[n]), n + 1 < e.length && (r += t);
                  return r;
                })(l, ",") +
                "){ return binder.apply(this,arguments); }"
            )(function () {
              if (this instanceof i) {
                var t = o.apply(this, n(s, arguments));
                return Object(t) === t ? t : this;
              }
              return o.apply(e, n(s, arguments));
            })),
            o.prototype)
          ) {
            var u = function () {};
            (u.prototype = o.prototype),
              (i.prototype = new u()),
              (u.prototype = null);
          }
          return i;
        };
      },
      9932: (e, t, r) => {
        "use strict";
        var n = r(5712);
        e.exports = Function.prototype.bind || n;
      },
      9718: (e, t, r) => {
        "use strict";
        var n,
          o = r(6788),
          i = r(8208),
          s = r(5785),
          a = r(7369),
          l = r(4121),
          c = r(4114),
          u = r(9394),
          d = Function,
          p = function (e) {
            try {
              return d('"use strict"; return (' + e + ").constructor;")();
            } catch (e) {}
          },
          f = Object.getOwnPropertyDescriptor;
        if (f)
          try {
            f({}, "");
          } catch (e) {
            f = null;
          }
        var h = function () {
            throw new c();
          },
          m = f
            ? (function () {
                try {
                  return h;
                } catch (e) {
                  try {
                    return f(arguments, "callee").get;
                  } catch (e) {
                    return h;
                  }
                }
              })()
            : h,
          g = r(1064)(),
          y = r(7411)(),
          v =
            Object.getPrototypeOf ||
            (y
              ? function (e) {
                  return e.__proto__;
                }
              : null),
          w = {},
          b = "undefined" != typeof Uint8Array && v ? v(Uint8Array) : n,
          A = {
            __proto__: null,
            "%AggregateError%":
              "undefined" == typeof AggregateError ? n : AggregateError,
            "%Array%": Array,
            "%ArrayBuffer%":
              "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
            "%ArrayIteratorPrototype%": g && v ? v([][Symbol.iterator]()) : n,
            "%AsyncFromSyncIteratorPrototype%": n,
            "%AsyncFunction%": w,
            "%AsyncGenerator%": w,
            "%AsyncGeneratorFunction%": w,
            "%AsyncIteratorPrototype%": w,
            "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
            "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
            "%BigInt64Array%":
              "undefined" == typeof BigInt64Array ? n : BigInt64Array,
            "%BigUint64Array%":
              "undefined" == typeof BigUint64Array ? n : BigUint64Array,
            "%Boolean%": Boolean,
            "%DataView%": "undefined" == typeof DataView ? n : DataView,
            "%Date%": Date,
            "%decodeURI%": decodeURI,
            "%decodeURIComponent%": decodeURIComponent,
            "%encodeURI%": encodeURI,
            "%encodeURIComponent%": encodeURIComponent,
            "%Error%": o,
            "%eval%": eval,
            "%EvalError%": i,
            "%Float32Array%":
              "undefined" == typeof Float32Array ? n : Float32Array,
            "%Float64Array%":
              "undefined" == typeof Float64Array ? n : Float64Array,
            "%FinalizationRegistry%":
              "undefined" == typeof FinalizationRegistry
                ? n
                : FinalizationRegistry,
            "%Function%": d,
            "%GeneratorFunction%": w,
            "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
            "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
            "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
            "%isFinite%": isFinite,
            "%isNaN%": isNaN,
            "%IteratorPrototype%": g && v ? v(v([][Symbol.iterator]())) : n,
            "%JSON%": "object" == typeof JSON ? JSON : n,
            "%Map%": "undefined" == typeof Map ? n : Map,
            "%MapIteratorPrototype%":
              "undefined" != typeof Map && g && v
                ? v(new Map()[Symbol.iterator]())
                : n,
            "%Math%": Math,
            "%Number%": Number,
            "%Object%": Object,
            "%parseFloat%": parseFloat,
            "%parseInt%": parseInt,
            "%Promise%": "undefined" == typeof Promise ? n : Promise,
            "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
            "%RangeError%": s,
            "%ReferenceError%": a,
            "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
            "%RegExp%": RegExp,
            "%Set%": "undefined" == typeof Set ? n : Set,
            "%SetIteratorPrototype%":
              "undefined" != typeof Set && g && v
                ? v(new Set()[Symbol.iterator]())
                : n,
            "%SharedArrayBuffer%":
              "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
            "%String%": String,
            "%StringIteratorPrototype%": g && v ? v(""[Symbol.iterator]()) : n,
            "%Symbol%": g ? Symbol : n,
            "%SyntaxError%": l,
            "%ThrowTypeError%": m,
            "%TypedArray%": b,
            "%TypeError%": c,
            "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
            "%Uint8ClampedArray%":
              "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
            "%Uint16Array%":
              "undefined" == typeof Uint16Array ? n : Uint16Array,
            "%Uint32Array%":
              "undefined" == typeof Uint32Array ? n : Uint32Array,
            "%URIError%": u,
            "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
            "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
            "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet,
          };
        if (v)
          try {
            null.error;
          } catch (e) {
            var S = v(v(e));
            A["%Error.prototype%"] = S;
          }
        var E = function e(t) {
            var r;
            if ("%AsyncFunction%" === t) r = p("async function () {}");
            else if ("%GeneratorFunction%" === t) r = p("function* () {}");
            else if ("%AsyncGeneratorFunction%" === t)
              r = p("async function* () {}");
            else if ("%AsyncGenerator%" === t) {
              var n = e("%AsyncGeneratorFunction%");
              n && (r = n.prototype);
            } else if ("%AsyncIteratorPrototype%" === t) {
              var o = e("%AsyncGenerator%");
              o && v && (r = v(o.prototype));
            }
            return (A[t] = r), r;
          },
          x = {
            __proto__: null,
            "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
            "%ArrayPrototype%": ["Array", "prototype"],
            "%ArrayProto_entries%": ["Array", "prototype", "entries"],
            "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
            "%ArrayProto_keys%": ["Array", "prototype", "keys"],
            "%ArrayProto_values%": ["Array", "prototype", "values"],
            "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
            "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
            "%AsyncGeneratorPrototype%": [
              "AsyncGeneratorFunction",
              "prototype",
              "prototype",
            ],
            "%BooleanPrototype%": ["Boolean", "prototype"],
            "%DataViewPrototype%": ["DataView", "prototype"],
            "%DatePrototype%": ["Date", "prototype"],
            "%ErrorPrototype%": ["Error", "prototype"],
            "%EvalErrorPrototype%": ["EvalError", "prototype"],
            "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
            "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
            "%FunctionPrototype%": ["Function", "prototype"],
            "%Generator%": ["GeneratorFunction", "prototype"],
            "%GeneratorPrototype%": [
              "GeneratorFunction",
              "prototype",
              "prototype",
            ],
            "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
            "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
            "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
            "%JSONParse%": ["JSON", "parse"],
            "%JSONStringify%": ["JSON", "stringify"],
            "%MapPrototype%": ["Map", "prototype"],
            "%NumberPrototype%": ["Number", "prototype"],
            "%ObjectPrototype%": ["Object", "prototype"],
            "%ObjProto_toString%": ["Object", "prototype", "toString"],
            "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
            "%PromisePrototype%": ["Promise", "prototype"],
            "%PromiseProto_then%": ["Promise", "prototype", "then"],
            "%Promise_all%": ["Promise", "all"],
            "%Promise_reject%": ["Promise", "reject"],
            "%Promise_resolve%": ["Promise", "resolve"],
            "%RangeErrorPrototype%": ["RangeError", "prototype"],
            "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
            "%RegExpPrototype%": ["RegExp", "prototype"],
            "%SetPrototype%": ["Set", "prototype"],
            "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
            "%StringPrototype%": ["String", "prototype"],
            "%SymbolPrototype%": ["Symbol", "prototype"],
            "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
            "%TypedArrayPrototype%": ["TypedArray", "prototype"],
            "%TypeErrorPrototype%": ["TypeError", "prototype"],
            "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
            "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
            "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
            "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
            "%URIErrorPrototype%": ["URIError", "prototype"],
            "%WeakMapPrototype%": ["WeakMap", "prototype"],
            "%WeakSetPrototype%": ["WeakSet", "prototype"],
          },
          T = r(9932),
          O = r(8396),
          P = T.call(Function.call, Array.prototype.concat),
          j = T.call(Function.apply, Array.prototype.splice),
          M = T.call(Function.call, String.prototype.replace),
          k = T.call(Function.call, String.prototype.slice),
          I = T.call(Function.call, RegExp.prototype.exec),
          C =
            /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
          L = /\\(\\)?/g,
          B = function (e, t) {
            var r,
              n = e;
            if ((O(x, n) && (n = "%" + (r = x[n])[0] + "%"), O(A, n))) {
              var o = A[n];
              if ((o === w && (o = E(n)), void 0 === o && !t))
                throw new c(
                  "intrinsic " +
                    e +
                    " exists, but is not available. Please file an issue!"
                );
              return { alias: r, name: n, value: o };
            }
            throw new l("intrinsic " + e + " does not exist!");
          };
        e.exports = function (e, t) {
          if ("string" != typeof e || 0 === e.length)
            throw new c("intrinsic name must be a non-empty string");
          if (arguments.length > 1 && "boolean" != typeof t)
            throw new c('"allowMissing" argument must be a boolean');
          if (null === I(/^%?[^%]*%?$/, e))
            throw new l(
              "`%` may not be present anywhere but at the beginning and end of the intrinsic name"
            );
          var r = (function (e) {
              var t = k(e, 0, 1),
                r = k(e, -1);
              if ("%" === t && "%" !== r)
                throw new l("invalid intrinsic syntax, expected closing `%`");
              if ("%" === r && "%" !== t)
                throw new l("invalid intrinsic syntax, expected opening `%`");
              var n = [];
              return (
                M(e, C, function (e, t, r, o) {
                  n[n.length] = r ? M(o, L, "$1") : t || e;
                }),
                n
              );
            })(e),
            n = r.length > 0 ? r[0] : "",
            o = B("%" + n + "%", t),
            i = o.name,
            s = o.value,
            a = !1,
            u = o.alias;
          u && ((n = u[0]), j(r, P([0, 1], u)));
          for (var d = 1, p = !0; d < r.length; d += 1) {
            var h = r[d],
              m = k(h, 0, 1),
              g = k(h, -1);
            if (
              ('"' === m ||
                "'" === m ||
                "`" === m ||
                '"' === g ||
                "'" === g ||
                "`" === g) &&
              m !== g
            )
              throw new l(
                "property names with quotes must have matching quotes"
              );
            if (
              (("constructor" !== h && p) || (a = !0),
              O(A, (i = "%" + (n += "." + h) + "%")))
            )
              s = A[i];
            else if (null != s) {
              if (!(h in s)) {
                if (!t)
                  throw new c(
                    "base intrinsic for " +
                      e +
                      " exists, but the property is not available."
                  );
                return;
              }
              if (f && d + 1 >= r.length) {
                var y = f(s, h);
                s =
                  (p = !!y) && "get" in y && !("originalValue" in y.get)
                    ? y.get
                    : s[h];
              } else (p = O(s, h)), (s = s[h]);
              p && !a && (A[i] = s);
            }
          }
          return s;
        };
      },
      7570: (e, t, r) => {
        "use strict";
        var n = r(9718)("%Object.getOwnPropertyDescriptor%", !0);
        if (n)
          try {
            n([], "length");
          } catch (e) {
            n = null;
          }
        e.exports = n;
      },
      6177: (e, t, r) => {
        "use strict";
        var n = r(70),
          o = function () {
            return !!n;
          };
        (o.hasArrayLengthDefineBug = function () {
          if (!n) return null;
          try {
            return 1 !== n([], "length", { value: 1 }).length;
          } catch (e) {
            return !0;
          }
        }),
          (e.exports = o);
      },
      7411: (e) => {
        "use strict";
        var t = { __proto__: null, foo: {} },
          r = Object;
        e.exports = function () {
          return { __proto__: t }.foo === t.foo && !(t instanceof r);
        };
      },
      1064: (e, t, r) => {
        "use strict";
        var n = "undefined" != typeof Symbol && Symbol,
          o = r(2698);
        e.exports = function () {
          return (
            "function" == typeof n &&
            "function" == typeof Symbol &&
            "symbol" == typeof n("foo") &&
            "symbol" == typeof Symbol("bar") &&
            o()
          );
        };
      },
      2698: (e) => {
        "use strict";
        e.exports = function () {
          if (
            "function" != typeof Symbol ||
            "function" != typeof Object.getOwnPropertySymbols
          )
            return !1;
          if ("symbol" == typeof Symbol.iterator) return !0;
          var e = {},
            t = Symbol("test"),
            r = Object(t);
          if ("string" == typeof t) return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(t))
            return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(r))
            return !1;
          for (t in ((e[t] = 42), e)) return !1;
          if ("function" == typeof Object.keys && 0 !== Object.keys(e).length)
            return !1;
          if (
            "function" == typeof Object.getOwnPropertyNames &&
            0 !== Object.getOwnPropertyNames(e).length
          )
            return !1;
          var n = Object.getOwnPropertySymbols(e);
          if (1 !== n.length || n[0] !== t) return !1;
          if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
          if ("function" == typeof Object.getOwnPropertyDescriptor) {
            var o = Object.getOwnPropertyDescriptor(e, t);
            if (42 !== o.value || !0 !== o.enumerable) return !1;
          }
          return !0;
        };
      },
      4903: (e, t, r) => {
        "use strict";
        var n = r(2698);
        e.exports = function () {
          return n() && !!Symbol.toStringTag;
        };
      },
      8396: (e, t, r) => {
        "use strict";
        var n = Function.prototype.call,
          o = Object.prototype.hasOwnProperty,
          i = r(9932);
        e.exports = i.call(n, o);
      },
      8365: (e) => {
        "function" == typeof Object.create
          ? (e.exports = function (e, t) {
              t &&
                ((e.super_ = t),
                (e.prototype = Object.create(t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })));
            })
          : (e.exports = function (e, t) {
              if (t) {
                e.super_ = t;
                var r = function () {};
                (r.prototype = t.prototype),
                  (e.prototype = new r()),
                  (e.prototype.constructor = e);
              }
            });
      },
      3929: (e, t, r) => {
        "use strict";
        var n = r(4903)(),
          o = r(2264)("Object.prototype.toString"),
          i = function (e) {
            return (
              !(n && e && "object" == typeof e && Symbol.toStringTag in e) &&
              "[object Arguments]" === o(e)
            );
          },
          s = function (e) {
            return (
              !!i(e) ||
              (null !== e &&
                "object" == typeof e &&
                "number" == typeof e.length &&
                e.length >= 0 &&
                "[object Array]" !== o(e) &&
                "[object Function]" === o(e.callee))
            );
          },
          a = (function () {
            return i(arguments);
          })();
        (i.isLegacyArguments = s), (e.exports = a ? i : s);
      },
      403: (e) => {
        "use strict";
        var t,
          r,
          n = Function.prototype.toString,
          o = "object" == typeof Reflect && null !== Reflect && Reflect.apply;
        if (
          "function" == typeof o &&
          "function" == typeof Object.defineProperty
        )
          try {
            (t = Object.defineProperty({}, "length", {
              get: function () {
                throw r;
              },
            })),
              (r = {}),
              o(
                function () {
                  throw 42;
                },
                null,
                t
              );
          } catch (e) {
            e !== r && (o = null);
          }
        else o = null;
        var i = /^\s*class\b/,
          s = function (e) {
            try {
              var t = n.call(e);
              return i.test(t);
            } catch (e) {
              return !1;
            }
          },
          a = function (e) {
            try {
              return !s(e) && (n.call(e), !0);
            } catch (e) {
              return !1;
            }
          },
          l = Object.prototype.toString,
          c = "function" == typeof Symbol && !!Symbol.toStringTag,
          u = !(0 in [,]),
          d = function () {
            return !1;
          };
        if ("object" == typeof document) {
          var p = document.all;
          l.call(p) === l.call(document.all) &&
            (d = function (e) {
              if ((u || !e) && (void 0 === e || "object" == typeof e))
                try {
                  var t = l.call(e);
                  return (
                    ("[object HTMLAllCollection]" === t ||
                      "[object HTML document.all class]" === t ||
                      "[object HTMLCollection]" === t ||
                      "[object Object]" === t) &&
                    null == e("")
                  );
                } catch (e) {}
              return !1;
            });
        }
        e.exports = o
          ? function (e) {
              if (d(e)) return !0;
              if (!e) return !1;
              if ("function" != typeof e && "object" != typeof e) return !1;
              try {
                o(e, null, t);
              } catch (e) {
                if (e !== r) return !1;
              }
              return !s(e) && a(e);
            }
          : function (e) {
              if (d(e)) return !0;
              if (!e) return !1;
              if ("function" != typeof e && "object" != typeof e) return !1;
              if (c) return a(e);
              if (s(e)) return !1;
              var t = l.call(e);
              return (
                !(
                  "[object Function]" !== t &&
                  "[object GeneratorFunction]" !== t &&
                  !/^\[object HTML/.test(t)
                ) && a(e)
              );
            };
      },
      2379: (e, t, r) => {
        "use strict";
        var n,
          o = Object.prototype.toString,
          i = Function.prototype.toString,
          s = /^\s*(?:function)?\*/,
          a = r(4903)(),
          l = Object.getPrototypeOf;
        e.exports = function (e) {
          if ("function" != typeof e) return !1;
          if (s.test(i.call(e))) return !0;
          if (!a) return "[object GeneratorFunction]" === o.call(e);
          if (!l) return !1;
          if (void 0 === n) {
            var t = (function () {
              if (!a) return !1;
              try {
                return Function("return function*() {}")();
              } catch (e) {}
            })();
            n = !!t && l(t);
          }
          return l(e) === n;
        };
      },
      5328: (e) => {
        "use strict";
        e.exports = function (e) {
          return e != e;
        };
      },
      9836: (e, t, r) => {
        "use strict";
        var n = r(2756),
          o = r(5935),
          i = r(5328),
          s = r(9157),
          a = r(8627),
          l = n(s(), Number);
        o(l, { getPolyfill: s, implementation: i, shim: a }), (e.exports = l);
      },
      9157: (e, t, r) => {
        "use strict";
        var n = r(5328);
        e.exports = function () {
          return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")
            ? Number.isNaN
            : n;
        };
      },
      8627: (e, t, r) => {
        "use strict";
        var n = r(5935),
          o = r(9157);
        e.exports = function () {
          var e = o();
          return (
            n(
              Number,
              { isNaN: e },
              {
                isNaN: function () {
                  return Number.isNaN !== e;
                },
              }
            ),
            e
          );
        };
      },
      1701: (e, t, r) => {
        "use strict";
        var n = r(4912);
        e.exports = function (e) {
          return !!n(e);
        };
      },
      1474: (e) => {
        "use strict";
        var t = function (e) {
          return e != e;
        };
        e.exports = function (e, r) {
          return 0 === e && 0 === r
            ? 1 / e == 1 / r
            : e === r || !(!t(e) || !t(r));
        };
      },
      3354: (e, t, r) => {
        "use strict";
        var n = r(5935),
          o = r(2756),
          i = r(1474),
          s = r(1723),
          a = r(2365),
          l = o(s(), Object);
        n(l, { getPolyfill: s, implementation: i, shim: a }), (e.exports = l);
      },
      1723: (e, t, r) => {
        "use strict";
        var n = r(1474);
        e.exports = function () {
          return "function" == typeof Object.is ? Object.is : n;
        };
      },
      2365: (e, t, r) => {
        "use strict";
        var n = r(1723),
          o = r(5935);
        e.exports = function () {
          var e = n();
          return (
            o(
              Object,
              { is: e },
              {
                is: function () {
                  return Object.is !== e;
                },
              }
            ),
            e
          );
        };
      },
      1730: (e, t, r) => {
        "use strict";
        var n;
        if (!Object.keys) {
          var o = Object.prototype.hasOwnProperty,
            i = Object.prototype.toString,
            s = r(6838),
            a = Object.prototype.propertyIsEnumerable,
            l = !a.call({ toString: null }, "toString"),
            c = a.call(function () {}, "prototype"),
            u = [
              "toString",
              "toLocaleString",
              "valueOf",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "constructor",
            ],
            d = function (e) {
              var t = e.constructor;
              return t && t.prototype === e;
            },
            p = {
              $applicationCache: !0,
              $console: !0,
              $external: !0,
              $frame: !0,
              $frameElement: !0,
              $frames: !0,
              $innerHeight: !0,
              $innerWidth: !0,
              $onmozfullscreenchange: !0,
              $onmozfullscreenerror: !0,
              $outerHeight: !0,
              $outerWidth: !0,
              $pageXOffset: !0,
              $pageYOffset: !0,
              $parent: !0,
              $scrollLeft: !0,
              $scrollTop: !0,
              $scrollX: !0,
              $scrollY: !0,
              $self: !0,
              $webkitIndexedDB: !0,
              $webkitStorageInfo: !0,
              $window: !0,
            },
            f = (function () {
              if ("undefined" == typeof window) return !1;
              for (var e in window)
                try {
                  if (
                    !p["$" + e] &&
                    o.call(window, e) &&
                    null !== window[e] &&
                    "object" == typeof window[e]
                  )
                    try {
                      d(window[e]);
                    } catch (e) {
                      return !0;
                    }
                } catch (e) {
                  return !0;
                }
              return !1;
            })();
          n = function (e) {
            var t = null !== e && "object" == typeof e,
              r = "[object Function]" === i.call(e),
              n = s(e),
              a = t && "[object String]" === i.call(e),
              p = [];
            if (!t && !r && !n)
              throw new TypeError("Object.keys called on a non-object");
            var h = c && r;
            if (a && e.length > 0 && !o.call(e, 0))
              for (var m = 0; m < e.length; ++m) p.push(String(m));
            if (n && e.length > 0)
              for (var g = 0; g < e.length; ++g) p.push(String(g));
            else
              for (var y in e)
                (h && "prototype" === y) || !o.call(e, y) || p.push(String(y));
            if (l)
              for (
                var v = (function (e) {
                    if ("undefined" == typeof window || !f) return d(e);
                    try {
                      return d(e);
                    } catch (e) {
                      return !1;
                    }
                  })(e),
                  w = 0;
                w < u.length;
                ++w
              )
                (v && "constructor" === u[w]) ||
                  !o.call(e, u[w]) ||
                  p.push(u[w]);
            return p;
          };
        }
        e.exports = n;
      },
      9722: (e, t, r) => {
        "use strict";
        var n = Array.prototype.slice,
          o = r(6838),
          i = Object.keys,
          s = i
            ? function (e) {
                return i(e);
              }
            : r(1730),
          a = Object.keys;
        (s.shim = function () {
          if (Object.keys) {
            var e = (function () {
              var e = Object.keys(arguments);
              return e && e.length === arguments.length;
            })(1, 2);
            e ||
              (Object.keys = function (e) {
                return o(e) ? a(n.call(e)) : a(e);
              });
          } else Object.keys = s;
          return Object.keys || s;
        }),
          (e.exports = s);
      },
      6838: (e) => {
        "use strict";
        var t = Object.prototype.toString;
        e.exports = function (e) {
          var r = t.call(e),
            n = "[object Arguments]" === r;
          return (
            n ||
              (n =
                "[object Array]" !== r &&
                null !== e &&
                "object" == typeof e &&
                "number" == typeof e.length &&
                e.length >= 0 &&
                "[object Function]" === t.call(e.callee)),
            n
          );
        };
      },
      2418: (e, t, r) => {
        "use strict";
        var n = r(9722),
          o = r(2698)(),
          i = r(2264),
          s = Object,
          a = i("Array.prototype.push"),
          l = i("Object.prototype.propertyIsEnumerable"),
          c = o ? Object.getOwnPropertySymbols : null;
        e.exports = function (e, t) {
          if (null == e) throw new TypeError("target must be an object");
          var r = s(e);
          if (1 === arguments.length) return r;
          for (var i = 1; i < arguments.length; ++i) {
            var u = s(arguments[i]),
              d = n(u),
              p = o && (Object.getOwnPropertySymbols || c);
            if (p)
              for (var f = p(u), h = 0; h < f.length; ++h) {
                var m = f[h];
                l(u, m) && a(d, m);
              }
            for (var g = 0; g < d.length; ++g) {
              var y = d[g];
              if (l(u, y)) {
                var v = u[y];
                r[y] = v;
              }
            }
          }
          return r;
        };
      },
      8267: (e, t, r) => {
        "use strict";
        var n = r(2418);
        e.exports = function () {
          return Object.assign
            ? (function () {
                if (!Object.assign) return !1;
                for (
                  var e = "abcdefghijklmnopqrst",
                    t = e.split(""),
                    r = {},
                    n = 0;
                  n < t.length;
                  ++n
                )
                  r[t[n]] = t[n];
                var o = Object.assign({}, r),
                  i = "";
                for (var s in o) i += s;
                return e !== i;
              })() ||
              (function () {
                if (!Object.assign || !Object.preventExtensions) return !1;
                var e = Object.preventExtensions({ 1: 2 });
                try {
                  Object.assign(e, "xy");
                } catch (t) {
                  return "y" === e[1];
                }
                return !1;
              })()
              ? n
              : Object.assign
            : n;
        };
      },
      2031: (e) => {
        "use strict";
        e.exports = [
          "Float32Array",
          "Float64Array",
          "Int8Array",
          "Int16Array",
          "Int32Array",
          "Uint8Array",
          "Uint8ClampedArray",
          "Uint16Array",
          "Uint32Array",
          "BigInt64Array",
          "BigUint64Array",
        ];
      },
      1385: (e) => {
        var t,
          r,
          n = (e.exports = {});
        function o() {
          throw new Error("setTimeout has not been defined");
        }
        function i() {
          throw new Error("clearTimeout has not been defined");
        }
        function s(e) {
          if (t === setTimeout) return setTimeout(e, 0);
          if ((t === o || !t) && setTimeout)
            return (t = setTimeout), setTimeout(e, 0);
          try {
            return t(e, 0);
          } catch (r) {
            try {
              return t.call(null, e, 0);
            } catch (r) {
              return t.call(this, e, 0);
            }
          }
        }
        !(function () {
          try {
            t = "function" == typeof setTimeout ? setTimeout : o;
          } catch (e) {
            t = o;
          }
          try {
            r = "function" == typeof clearTimeout ? clearTimeout : i;
          } catch (e) {
            r = i;
          }
        })();
        var a,
          l = [],
          c = !1,
          u = -1;
        function d() {
          c &&
            a &&
            ((c = !1),
            a.length ? (l = a.concat(l)) : (u = -1),
            l.length && p());
        }
        function p() {
          if (!c) {
            var e = s(d);
            c = !0;
            for (var t = l.length; t; ) {
              for (a = l, l = []; ++u < t; ) a && a[u].run();
              (u = -1), (t = l.length);
            }
            (a = null),
              (c = !1),
              (function (e) {
                if (r === clearTimeout) return clearTimeout(e);
                if ((r === i || !r) && clearTimeout)
                  return (r = clearTimeout), clearTimeout(e);
                try {
                  return r(e);
                } catch (t) {
                  try {
                    return r.call(null, e);
                  } catch (t) {
                    return r.call(this, e);
                  }
                }
              })(e);
          }
        }
        function f(e, t) {
          (this.fun = e), (this.array = t);
        }
        function h() {}
        (n.nextTick = function (e) {
          var t = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
          l.push(new f(e, t)), 1 !== l.length || c || s(p);
        }),
          (f.prototype.run = function () {
            this.fun.apply(null, this.array);
          }),
          (n.title = "browser"),
          (n.browser = !0),
          (n.env = {}),
          (n.argv = []),
          (n.version = ""),
          (n.versions = {}),
          (n.on = h),
          (n.addListener = h),
          (n.once = h),
          (n.off = h),
          (n.removeListener = h),
          (n.removeAllListeners = h),
          (n.emit = h),
          (n.prependListener = h),
          (n.prependOnceListener = h),
          (n.listeners = function (e) {
            return [];
          }),
          (n.binding = function (e) {
            throw new Error("process.binding is not supported");
          }),
          (n.cwd = function () {
            return "/";
          }),
          (n.chdir = function (e) {
            throw new Error("process.chdir is not supported");
          }),
          (n.umask = function () {
            return 0;
          });
      },
      6930: (e, t, r) => {
        "use strict";
        var n = r(9718),
          o = r(1828),
          i = r(6177)(),
          s = r(7570),
          a = r(4114),
          l = n("%Math.floor%");
        e.exports = function (e, t) {
          if ("function" != typeof e) throw new a("`fn` is not a function");
          if ("number" != typeof t || t < 0 || t > 4294967295 || l(t) !== t)
            throw new a("`length` must be a positive 32-bit integer");
          var r = arguments.length > 2 && !!arguments[2],
            n = !0,
            c = !0;
          if ("length" in e && s) {
            var u = s(e, "length");
            u && !u.configurable && (n = !1), u && !u.writable && (c = !1);
          }
          return (
            (n || c || !r) &&
              (i ? o(e, "length", t, !0, !0) : o(e, "length", t)),
            e
          );
        };
      },
      6098: (e) => {
        e.exports = function (e) {
          return (
            e &&
            "object" == typeof e &&
            "function" == typeof e.copy &&
            "function" == typeof e.fill &&
            "function" == typeof e.readUInt8
          );
        };
      },
      7213: (e, t, r) => {
        "use strict";
        var n = r(3929),
          o = r(2379),
          i = r(4912),
          s = r(1701);
        function a(e) {
          return e.call.bind(e);
        }
        var l = "undefined" != typeof BigInt,
          c = "undefined" != typeof Symbol,
          u = a(Object.prototype.toString),
          d = a(Number.prototype.valueOf),
          p = a(String.prototype.valueOf),
          f = a(Boolean.prototype.valueOf);
        if (l) var h = a(BigInt.prototype.valueOf);
        if (c) var m = a(Symbol.prototype.valueOf);
        function g(e, t) {
          if ("object" != typeof e) return !1;
          try {
            return t(e), !0;
          } catch (e) {
            return !1;
          }
        }
        function y(e) {
          return "[object Map]" === u(e);
        }
        function v(e) {
          return "[object Set]" === u(e);
        }
        function w(e) {
          return "[object WeakMap]" === u(e);
        }
        function b(e) {
          return "[object WeakSet]" === u(e);
        }
        function A(e) {
          return "[object ArrayBuffer]" === u(e);
        }
        function S(e) {
          return (
            "undefined" != typeof ArrayBuffer &&
            (A.working ? A(e) : e instanceof ArrayBuffer)
          );
        }
        function E(e) {
          return "[object DataView]" === u(e);
        }
        function x(e) {
          return (
            "undefined" != typeof DataView &&
            (E.working ? E(e) : e instanceof DataView)
          );
        }
        (t.isArgumentsObject = n),
          (t.isGeneratorFunction = o),
          (t.isTypedArray = s),
          (t.isPromise = function (e) {
            return (
              ("undefined" != typeof Promise && e instanceof Promise) ||
              (null !== e &&
                "object" == typeof e &&
                "function" == typeof e.then &&
                "function" == typeof e.catch)
            );
          }),
          (t.isArrayBufferView = function (e) {
            return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
              ? ArrayBuffer.isView(e)
              : s(e) || x(e);
          }),
          (t.isUint8Array = function (e) {
            return "Uint8Array" === i(e);
          }),
          (t.isUint8ClampedArray = function (e) {
            return "Uint8ClampedArray" === i(e);
          }),
          (t.isUint16Array = function (e) {
            return "Uint16Array" === i(e);
          }),
          (t.isUint32Array = function (e) {
            return "Uint32Array" === i(e);
          }),
          (t.isInt8Array = function (e) {
            return "Int8Array" === i(e);
          }),
          (t.isInt16Array = function (e) {
            return "Int16Array" === i(e);
          }),
          (t.isInt32Array = function (e) {
            return "Int32Array" === i(e);
          }),
          (t.isFloat32Array = function (e) {
            return "Float32Array" === i(e);
          }),
          (t.isFloat64Array = function (e) {
            return "Float64Array" === i(e);
          }),
          (t.isBigInt64Array = function (e) {
            return "BigInt64Array" === i(e);
          }),
          (t.isBigUint64Array = function (e) {
            return "BigUint64Array" === i(e);
          }),
          (y.working = "undefined" != typeof Map && y(new Map())),
          (t.isMap = function (e) {
            return (
              "undefined" != typeof Map && (y.working ? y(e) : e instanceof Map)
            );
          }),
          (v.working = "undefined" != typeof Set && v(new Set())),
          (t.isSet = function (e) {
            return (
              "undefined" != typeof Set && (v.working ? v(e) : e instanceof Set)
            );
          }),
          (w.working = "undefined" != typeof WeakMap && w(new WeakMap())),
          (t.isWeakMap = function (e) {
            return (
              "undefined" != typeof WeakMap &&
              (w.working ? w(e) : e instanceof WeakMap)
            );
          }),
          (b.working = "undefined" != typeof WeakSet && b(new WeakSet())),
          (t.isWeakSet = function (e) {
            return b(e);
          }),
          (A.working =
            "undefined" != typeof ArrayBuffer && A(new ArrayBuffer())),
          (t.isArrayBuffer = S),
          (E.working =
            "undefined" != typeof ArrayBuffer &&
            "undefined" != typeof DataView &&
            E(new DataView(new ArrayBuffer(1), 0, 1))),
          (t.isDataView = x);
        var T =
          "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
        function O(e) {
          return "[object SharedArrayBuffer]" === u(e);
        }
        function P(e) {
          return (
            void 0 !== T &&
            (void 0 === O.working && (O.working = O(new T())),
            O.working ? O(e) : e instanceof T)
          );
        }
        function j(e) {
          return g(e, d);
        }
        function M(e) {
          return g(e, p);
        }
        function k(e) {
          return g(e, f);
        }
        function I(e) {
          return l && g(e, h);
        }
        function C(e) {
          return c && g(e, m);
        }
        (t.isSharedArrayBuffer = P),
          (t.isAsyncFunction = function (e) {
            return "[object AsyncFunction]" === u(e);
          }),
          (t.isMapIterator = function (e) {
            return "[object Map Iterator]" === u(e);
          }),
          (t.isSetIterator = function (e) {
            return "[object Set Iterator]" === u(e);
          }),
          (t.isGeneratorObject = function (e) {
            return "[object Generator]" === u(e);
          }),
          (t.isWebAssemblyCompiledModule = function (e) {
            return "[object WebAssembly.Module]" === u(e);
          }),
          (t.isNumberObject = j),
          (t.isStringObject = M),
          (t.isBooleanObject = k),
          (t.isBigIntObject = I),
          (t.isSymbolObject = C),
          (t.isBoxedPrimitive = function (e) {
            return j(e) || M(e) || k(e) || I(e) || C(e);
          }),
          (t.isAnyArrayBuffer = function (e) {
            return "undefined" != typeof Uint8Array && (S(e) || P(e));
          }),
          ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(
            function (e) {
              Object.defineProperty(t, e, {
                enumerable: !1,
                value: function () {
                  throw new Error(e + " is not supported in userland");
                },
              });
            }
          );
      },
      6818: (e, t, r) => {
        var n = r(1385),
          o = r(8974),
          i =
            Object.getOwnPropertyDescriptors ||
            function (e) {
              for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++)
                r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
              return r;
            },
          s = /%[sdj%]/g;
        (t.format = function (e) {
          if (!b(e)) {
            for (var t = [], r = 0; r < arguments.length; r++)
              t.push(u(arguments[r]));
            return t.join(" ");
          }
          r = 1;
          for (
            var n = arguments,
              o = n.length,
              i = String(e).replace(s, function (e) {
                if ("%%" === e) return "%";
                if (r >= o) return e;
                switch (e) {
                  case "%s":
                    return String(n[r++]);
                  case "%d":
                    return Number(n[r++]);
                  case "%j":
                    try {
                      return JSON.stringify(n[r++]);
                    } catch (e) {
                      return "[Circular]";
                    }
                  default:
                    return e;
                }
              }),
              a = n[r];
            r < o;
            a = n[++r]
          )
            v(a) || !E(a) ? (i += " " + a) : (i += " " + u(a));
          return i;
        }),
          (t.deprecate = function (e, r) {
            if (void 0 !== n && !0 === n.noDeprecation) return e;
            if (void 0 === n)
              return function () {
                return t.deprecate(e, r).apply(this, arguments);
              };
            var i = !1;
            return function () {
              if (!i) {
                if (n.throwDeprecation) throw new Error(r);
                n.traceDeprecation ? o.trace(r) : o.error(r), (i = !0);
              }
              return e.apply(this, arguments);
            };
          });
        var a = {},
          l = /^$/;
        if (n.env.NODE_DEBUG) {
          var c = n.env.NODE_DEBUG;
          (c = c
            .replace(/[|\\{}()[\]^$+?.]/g, "\\$&")
            .replace(/\*/g, ".*")
            .replace(/,/g, "$|^")
            .toUpperCase()),
            (l = new RegExp("^" + c + "$", "i"));
        }
        function u(e, r) {
          var n = { seen: [], stylize: p };
          return (
            arguments.length >= 3 && (n.depth = arguments[2]),
            arguments.length >= 4 && (n.colors = arguments[3]),
            y(r) ? (n.showHidden = r) : r && t._extend(n, r),
            A(n.showHidden) && (n.showHidden = !1),
            A(n.depth) && (n.depth = 2),
            A(n.colors) && (n.colors = !1),
            A(n.customInspect) && (n.customInspect = !0),
            n.colors && (n.stylize = d),
            f(n, e, n.depth)
          );
        }
        function d(e, t) {
          var r = u.styles[t];
          return r
            ? "[" + u.colors[r][0] + "m" + e + "[" + u.colors[r][1] + "m"
            : e;
        }
        function p(e, t) {
          return e;
        }
        function f(e, r, n) {
          if (
            e.customInspect &&
            r &&
            O(r.inspect) &&
            r.inspect !== t.inspect &&
            (!r.constructor || r.constructor.prototype !== r)
          ) {
            var o = r.inspect(n, e);
            return b(o) || (o = f(e, o, n)), o;
          }
          var i = (function (e, t) {
            if (A(t)) return e.stylize("undefined", "undefined");
            if (b(t)) {
              var r =
                "'" +
                JSON.stringify(t)
                  .replace(/^"|"$/g, "")
                  .replace(/'/g, "\\'")
                  .replace(/\\"/g, '"') +
                "'";
              return e.stylize(r, "string");
            }
            if (w(t)) return e.stylize("" + t, "number");
            if (y(t)) return e.stylize("" + t, "boolean");
            if (v(t)) return e.stylize("null", "null");
          })(e, r);
          if (i) return i;
          var s = Object.keys(r),
            a = (function (e) {
              var t = {};
              return (
                e.forEach(function (e, r) {
                  t[e] = !0;
                }),
                t
              );
            })(s);
          if (
            (e.showHidden && (s = Object.getOwnPropertyNames(r)),
            T(r) &&
              (s.indexOf("message") >= 0 || s.indexOf("description") >= 0))
          )
            return h(r);
          if (0 === s.length) {
            if (O(r)) {
              var l = r.name ? ": " + r.name : "";
              return e.stylize("[Function" + l + "]", "special");
            }
            if (S(r))
              return e.stylize(RegExp.prototype.toString.call(r), "regexp");
            if (x(r)) return e.stylize(Date.prototype.toString.call(r), "date");
            if (T(r)) return h(r);
          }
          var c,
            u = "",
            d = !1,
            p = ["{", "}"];
          (g(r) && ((d = !0), (p = ["[", "]"])), O(r)) &&
            (u = " [Function" + (r.name ? ": " + r.name : "") + "]");
          return (
            S(r) && (u = " " + RegExp.prototype.toString.call(r)),
            x(r) && (u = " " + Date.prototype.toUTCString.call(r)),
            T(r) && (u = " " + h(r)),
            0 !== s.length || (d && 0 != r.length)
              ? n < 0
                ? S(r)
                  ? e.stylize(RegExp.prototype.toString.call(r), "regexp")
                  : e.stylize("[Object]", "special")
                : (e.seen.push(r),
                  (c = d
                    ? (function (e, t, r, n, o) {
                        for (var i = [], s = 0, a = t.length; s < a; ++s)
                          k(t, String(s))
                            ? i.push(m(e, t, r, n, String(s), !0))
                            : i.push("");
                        return (
                          o.forEach(function (o) {
                            o.match(/^\d+$/) || i.push(m(e, t, r, n, o, !0));
                          }),
                          i
                        );
                      })(e, r, n, a, s)
                    : s.map(function (t) {
                        return m(e, r, n, a, t, d);
                      })),
                  e.seen.pop(),
                  (function (e, t, r) {
                    var n = e.reduce(function (e, t) {
                      return (
                        t.indexOf("\n") >= 0 && 0,
                        e + t.replace(/\u001b\[\d\d?m/g, "").length + 1
                      );
                    }, 0);
                    if (n > 60)
                      return (
                        r[0] +
                        ("" === t ? "" : t + "\n ") +
                        " " +
                        e.join(",\n  ") +
                        " " +
                        r[1]
                      );
                    return r[0] + t + " " + e.join(", ") + " " + r[1];
                  })(c, u, p))
              : p[0] + u + p[1]
          );
        }
        function h(e) {
          return "[" + Error.prototype.toString.call(e) + "]";
        }
        function m(e, t, r, n, o, i) {
          var s, a, l;
          if (
            ((l = Object.getOwnPropertyDescriptor(t, o) || { value: t[o] }).get
              ? (a = l.set
                  ? e.stylize("[Getter/Setter]", "special")
                  : e.stylize("[Getter]", "special"))
              : l.set && (a = e.stylize("[Setter]", "special")),
            k(n, o) || (s = "[" + o + "]"),
            a ||
              (e.seen.indexOf(l.value) < 0
                ? (a = v(r)
                    ? f(e, l.value, null)
                    : f(e, l.value, r - 1)).indexOf("\n") > -1 &&
                  (a = i
                    ? a
                        .split("\n")
                        .map(function (e) {
                          return "  " + e;
                        })
                        .join("\n")
                        .slice(2)
                    : "\n" +
                      a
                        .split("\n")
                        .map(function (e) {
                          return "   " + e;
                        })
                        .join("\n"))
                : (a = e.stylize("[Circular]", "special"))),
            A(s))
          ) {
            if (i && o.match(/^\d+$/)) return a;
            (s = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)
              ? ((s = s.slice(1, -1)), (s = e.stylize(s, "name")))
              : ((s = s
                  .replace(/'/g, "\\'")
                  .replace(/\\"/g, '"')
                  .replace(/(^"|"$)/g, "'")),
                (s = e.stylize(s, "string")));
          }
          return s + ": " + a;
        }
        function g(e) {
          return Array.isArray(e);
        }
        function y(e) {
          return "boolean" == typeof e;
        }
        function v(e) {
          return null === e;
        }
        function w(e) {
          return "number" == typeof e;
        }
        function b(e) {
          return "string" == typeof e;
        }
        function A(e) {
          return void 0 === e;
        }
        function S(e) {
          return E(e) && "[object RegExp]" === P(e);
        }
        function E(e) {
          return "object" == typeof e && null !== e;
        }
        function x(e) {
          return E(e) && "[object Date]" === P(e);
        }
        function T(e) {
          return E(e) && ("[object Error]" === P(e) || e instanceof Error);
        }
        function O(e) {
          return "function" == typeof e;
        }
        function P(e) {
          return Object.prototype.toString.call(e);
        }
        function j(e) {
          return e < 10 ? "0" + e.toString(10) : e.toString(10);
        }
        (t.debuglog = function (e) {
          if (((e = e.toUpperCase()), !a[e]))
            if (l.test(e)) {
              var r = n.pid;
              a[e] = function () {
                var n = t.format.apply(t, arguments);
                o.error("%s %d: %s", e, r, n);
              };
            } else a[e] = function () {};
          return a[e];
        }),
          (t.inspect = u),
          (u.colors = {
            bold: [1, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            white: [37, 39],
            grey: [90, 39],
            black: [30, 39],
            blue: [34, 39],
            cyan: [36, 39],
            green: [32, 39],
            magenta: [35, 39],
            red: [31, 39],
            yellow: [33, 39],
          }),
          (u.styles = {
            special: "cyan",
            number: "yellow",
            boolean: "yellow",
            undefined: "grey",
            null: "bold",
            string: "green",
            date: "magenta",
            regexp: "red",
          }),
          (t.types = r(7213)),
          (t.isArray = g),
          (t.isBoolean = y),
          (t.isNull = v),
          (t.isNullOrUndefined = function (e) {
            return null == e;
          }),
          (t.isNumber = w),
          (t.isString = b),
          (t.isSymbol = function (e) {
            return "symbol" == typeof e;
          }),
          (t.isUndefined = A),
          (t.isRegExp = S),
          (t.types.isRegExp = S),
          (t.isObject = E),
          (t.isDate = x),
          (t.types.isDate = x),
          (t.isError = T),
          (t.types.isNativeError = T),
          (t.isFunction = O),
          (t.isPrimitive = function (e) {
            return (
              null === e ||
              "boolean" == typeof e ||
              "number" == typeof e ||
              "string" == typeof e ||
              "symbol" == typeof e ||
              void 0 === e
            );
          }),
          (t.isBuffer = r(6098));
        var M = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        function k(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
        (t.log = function () {
          var e, r;
          o.log(
            "%s - %s",
            ((e = new Date()),
            (r = [j(e.getHours()), j(e.getMinutes()), j(e.getSeconds())].join(
              ":"
            )),
            [e.getDate(), M[e.getMonth()], r].join(" ")),
            t.format.apply(t, arguments)
          );
        }),
          (t.inherits = r(8365)),
          (t._extend = function (e, t) {
            if (!t || !E(t)) return e;
            for (var r = Object.keys(t), n = r.length; n--; ) e[r[n]] = t[r[n]];
            return e;
          });
        var I =
          "undefined" != typeof Symbol
            ? Symbol("util.promisify.custom")
            : void 0;
        function C(e, t) {
          if (!e) {
            var r = new Error("Promise was rejected with a falsy value");
            (r.reason = e), (e = r);
          }
          return t(e);
        }
        (t.promisify = function (e) {
          if ("function" != typeof e)
            throw new TypeError(
              'The "original" argument must be of type Function'
            );
          if (I && e[I]) {
            var t;
            if ("function" != typeof (t = e[I]))
              throw new TypeError(
                'The "util.promisify.custom" argument must be of type Function'
              );
            return (
              Object.defineProperty(t, I, {
                value: t,
                enumerable: !1,
                writable: !1,
                configurable: !0,
              }),
              t
            );
          }
          function t() {
            for (
              var t,
                r,
                n = new Promise(function (e, n) {
                  (t = e), (r = n);
                }),
                o = [],
                i = 0;
              i < arguments.length;
              i++
            )
              o.push(arguments[i]);
            o.push(function (e, n) {
              e ? r(e) : t(n);
            });
            try {
              e.apply(this, o);
            } catch (e) {
              r(e);
            }
            return n;
          }
          return (
            Object.setPrototypeOf(t, Object.getPrototypeOf(e)),
            I &&
              Object.defineProperty(t, I, {
                value: t,
                enumerable: !1,
                writable: !1,
                configurable: !0,
              }),
            Object.defineProperties(t, i(e))
          );
        }),
          (t.promisify.custom = I),
          (t.callbackify = function (e) {
            if ("function" != typeof e)
              throw new TypeError(
                'The "original" argument must be of type Function'
              );
            function t() {
              for (var t = [], r = 0; r < arguments.length; r++)
                t.push(arguments[r]);
              var o = t.pop();
              if ("function" != typeof o)
                throw new TypeError(
                  "The last argument must be of type Function"
                );
              var i = this,
                s = function () {
                  return o.apply(i, arguments);
                };
              e.apply(this, t).then(
                function (e) {
                  n.nextTick(s.bind(null, null, e));
                },
                function (e) {
                  n.nextTick(C.bind(null, e, s));
                }
              );
            }
            return (
              Object.setPrototypeOf(t, Object.getPrototypeOf(e)),
              Object.defineProperties(t, i(e)),
              t
            );
          });
      },
      4912: (e, t, r) => {
        "use strict";
        var n = r(755),
          o = r(750),
          i = r(2756),
          s = r(2264),
          a = r(7570),
          l = s("Object.prototype.toString"),
          c = r(4903)(),
          u = "undefined" == typeof globalThis ? r.g : globalThis,
          d = o(),
          p = s("String.prototype.slice"),
          f = Object.getPrototypeOf,
          h =
            s("Array.prototype.indexOf", !0) ||
            function (e, t) {
              for (var r = 0; r < e.length; r += 1) if (e[r] === t) return r;
              return -1;
            },
          m = { __proto__: null };
        n(
          d,
          c && a && f
            ? function (e) {
                var t = new u[e]();
                if (Symbol.toStringTag in t) {
                  var r = f(t),
                    n = a(r, Symbol.toStringTag);
                  if (!n) {
                    var o = f(r);
                    n = a(o, Symbol.toStringTag);
                  }
                  m["$" + e] = i(n.get);
                }
              }
            : function (e) {
                var t = new u[e](),
                  r = t.slice || t.set;
                r && (m["$" + e] = i(r));
              }
        );
        e.exports = function (e) {
          if (!e || "object" != typeof e) return !1;
          if (!c) {
            var t = p(l(e), 8, -1);
            return h(d, t) > -1
              ? t
              : "Object" === t &&
                  (function (e) {
                    var t = !1;
                    return (
                      n(m, function (r, n) {
                        if (!t)
                          try {
                            r(e), (t = p(n, 1));
                          } catch (e) {}
                      }),
                      t
                    );
                  })(e);
          }
          return a
            ? (function (e) {
                var t = !1;
                return (
                  n(m, function (r, n) {
                    if (!t)
                      try {
                        "$" + r(e) === n && (t = p(n, 1));
                      } catch (e) {}
                  }),
                  t
                );
              })(e)
            : null;
        };
      },
      3052: () => {
        document.querySelector(".option-selector__content") &&
          document.addEventListener("click", (e) => {
            const t = document.querySelector(
              ".price__current[data-default-price]"
            );
            e.target.classList.contains("gift-card-price") &&
              (t.textContent = e.target.textContent);
          });
      },
      2870: (e, t, r) => {
        "use strict";
        r.d(t, { A: () => p });
        var n = r(9248),
          o = r.n(n),
          i = r(9089),
          s = r.n(i),
          a = r(6492),
          l = r.n(a),
          c = new URL(r(6085), r.b),
          u = s()(o()),
          d = l()(c);
        u.push([
          e.id,
          `/**\n * Swiper 11.2.2\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2025 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: January 31, 2025\n */\n\n/* FONT_START */\n@font-face {\n  font-family: 'swiper-icons';\n  src: url(${d});\n  font-weight: 400;\n  font-style: normal;\n}\n/* FONT_END */\n:root {\n  --swiper-theme-color: #007aff;\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  --swiper-wrapper-transition-timing-function: initial;\n  */\n}\n:host {\n  position: relative;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1;\n}\n.swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n  display: block;\n}\n.swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);\n  box-sizing: content-box;\n}\n.swiper-android .swiper-slide,\n.swiper-ios .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-horizontal {\n  touch-action: pan-y;\n}\n.swiper-vertical {\n  touch-action: pan-x;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n  display: block;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-autoheight,\n.swiper-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n.swiper-backface-hidden .swiper-slide {\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* 3D Effects */\n.swiper-3d.swiper-css-mode .swiper-wrapper {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-wrapper {\n  transform-style: preserve-3d;\n}\n.swiper-3d {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-slide,\n.swiper-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n/* CSS Mode */\n.swiper-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-css-mode.swiper-horizontal > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-css-mode.swiper-vertical > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper {\n  scroll-snap-type: none;\n}\n.swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: none;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper::before {\n  content: '';\n  flex-shrink: 0;\n  order: 9999;\n}\n.swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: center center;\n  scroll-snap-stop: always;\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {\n  margin-inline-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before {\n  height: 100%;\n  min-height: 1px;\n  width: var(--swiper-centered-offset-after);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {\n  margin-block-start: var(--swiper-centered-offset-before);\n}\n.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before {\n  width: 100%;\n  min-width: 1px;\n  height: var(--swiper-centered-offset-after);\n}\n/* Slide styles start */\n/* 3D Shadows */\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-3d .swiper-slide-shadow {\n  background: rgba(0, 0, 0, 0.15);\n}\n.swiper-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,\n.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {\n  animation: swiper-preloader-spin 1s infinite linear;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* Slide styles end */\n`,
          "",
        ]);
        const p = u;
      },
      5072: (e) => {
        "use strict";
        var t = [];
        function r(e) {
          for (var r = -1, n = 0; n < t.length; n++)
            if (t[n].identifier === e) {
              r = n;
              break;
            }
          return r;
        }
        function n(e, n) {
          for (var i = {}, s = [], a = 0; a < e.length; a++) {
            var l = e[a],
              c = n.base ? l[0] + n.base : l[0],
              u = i[c] || 0,
              d = "".concat(c, " ").concat(u);
            i[c] = u + 1;
            var p = r(d),
              f = {
                css: l[1],
                media: l[2],
                sourceMap: l[3],
                supports: l[4],
                layer: l[5],
              };
            if (-1 !== p) t[p].references++, t[p].updater(f);
            else {
              var h = o(f, n);
              (n.byIndex = a),
                t.splice(a, 0, { identifier: d, updater: h, references: 1 });
            }
            s.push(d);
          }
          return s;
        }
        function o(e, t) {
          var r = t.domAPI(t);
          r.update(e);
          return function (t) {
            if (t) {
              if (
                t.css === e.css &&
                t.media === e.media &&
                t.sourceMap === e.sourceMap &&
                t.supports === e.supports &&
                t.layer === e.layer
              )
                return;
              r.update((e = t));
            } else r.remove();
          };
        }
        e.exports = function (e, o) {
          var i = n((e = e || []), (o = o || {}));
          return function (e) {
            e = e || [];
            for (var s = 0; s < i.length; s++) {
              var a = r(i[s]);
              t[a].references--;
            }
            for (var l = n(e, o), c = 0; c < i.length; c++) {
              var u = r(i[c]);
              0 === t[u].references && (t[u].updater(), t.splice(u, 1));
            }
            i = l;
          };
        };
      },
      7659: (e) => {
        "use strict";
        var t = {};
        e.exports = function (e, r) {
          var n = (function (e) {
            if (void 0 === t[e]) {
              var r = document.querySelector(e);
              if (
                window.HTMLIFrameElement &&
                r instanceof window.HTMLIFrameElement
              )
                try {
                  r = r.contentDocument.head;
                } catch (e) {
                  r = null;
                }
              t[e] = r;
            }
            return t[e];
          })(e);
          if (!n)
            throw new Error(
              "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
            );
          n.appendChild(r);
        };
      },
      540: (e) => {
        "use strict";
        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      5056: (e, t, r) => {
        "use strict";
        e.exports = function (e) {
          var t = r.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      7825: (e) => {
        "use strict";
        e.exports = function (e) {
          if ("undefined" == typeof document)
            return { update: function () {}, remove: function () {} };
          var t = e.insertStyleElement(e);
          return {
            update: function (r) {
              !(function (e, t, r) {
                var n = "";
                r.supports && (n += "@supports (".concat(r.supports, ") {")),
                  r.media && (n += "@media ".concat(r.media, " {"));
                var o = void 0 !== r.layer;
                o &&
                  (n += "@layer".concat(
                    r.layer.length > 0 ? " ".concat(r.layer) : "",
                    " {"
                  )),
                  (n += r.css),
                  o && (n += "}"),
                  r.media && (n += "}"),
                  r.supports && (n += "}");
                var i = r.sourceMap;
                i &&
                  "undefined" != typeof btoa &&
                  (n +=
                    "\n/*# sourceMappingURL=data:application/json;base64,".concat(
                      btoa(unescape(encodeURIComponent(JSON.stringify(i)))),
                      " */"
                    )),
                  t.styleTagTransform(n, e, t.options);
              })(t, e, r);
            },
            remove: function () {
              !(function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              })(t);
            },
          };
        };
      },
      1113: (e) => {
        "use strict";
        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;
          else {
            for (; t.firstChild; ) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(e));
          }
        };
      },
      6085: (e) => {
        "use strict";
        e.exports =
          "data:application/font-woff;charset=utf-8;base64, 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";
      },
      750: (e, t, r) => {
        "use strict";
        var n = r(2031),
          o = "undefined" == typeof globalThis ? r.g : globalThis;
        e.exports = function () {
          for (var e = [], t = 0; t < n.length; t++)
            "function" == typeof o[n[t]] && (e[e.length] = n[t]);
          return e;
        };
      },
    },
    t = {};
  function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var i = (t[n] = { id: n, exports: {} });
    return e[n](i, i.exports, r), i.exports;
  }
  (r.m = e),
    (r.n = (e) => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return r.d(t, { a: t }), t;
    }),
    (r.d = (e, t) => {
      for (var n in t)
        r.o(t, n) &&
          !r.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (r.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (r.b = document.baseURI || self.location.href),
    (r.nc = void 0),
    (() => {
      "use strict";
      const e = (e) => {
        const t = parseFloat(e) / 100;
        if (isNaN(t)) throw new Error("Invalid price format");
        {
          const e = t % 1 != 0;
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: e ? 2 : 0,
            maximumFractionDigits: e ? 2 : 0,
          }).format(t);
        }
      };
      class t extends HTMLElement {
        constructor() {
          super(),
            (this.product = {
              variants: window.productData?.variants,
              options: window.productData?.options,
            }),
            (this.sectionId = this.getAttribute("section-id")),
            this.querySelectorAll("[data-zoom-image]").forEach((e) => {
              e.addEventListener("click", (e) =>
                this.handleZoomImageClick(e, "open")
              );
            }),
            document
              .getElementById("mediaZoomModal")
              ?.addEventListener("click", (e) =>
                this.handleZoomImageClick(e, "close")
              ),
            (this.productDetailsHandler = (e) => {
              const t = this.querySelector(`[${e}]`);
              if (t) {
                const e = t.querySelector(".product-details__header"),
                  r = t.querySelector(".product-details__content"),
                  n = e.querySelector("[data-plus-button]"),
                  o = e.querySelector("[data-minus-button]");
                e &&
                  r &&
                  e.addEventListener("click", () => {
                    r.classList.contains("disp-flx-imp")
                      ? (r.classList.remove("disp-flx-imp"),
                        n?.classList.remove("disp-none-imp"),
                        o?.classList.add("disp-none-imp"))
                      : (r.classList.add("disp-flx-imp"),
                        n?.classList.add("disp-none-imp"),
                        o?.classList.remove("disp-none-imp"));
                  });
              }
            });
        }
        connectedCallback() {
          document.addEventListener("DOMContentLoaded", () => {
            this.initializeOptionSelectors(),
              this.watchScroll(),
              this.setTitleForColorSwatches(),
              this.initializeProductDetailsToggle(),
              this.initializeSizeInfoToggle();
            const e = localStorage.getItem("cameFromLink"),
              t = localStorage.getItem("selectedSize");
            if (e && t) {
              const e = this.querySelector(`input[type="radio"][value="${t}"]`);
              e &&
                (setTimeout(function () {
                  (e.checked = !1), e.click();
                }, 300),
                setTimeout(function () {
                  (e.checked = !1), e.click();
                }, 600),
                setTimeout(function () {
                  (e.checked = !1), e.click();
                }, 1e3)),
                localStorage.removeItem("cameFromLink");
            }
          }),
            document.addEventListener(
              "variant:change",
              this.handleVariantChange.bind(this)
            );
        }
        watchScroll() {
          let e = 212;
          const t = document.querySelector("[data-sticky-content-container]");
          window.addEventListener("scroll", () => {
            const r = document
                .querySelector(".product-column-right")
                .getBoundingClientRect(),
              n = window.innerHeight;
            if (t) {
              const o = t.offsetHeight,
                i = r.top - o + n,
                s = window.pageYOffset || document.documentElement.scrollTop;
              if (s > e)
                window.pageYOffset >= i && o > n
                  ? (t.style.top = n - o - 59 + "px")
                  : window.pageYOffset >= i && (t.style.top = "59px");
              else if (window.pageYOffset < r.top) t.style.top = "212px";
              else {
                const r = Math.min(212, parseInt(t.style.top) + (e - s));
                t.style.top = `${r}px`;
              }
              e = s <= 0 ? 0 : s;
            }
          });
        }
        initializeOptionSelectors() {
          this.querySelectorAll(".js-option").forEach((e) => {
            e.addEventListener("change", this.handleOptionChange.bind(this));
          });
        }
        handleOptionChange() {
          const e = Array.from(this.querySelectorAll(".js-option:checked")).map(
              (e) => {
                const t = e.name.split("-option")[0].split("-").slice(-1)[0];
                return {
                  name: t.charAt(0).toUpperCase() + t.slice(1),
                  value: e.value,
                };
              }
            ),
            t = e.find((e) => "size" === e.name.toLowerCase());
          t && localStorage.setItem("selectedSize", t.value);
          const r = this.querySelectorAll(".gsw-prg-item--link");
          r &&
            r.forEach(function (e) {
              e.addEventListener("click", function (t) {
                t.preventDefault(),
                  localStorage.setItem("cameFromLink", "true");
                const r = e.getAttribute("href");
                setTimeout(() => {
                  window.location.href = r;
                }, 100);
              });
            });
          const n = this.findVariant(e),
            o = e.find((e) => "color" === e.name.toLowerCase()).value;
          n && this.updateProduct(n, o);
        }
        handleVariantChange(e) {
          const t = e.detail.variant,
            r = t.options.find((e) => "color" === e.toLowerCase());
          this.updateProduct(t, r);
        }
        handleZoomImageClick(e, t) {
          e.preventDefault();
          const r = document.getElementById("mediaZoomModal"),
            n = document.querySelector(".section-header"),
            o = document.getElementById("zoomImage");
          switch (t) {
            case "open":
              const t = e.target.closest("[data-zoom-image]").dataset.zoomImage,
                i = (() => {
                  let e = parseInt(document.documentElement.clientWidth);
                  return parseInt(window.innerWidth) - e;
                })();
              n.classList.add("under-modal"),
                (o.src = t),
                r.classList.add("open"),
                (document.body.style.overflow = "hidden"),
                (document.body.style.paddingRight = `${i}px`);
              break;
            case "close":
              n.classList.remove("under-modal"),
                r.classList.remove("open"),
                (o.src = ""),
                (document.body.style.overflow = null),
                (document.body.style.paddingRight = "0");
          }
        }
        findVariant(e) {
          const t = this.product.variants?.find((t) =>
            e.every((e) => {
              const r = this.product.options.indexOf(e.name);
              return t.options[r] === e.value;
            })
          );
          return t;
        }
        updateProduct(e, t) {
          this.updateProductPrice(e.price, e.compare_at_price),
            this.updateProductAvailability(e.available),
            this.updateSelectedVariantLayout(t);
        }
        updateProductPrice(t, r) {
          const n = document
              .querySelector("body")
              .dataset.currencySymbol.trim(),
            o = this.querySelector(".price__current-container"),
            i = o.querySelector("[data-default-price]"),
            s = o.querySelector("[data-price-crossed-out]"),
            a = o.querySelector("[data-price-sale]"),
            l = s && a && null !== r && null !== t && t !== r;
          (i && null === r) || (i && t === r)
            ? ((i.innerHTML = `${n}${e(t)}`),
              i.classList.remove("disp-none-imp"),
              s.classList.add("disp-none-imp"),
              a.classList.add("disp-none-imp"))
            : l &&
              ((s.innerHTML = `${n}${e(r)}`),
              (a.innerHTML = `${n}${e(t)}`),
              i.classList.add("disp-none-imp"),
              s.classList.remove("disp-none-imp"),
              a.classList.remove("disp-none-imp"));
        }
        updateProductAvailability(e) {
          const t = this.querySelector(".product-availability");
          t && (t.textContent = e ? "In Stock" : "Out of Stock");
        }
        updateSelectedVariantLayout(e) {
          const t = e.toLowerCase(),
            r = "product-media-collage--active";
          this.querySelectorAll(`[data-color-images-wrapper].${r}`).forEach(
            (e) => {
              if (e.dataset.colorImagesWrapper !== t) {
                e.classList.remove(r);
                const n = this.querySelectorAll(
                  `[data-color-images-wrapper="${t}"]`
                );
                n.length > 0 &&
                  n.forEach((e) => {
                    e.classList.add(r);
                  });
              }
            }
          );
        }
        updateRecommendedProducts(e) {
          const t = e.toLowerCase(),
            r = "recommendations-grid--active";
          this.querySelectorAll(
            ".product-recommendations [data-rec-products]"
          ).forEach((e) => {
            const n = e.dataset.recProductsColor.toLowerCase();
            n !== t && e.classList.contains(r)
              ? e.classList.remove(r)
              : n === t && e.classList.add(r);
          });
        }
        setTitleForColorSwatches() {
          const e = this.querySelectorAll(".opt-label--swatch");
          e &&
            e.forEach((e) => {
              const t = e.dataset.swatch.toUpperCase();
              e.setAttribute("title", t);
            });
        }
        initializeProductDetailsToggle() {
          this.productDetailsHandler("data-product-details");
        }
        initializeSizeInfoToggle() {
          this.productDetailsHandler("data-product-size-and-info");
        }
      }
      function n(e) {
        return (
          null !== e &&
          "object" == typeof e &&
          "constructor" in e &&
          e.constructor === Object
        );
      }
      function o(e, t) {
        void 0 === e && (e = {}),
          void 0 === t && (t = {}),
          Object.keys(t).forEach((r) => {
            void 0 === e[r]
              ? (e[r] = t[r])
              : n(t[r]) &&
                n(e[r]) &&
                Object.keys(t[r]).length > 0 &&
                o(e[r], t[r]);
          });
      }
      const i = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: "" },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() {} }),
        createElement: () => ({
          children: [],
          childNodes: [],
          style: {},
          setAttribute() {},
          getElementsByTagName: () => [],
        }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
      };
      function s() {
        const e = "undefined" != typeof document ? document : {};
        return o(e, i), e;
      }
      const a = {
        document: i,
        navigator: { userAgent: "" },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle: () => ({ getPropertyValue: () => "" }),
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia: () => ({}),
        requestAnimationFrame: (e) =>
          "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
        cancelAnimationFrame(e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function l() {
        const e = "undefined" != typeof window ? window : {};
        return o(e, a), e;
      }
      var c = r(8974);
      function u(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t);
      }
      function d() {
        return Date.now();
      }
      function p(e, t) {
        void 0 === t && (t = "x");
        const r = l();
        let n, o, i;
        const s = (function (e) {
          const t = l();
          let r;
          return (
            t.getComputedStyle && (r = t.getComputedStyle(e, null)),
            !r && e.currentStyle && (r = e.currentStyle),
            r || (r = e.style),
            r
          );
        })(e);
        return (
          r.WebKitCSSMatrix
            ? ((o = s.transform || s.webkitTransform),
              o.split(",").length > 6 &&
                (o = o
                  .split(", ")
                  .map((e) => e.replace(",", "."))
                  .join(", ")),
              (i = new r.WebKitCSSMatrix("none" === o ? "" : o)))
            : ((i =
                s.MozTransform ||
                s.OTransform ||
                s.MsTransform ||
                s.msTransform ||
                s.transform ||
                s
                  .getPropertyValue("transform")
                  .replace("translate(", "matrix(1, 0, 0, 1,")),
              (n = i.toString().split(","))),
          "x" === t &&
            (o = r.WebKitCSSMatrix
              ? i.m41
              : 16 === n.length
              ? parseFloat(n[12])
              : parseFloat(n[4])),
          "y" === t &&
            (o = r.WebKitCSSMatrix
              ? i.m42
              : 16 === n.length
              ? parseFloat(n[13])
              : parseFloat(n[5])),
          o || 0
        );
      }
      function f(e) {
        return (
          "object" == typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function h() {
        const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
          t = ["__proto__", "constructor", "prototype"];
        for (let n = 1; n < arguments.length; n += 1) {
          const o = n < 0 || arguments.length <= n ? void 0 : arguments[n];
          if (
            null != o &&
            ((r = o),
            !("undefined" != typeof window && void 0 !== window.HTMLElement
              ? r instanceof HTMLElement
              : r && (1 === r.nodeType || 11 === r.nodeType)))
          ) {
            const r = Object.keys(Object(o)).filter((e) => t.indexOf(e) < 0);
            for (let t = 0, n = r.length; t < n; t += 1) {
              const n = r[t],
                i = Object.getOwnPropertyDescriptor(o, n);
              void 0 !== i &&
                i.enumerable &&
                (f(e[n]) && f(o[n])
                  ? o[n].__swiper__
                    ? (e[n] = o[n])
                    : h(e[n], o[n])
                  : !f(e[n]) && f(o[n])
                  ? ((e[n] = {}),
                    o[n].__swiper__ ? (e[n] = o[n]) : h(e[n], o[n]))
                  : (e[n] = o[n]));
            }
          }
        }
        var r;
        return e;
      }
      function m(e, t, r) {
        e.style.setProperty(t, r);
      }
      function g(e) {
        let { swiper: t, targetPosition: r, side: n } = e;
        const o = l(),
          i = -t.translate;
        let s,
          a = null;
        const c = t.params.speed;
        (t.wrapperEl.style.scrollSnapType = "none"),
          o.cancelAnimationFrame(t.cssModeFrameID);
        const u = r > i ? "next" : "prev",
          d = (e, t) => ("next" === u && e >= t) || ("prev" === u && e <= t),
          p = () => {
            (s = new Date().getTime()), null === a && (a = s);
            const e = Math.max(Math.min((s - a) / c, 1), 0),
              l = 0.5 - Math.cos(e * Math.PI) / 2;
            let u = i + l * (r - i);
            if ((d(u, r) && (u = r), t.wrapperEl.scrollTo({ [n]: u }), d(u, r)))
              return (
                (t.wrapperEl.style.overflow = "hidden"),
                (t.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (t.wrapperEl.style.overflow = ""),
                    t.wrapperEl.scrollTo({ [n]: u });
                }),
                void o.cancelAnimationFrame(t.cssModeFrameID)
              );
            t.cssModeFrameID = o.requestAnimationFrame(p);
          };
        p();
      }
      function y(e, t) {
        void 0 === t && (t = "");
        const r = l(),
          n = [...e.children];
        return (
          r.HTMLSlotElement &&
            e instanceof HTMLSlotElement &&
            n.push(...e.assignedElements()),
          t ? n.filter((e) => e.matches(t)) : n
        );
      }
      function v(e) {
        try {
          return void c.warn(e);
        } catch (e) {}
      }
      function w(e, t) {
        void 0 === t && (t = []);
        const r = document.createElement(e);
        return (
          r.classList.add(
            ...(Array.isArray(t)
              ? t
              : (function (e) {
                  return (
                    void 0 === e && (e = ""),
                    e
                      .trim()
                      .split(" ")
                      .filter((e) => !!e.trim())
                  );
                })(t))
          ),
          r
        );
      }
      function b(e, t) {
        return l().getComputedStyle(e, null).getPropertyValue(t);
      }
      function A(e) {
        let t,
          r = e;
        if (r) {
          for (t = 0; null !== (r = r.previousSibling); )
            1 === r.nodeType && (t += 1);
          return t;
        }
      }
      function S(e, t, r) {
        const n = l();
        return r
          ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
              parseFloat(
                n
                  .getComputedStyle(e, null)
                  .getPropertyValue(
                    "width" === t ? "margin-right" : "margin-top"
                  )
              ) +
              parseFloat(
                n
                  .getComputedStyle(e, null)
                  .getPropertyValue(
                    "width" === t ? "margin-left" : "margin-bottom"
                  )
              )
          : e.offsetWidth;
      }
      function E(e) {
        return (Array.isArray(e) ? e : [e]).filter((e) => !!e);
      }
      let x, T, O;
      function P() {
        return (
          x ||
            (x = (function () {
              const e = l(),
                t = s();
              return {
                smoothScroll:
                  t.documentElement &&
                  t.documentElement.style &&
                  "scrollBehavior" in t.documentElement.style,
                touch: !!(
                  "ontouchstart" in e ||
                  (e.DocumentTouch && t instanceof e.DocumentTouch)
                ),
              };
            })()),
          x
        );
      }
      function j(e) {
        return (
          void 0 === e && (e = {}),
          T ||
            (T = (function (e) {
              let { userAgent: t } = void 0 === e ? {} : e;
              const r = P(),
                n = l(),
                o = n.navigator.platform,
                i = t || n.navigator.userAgent,
                s = { ios: !1, android: !1 },
                a = n.screen.width,
                c = n.screen.height,
                u = i.match(/(Android);?[\s\/]+([\d.]+)?/);
              let d = i.match(/(iPad).*OS\s([\d_]+)/);
              const p = i.match(/(iPod)(.*OS\s([\d_]+))?/),
                f = !d && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                h = "Win32" === o;
              let m = "MacIntel" === o;
              return (
                !d &&
                  m &&
                  r.touch &&
                  [
                    "1024x1366",
                    "1366x1024",
                    "834x1194",
                    "1194x834",
                    "834x1112",
                    "1112x834",
                    "768x1024",
                    "1024x768",
                    "820x1180",
                    "1180x820",
                    "810x1080",
                    "1080x810",
                  ].indexOf(`${a}x${c}`) >= 0 &&
                  ((d = i.match(/(Version)\/([\d.]+)/)),
                  d || (d = [0, 1, "13_0_0"]),
                  (m = !1)),
                u && !h && ((s.os = "android"), (s.android = !0)),
                (d || f || p) && ((s.os = "ios"), (s.ios = !0)),
                s
              );
            })(e)),
          T
        );
      }
      function M() {
        return (
          O ||
            (O = (function () {
              const e = l(),
                t = j();
              let r = !1;
              function n() {
                const t = e.navigator.userAgent.toLowerCase();
                return (
                  t.indexOf("safari") >= 0 &&
                  t.indexOf("chrome") < 0 &&
                  t.indexOf("android") < 0
                );
              }
              if (n()) {
                const t = String(e.navigator.userAgent);
                if (t.includes("Version/")) {
                  const [e, n] = t
                    .split("Version/")[1]
                    .split(" ")[0]
                    .split(".")
                    .map((e) => Number(e));
                  r = e < 16 || (16 === e && n < 2);
                }
              }
              const o = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                  e.navigator.userAgent
                ),
                i = n();
              return {
                isSafari: r || i,
                needPerspectiveFix: r,
                need3dFix: i || (o && t.ios),
                isWebView: o,
              };
            })()),
          O
        );
      }
      var k = {
        on(e, t, r) {
          const n = this;
          if (!n.eventsListeners || n.destroyed) return n;
          if ("function" != typeof t) return n;
          const o = r ? "unshift" : "push";
          return (
            e.split(" ").forEach((e) => {
              n.eventsListeners[e] || (n.eventsListeners[e] = []),
                n.eventsListeners[e][o](t);
            }),
            n
          );
        },
        once(e, t, r) {
          const n = this;
          if (!n.eventsListeners || n.destroyed) return n;
          if ("function" != typeof t) return n;
          function o() {
            n.off(e, o), o.__emitterProxy && delete o.__emitterProxy;
            for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
              i[s] = arguments[s];
            t.apply(n, i);
          }
          return (o.__emitterProxy = t), n.on(e, o, r);
        },
        onAny(e, t) {
          const r = this;
          if (!r.eventsListeners || r.destroyed) return r;
          if ("function" != typeof e) return r;
          const n = t ? "unshift" : "push";
          return (
            r.eventsAnyListeners.indexOf(e) < 0 && r.eventsAnyListeners[n](e), r
          );
        },
        offAny(e) {
          const t = this;
          if (!t.eventsListeners || t.destroyed) return t;
          if (!t.eventsAnyListeners) return t;
          const r = t.eventsAnyListeners.indexOf(e);
          return r >= 0 && t.eventsAnyListeners.splice(r, 1), t;
        },
        off(e, t) {
          const r = this;
          return !r.eventsListeners || r.destroyed
            ? r
            : r.eventsListeners
            ? (e.split(" ").forEach((e) => {
                void 0 === t
                  ? (r.eventsListeners[e] = [])
                  : r.eventsListeners[e] &&
                    r.eventsListeners[e].forEach((n, o) => {
                      (n === t ||
                        (n.__emitterProxy && n.__emitterProxy === t)) &&
                        r.eventsListeners[e].splice(o, 1);
                    });
              }),
              r)
            : r;
        },
        emit() {
          const e = this;
          if (!e.eventsListeners || e.destroyed) return e;
          if (!e.eventsListeners) return e;
          let t, r, n;
          for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
            i[s] = arguments[s];
          "string" == typeof i[0] || Array.isArray(i[0])
            ? ((t = i[0]), (r = i.slice(1, i.length)), (n = e))
            : ((t = i[0].events), (r = i[0].data), (n = i[0].context || e)),
            r.unshift(n);
          return (
            (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
              e.eventsAnyListeners &&
                e.eventsAnyListeners.length &&
                e.eventsAnyListeners.forEach((e) => {
                  e.apply(n, [t, ...r]);
                }),
                e.eventsListeners &&
                  e.eventsListeners[t] &&
                  e.eventsListeners[t].forEach((e) => {
                    e.apply(n, r);
                  });
            }),
            e
          );
        },
      };
      const I = (e, t, r) => {
        t && !e.classList.contains(r)
          ? e.classList.add(r)
          : !t && e.classList.contains(r) && e.classList.remove(r);
      };
      const C = (e, t, r) => {
        t && !e.classList.contains(r)
          ? e.classList.add(r)
          : !t && e.classList.contains(r) && e.classList.remove(r);
      };
      const L = (e, t) => {
          if (!e || e.destroyed || !e.params) return;
          const r = t.closest(
            e.isElement ? "swiper-slide" : `.${e.params.slideClass}`
          );
          if (r) {
            let t = r.querySelector(`.${e.params.lazyPreloaderClass}`);
            !t &&
              e.isElement &&
              (r.shadowRoot
                ? (t = r.shadowRoot.querySelector(
                    `.${e.params.lazyPreloaderClass}`
                  ))
                : requestAnimationFrame(() => {
                    r.shadowRoot &&
                      ((t = r.shadowRoot.querySelector(
                        `.${e.params.lazyPreloaderClass}`
                      )),
                      t && t.remove());
                  })),
              t && t.remove();
          }
        },
        B = (e, t) => {
          if (!e.slides[t]) return;
          const r = e.slides[t].querySelector('[loading="lazy"]');
          r && r.removeAttribute("loading");
        },
        D = (e) => {
          if (!e || e.destroyed || !e.params) return;
          let t = e.params.lazyPreloadPrevNext;
          const r = e.slides.length;
          if (!r || !t || t < 0) return;
          t = Math.min(t, r);
          const n =
              "auto" === e.params.slidesPerView
                ? e.slidesPerViewDynamic()
                : Math.ceil(e.params.slidesPerView),
            o = e.activeIndex;
          if (e.params.grid && e.params.grid.rows > 1) {
            const r = o,
              i = [r - t];
            return (
              i.push(...Array.from({ length: t }).map((e, t) => r + n + t)),
              void e.slides.forEach((t, r) => {
                i.includes(t.column) && B(e, r);
              })
            );
          }
          const i = o + n - 1;
          if (e.params.rewind || e.params.loop)
            for (let n = o - t; n <= i + t; n += 1) {
              const t = ((n % r) + r) % r;
              (t < o || t > i) && B(e, t);
            }
          else
            for (
              let n = Math.max(o - t, 0);
              n <= Math.min(i + t, r - 1);
              n += 1
            )
              n !== o && (n > i || n < o) && B(e, n);
        };
      var _ = {
        updateSize: function () {
          const e = this;
          let t, r;
          const n = e.el;
          (t =
            void 0 !== e.params.width && null !== e.params.width
              ? e.params.width
              : n.clientWidth),
            (r =
              void 0 !== e.params.height && null !== e.params.height
                ? e.params.height
                : n.clientHeight),
            (0 === t && e.isHorizontal()) ||
              (0 === r && e.isVertical()) ||
              ((t =
                t -
                parseInt(b(n, "padding-left") || 0, 10) -
                parseInt(b(n, "padding-right") || 0, 10)),
              (r =
                r -
                parseInt(b(n, "padding-top") || 0, 10) -
                parseInt(b(n, "padding-bottom") || 0, 10)),
              Number.isNaN(t) && (t = 0),
              Number.isNaN(r) && (r = 0),
              Object.assign(e, {
                width: t,
                height: r,
                size: e.isHorizontal() ? t : r,
              }));
        },
        updateSlides: function () {
          const e = this;
          function t(t, r) {
            return parseFloat(t.getPropertyValue(e.getDirectionLabel(r)) || 0);
          }
          const r = e.params,
            {
              wrapperEl: n,
              slidesEl: o,
              size: i,
              rtlTranslate: s,
              wrongRTL: a,
            } = e,
            l = e.virtual && r.virtual.enabled,
            c = l ? e.virtual.slides.length : e.slides.length,
            u = y(o, `.${e.params.slideClass}, swiper-slide`),
            d = l ? e.virtual.slides.length : u.length;
          let p = [];
          const f = [],
            h = [];
          let g = r.slidesOffsetBefore;
          "function" == typeof g && (g = r.slidesOffsetBefore.call(e));
          let v = r.slidesOffsetAfter;
          "function" == typeof v && (v = r.slidesOffsetAfter.call(e));
          const w = e.snapGrid.length,
            A = e.slidesGrid.length;
          let E = r.spaceBetween,
            x = -g,
            T = 0,
            O = 0;
          if (void 0 === i) return;
          "string" == typeof E && E.indexOf("%") >= 0
            ? (E = (parseFloat(E.replace("%", "")) / 100) * i)
            : "string" == typeof E && (E = parseFloat(E)),
            (e.virtualSize = -E),
            u.forEach((e) => {
              s ? (e.style.marginLeft = "") : (e.style.marginRight = ""),
                (e.style.marginBottom = ""),
                (e.style.marginTop = "");
            }),
            r.centeredSlides &&
              r.cssMode &&
              (m(n, "--swiper-centered-offset-before", ""),
              m(n, "--swiper-centered-offset-after", ""));
          const P = r.grid && r.grid.rows > 1 && e.grid;
          let j;
          P ? e.grid.initSlides(u) : e.grid && e.grid.unsetSlides();
          const M =
            "auto" === r.slidesPerView &&
            r.breakpoints &&
            Object.keys(r.breakpoints).filter(
              (e) => void 0 !== r.breakpoints[e].slidesPerView
            ).length > 0;
          for (let n = 0; n < d; n += 1) {
            let o;
            if (
              ((j = 0),
              u[n] && (o = u[n]),
              P && e.grid.updateSlide(n, o, u),
              !u[n] || "none" !== b(o, "display"))
            ) {
              if ("auto" === r.slidesPerView) {
                M && (u[n].style[e.getDirectionLabel("width")] = "");
                const i = getComputedStyle(o),
                  s = o.style.transform,
                  a = o.style.webkitTransform;
                if (
                  (s && (o.style.transform = "none"),
                  a && (o.style.webkitTransform = "none"),
                  r.roundLengths)
                )
                  j = e.isHorizontal() ? S(o, "width", !0) : S(o, "height", !0);
                else {
                  const e = t(i, "width"),
                    r = t(i, "padding-left"),
                    n = t(i, "padding-right"),
                    s = t(i, "margin-left"),
                    a = t(i, "margin-right"),
                    l = i.getPropertyValue("box-sizing");
                  if (l && "border-box" === l) j = e + s + a;
                  else {
                    const { clientWidth: t, offsetWidth: i } = o;
                    j = e + r + n + s + a + (i - t);
                  }
                }
                s && (o.style.transform = s),
                  a && (o.style.webkitTransform = a),
                  r.roundLengths && (j = Math.floor(j));
              } else
                (j = (i - (r.slidesPerView - 1) * E) / r.slidesPerView),
                  r.roundLengths && (j = Math.floor(j)),
                  u[n] && (u[n].style[e.getDirectionLabel("width")] = `${j}px`);
              u[n] && (u[n].swiperSlideSize = j),
                h.push(j),
                r.centeredSlides
                  ? ((x = x + j / 2 + T / 2 + E),
                    0 === T && 0 !== n && (x = x - i / 2 - E),
                    0 === n && (x = x - i / 2 - E),
                    Math.abs(x) < 0.001 && (x = 0),
                    r.roundLengths && (x = Math.floor(x)),
                    O % r.slidesPerGroup == 0 && p.push(x),
                    f.push(x))
                  : (r.roundLengths && (x = Math.floor(x)),
                    (O - Math.min(e.params.slidesPerGroupSkip, O)) %
                      e.params.slidesPerGroup ==
                      0 && p.push(x),
                    f.push(x),
                    (x = x + j + E)),
                (e.virtualSize += j + E),
                (T = j),
                (O += 1);
            }
          }
          if (
            ((e.virtualSize = Math.max(e.virtualSize, i) + v),
            s &&
              a &&
              ("slide" === r.effect || "coverflow" === r.effect) &&
              (n.style.width = `${e.virtualSize + E}px`),
            r.setWrapperSize &&
              (n.style[e.getDirectionLabel("width")] = `${
                e.virtualSize + E
              }px`),
            P && e.grid.updateWrapperSize(j, p),
            !r.centeredSlides)
          ) {
            const t = [];
            for (let n = 0; n < p.length; n += 1) {
              let o = p[n];
              r.roundLengths && (o = Math.floor(o)),
                p[n] <= e.virtualSize - i && t.push(o);
            }
            (p = t),
              Math.floor(e.virtualSize - i) - Math.floor(p[p.length - 1]) > 1 &&
                p.push(e.virtualSize - i);
          }
          if (l && r.loop) {
            const t = h[0] + E;
            if (r.slidesPerGroup > 1) {
              const n = Math.ceil(
                  (e.virtual.slidesBefore + e.virtual.slidesAfter) /
                    r.slidesPerGroup
                ),
                o = t * r.slidesPerGroup;
              for (let e = 0; e < n; e += 1) p.push(p[p.length - 1] + o);
            }
            for (
              let n = 0;
              n < e.virtual.slidesBefore + e.virtual.slidesAfter;
              n += 1
            )
              1 === r.slidesPerGroup && p.push(p[p.length - 1] + t),
                f.push(f[f.length - 1] + t),
                (e.virtualSize += t);
          }
          if ((0 === p.length && (p = [0]), 0 !== E)) {
            const t =
              e.isHorizontal() && s
                ? "marginLeft"
                : e.getDirectionLabel("marginRight");
            u.filter(
              (e, t) => !(r.cssMode && !r.loop) || t !== u.length - 1
            ).forEach((e) => {
              e.style[t] = `${E}px`;
            });
          }
          if (r.centeredSlides && r.centeredSlidesBounds) {
            let e = 0;
            h.forEach((t) => {
              e += t + (E || 0);
            }),
              (e -= E);
            const t = e > i ? e - i : 0;
            p = p.map((e) => (e <= 0 ? -g : e > t ? t + v : e));
          }
          if (r.centerInsufficientSlides) {
            let e = 0;
            h.forEach((t) => {
              e += t + (E || 0);
            }),
              (e -= E);
            const t = (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0);
            if (e + t < i) {
              const r = (i - e - t) / 2;
              p.forEach((e, t) => {
                p[t] = e - r;
              }),
                f.forEach((e, t) => {
                  f[t] = e + r;
                });
            }
          }
          if (
            (Object.assign(e, {
              slides: u,
              snapGrid: p,
              slidesGrid: f,
              slidesSizesGrid: h,
            }),
            r.centeredSlides && r.cssMode && !r.centeredSlidesBounds)
          ) {
            m(n, "--swiper-centered-offset-before", -p[0] + "px"),
              m(
                n,
                "--swiper-centered-offset-after",
                e.size / 2 - h[h.length - 1] / 2 + "px"
              );
            const t = -e.snapGrid[0],
              r = -e.slidesGrid[0];
            (e.snapGrid = e.snapGrid.map((e) => e + t)),
              (e.slidesGrid = e.slidesGrid.map((e) => e + r));
          }
          if (
            (d !== c && e.emit("slidesLengthChange"),
            p.length !== w &&
              (e.params.watchOverflow && e.checkOverflow(),
              e.emit("snapGridLengthChange")),
            f.length !== A && e.emit("slidesGridLengthChange"),
            r.watchSlidesProgress && e.updateSlidesOffset(),
            e.emit("slidesUpdated"),
            !(l || r.cssMode || ("slide" !== r.effect && "fade" !== r.effect)))
          ) {
            const t = `${r.containerModifierClass}backface-hidden`,
              n = e.el.classList.contains(t);
            d <= r.maxBackfaceHiddenSlides
              ? n || e.el.classList.add(t)
              : n && e.el.classList.remove(t);
          }
        },
        updateAutoHeight: function (e) {
          const t = this,
            r = [],
            n = t.virtual && t.params.virtual.enabled;
          let o,
            i = 0;
          "number" == typeof e
            ? t.setTransition(e)
            : !0 === e && t.setTransition(t.params.speed);
          const s = (e) =>
            n ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
          if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
            if (t.params.centeredSlides)
              (t.visibleSlides || []).forEach((e) => {
                r.push(e);
              });
            else
              for (o = 0; o < Math.ceil(t.params.slidesPerView); o += 1) {
                const e = t.activeIndex + o;
                if (e > t.slides.length && !n) break;
                r.push(s(e));
              }
          else r.push(s(t.activeIndex));
          for (o = 0; o < r.length; o += 1)
            if (void 0 !== r[o]) {
              const e = r[o].offsetHeight;
              i = e > i ? e : i;
            }
          (i || 0 === i) && (t.wrapperEl.style.height = `${i}px`);
        },
        updateSlidesOffset: function () {
          const e = this,
            t = e.slides,
            r = e.isElement
              ? e.isHorizontal()
                ? e.wrapperEl.offsetLeft
                : e.wrapperEl.offsetTop
              : 0;
          for (let n = 0; n < t.length; n += 1)
            t[n].swiperSlideOffset =
              (e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop) -
              r -
              e.cssOverflowAdjustment();
        },
        updateSlidesProgress: function (e) {
          void 0 === e && (e = (this && this.translate) || 0);
          const t = this,
            r = t.params,
            { slides: n, rtlTranslate: o, snapGrid: i } = t;
          if (0 === n.length) return;
          void 0 === n[0].swiperSlideOffset && t.updateSlidesOffset();
          let s = -e;
          o && (s = e), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
          let a = r.spaceBetween;
          "string" == typeof a && a.indexOf("%") >= 0
            ? (a = (parseFloat(a.replace("%", "")) / 100) * t.size)
            : "string" == typeof a && (a = parseFloat(a));
          for (let e = 0; e < n.length; e += 1) {
            const l = n[e];
            let c = l.swiperSlideOffset;
            r.cssMode && r.centeredSlides && (c -= n[0].swiperSlideOffset);
            const u =
                (s + (r.centeredSlides ? t.minTranslate() : 0) - c) /
                (l.swiperSlideSize + a),
              d =
                (s - i[0] + (r.centeredSlides ? t.minTranslate() : 0) - c) /
                (l.swiperSlideSize + a),
              p = -(s - c),
              f = p + t.slidesSizesGrid[e],
              h = p >= 0 && p <= t.size - t.slidesSizesGrid[e],
              m =
                (p >= 0 && p < t.size - 1) ||
                (f > 1 && f <= t.size) ||
                (p <= 0 && f >= t.size);
            m && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(e)),
              I(l, m, r.slideVisibleClass),
              I(l, h, r.slideFullyVisibleClass),
              (l.progress = o ? -u : u),
              (l.originalProgress = o ? -d : d);
          }
        },
        updateProgress: function (e) {
          const t = this;
          if (void 0 === e) {
            const r = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * r) || 0;
          }
          const r = t.params,
            n = t.maxTranslate() - t.minTranslate();
          let { progress: o, isBeginning: i, isEnd: s, progressLoop: a } = t;
          const l = i,
            c = s;
          if (0 === n) (o = 0), (i = !0), (s = !0);
          else {
            o = (e - t.minTranslate()) / n;
            const r = Math.abs(e - t.minTranslate()) < 1,
              a = Math.abs(e - t.maxTranslate()) < 1;
            (i = r || o <= 0), (s = a || o >= 1), r && (o = 0), a && (o = 1);
          }
          if (r.loop) {
            const r = t.getSlideIndexByData(0),
              n = t.getSlideIndexByData(t.slides.length - 1),
              o = t.slidesGrid[r],
              i = t.slidesGrid[n],
              s = t.slidesGrid[t.slidesGrid.length - 1],
              l = Math.abs(e);
            (a = l >= o ? (l - o) / s : (l + s - i) / s), a > 1 && (a -= 1);
          }
          Object.assign(t, {
            progress: o,
            progressLoop: a,
            isBeginning: i,
            isEnd: s,
          }),
            (r.watchSlidesProgress || (r.centeredSlides && r.autoHeight)) &&
              t.updateSlidesProgress(e),
            i && !l && t.emit("reachBeginning toEdge"),
            s && !c && t.emit("reachEnd toEdge"),
            ((l && !i) || (c && !s)) && t.emit("fromEdge"),
            t.emit("progress", o);
        },
        updateSlidesClasses: function () {
          const e = this,
            { slides: t, params: r, slidesEl: n, activeIndex: o } = e,
            i = e.virtual && r.virtual.enabled,
            s = e.grid && r.grid && r.grid.rows > 1,
            a = (e) => y(n, `.${r.slideClass}${e}, swiper-slide${e}`)[0];
          let l, c, u;
          if (i)
            if (r.loop) {
              let t = o - e.virtual.slidesBefore;
              t < 0 && (t = e.virtual.slides.length + t),
                t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
                (l = a(`[data-swiper-slide-index="${t}"]`));
            } else l = a(`[data-swiper-slide-index="${o}"]`);
          else
            s
              ? ((l = t.find((e) => e.column === o)),
                (u = t.find((e) => e.column === o + 1)),
                (c = t.find((e) => e.column === o - 1)))
              : (l = t[o]);
          l &&
            (s ||
              ((u = (function (e, t) {
                const r = [];
                for (; e.nextElementSibling; ) {
                  const n = e.nextElementSibling;
                  t ? n.matches(t) && r.push(n) : r.push(n), (e = n);
                }
                return r;
              })(l, `.${r.slideClass}, swiper-slide`)[0]),
              r.loop && !u && (u = t[0]),
              (c = (function (e, t) {
                const r = [];
                for (; e.previousElementSibling; ) {
                  const n = e.previousElementSibling;
                  t ? n.matches(t) && r.push(n) : r.push(n), (e = n);
                }
                return r;
              })(l, `.${r.slideClass}, swiper-slide`)[0]),
              r.loop && 0 === !c && (c = t[t.length - 1]))),
            t.forEach((e) => {
              C(e, e === l, r.slideActiveClass),
                C(e, e === u, r.slideNextClass),
                C(e, e === c, r.slidePrevClass);
            }),
            e.emitSlidesClasses();
        },
        updateActiveIndex: function (e) {
          const t = this,
            r = t.rtlTranslate ? t.translate : -t.translate,
            {
              snapGrid: n,
              params: o,
              activeIndex: i,
              realIndex: s,
              snapIndex: a,
            } = t;
          let l,
            c = e;
          const u = (e) => {
            let r = e - t.virtual.slidesBefore;
            return (
              r < 0 && (r = t.virtual.slides.length + r),
              r >= t.virtual.slides.length && (r -= t.virtual.slides.length),
              r
            );
          };
          if (
            (void 0 === c &&
              (c = (function (e) {
                const { slidesGrid: t, params: r } = e,
                  n = e.rtlTranslate ? e.translate : -e.translate;
                let o;
                for (let e = 0; e < t.length; e += 1)
                  void 0 !== t[e + 1]
                    ? n >= t[e] && n < t[e + 1] - (t[e + 1] - t[e]) / 2
                      ? (o = e)
                      : n >= t[e] && n < t[e + 1] && (o = e + 1)
                    : n >= t[e] && (o = e);
                return (
                  r.normalizeSlideIndex && (o < 0 || void 0 === o) && (o = 0), o
                );
              })(t)),
            n.indexOf(r) >= 0)
          )
            l = n.indexOf(r);
          else {
            const e = Math.min(o.slidesPerGroupSkip, c);
            l = e + Math.floor((c - e) / o.slidesPerGroup);
          }
          if ((l >= n.length && (l = n.length - 1), c === i && !t.params.loop))
            return void (
              l !== a && ((t.snapIndex = l), t.emit("snapIndexChange"))
            );
          if (c === i && t.params.loop && t.virtual && t.params.virtual.enabled)
            return void (t.realIndex = u(c));
          const d = t.grid && o.grid && o.grid.rows > 1;
          let p;
          if (t.virtual && o.virtual.enabled && o.loop) p = u(c);
          else if (d) {
            const e = t.slides.find((e) => e.column === c);
            let r = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
            Number.isNaN(r) && (r = Math.max(t.slides.indexOf(e), 0)),
              (p = Math.floor(r / o.grid.rows));
          } else if (t.slides[c]) {
            const e = t.slides[c].getAttribute("data-swiper-slide-index");
            p = e ? parseInt(e, 10) : c;
          } else p = c;
          Object.assign(t, {
            previousSnapIndex: a,
            snapIndex: l,
            previousRealIndex: s,
            realIndex: p,
            previousIndex: i,
            activeIndex: c,
          }),
            t.initialized && D(t),
            t.emit("activeIndexChange"),
            t.emit("snapIndexChange"),
            (t.initialized || t.params.runCallbacksOnInit) &&
              (s !== p && t.emit("realIndexChange"), t.emit("slideChange"));
        },
        updateClickedSlide: function (e, t) {
          const r = this,
            n = r.params;
          let o = e.closest(`.${n.slideClass}, swiper-slide`);
          !o &&
            r.isElement &&
            t &&
            t.length > 1 &&
            t.includes(e) &&
            [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
              !o &&
                e.matches &&
                e.matches(`.${n.slideClass}, swiper-slide`) &&
                (o = e);
            });
          let i,
            s = !1;
          if (o)
            for (let e = 0; e < r.slides.length; e += 1)
              if (r.slides[e] === o) {
                (s = !0), (i = e);
                break;
              }
          if (!o || !s)
            return (r.clickedSlide = void 0), void (r.clickedIndex = void 0);
          (r.clickedSlide = o),
            r.virtual && r.params.virtual.enabled
              ? (r.clickedIndex = parseInt(
                  o.getAttribute("data-swiper-slide-index"),
                  10
                ))
              : (r.clickedIndex = i),
            n.slideToClickedSlide &&
              void 0 !== r.clickedIndex &&
              r.clickedIndex !== r.activeIndex &&
              r.slideToClickedSlide();
        },
      };
      var z = {
        getTranslate: function (e) {
          void 0 === e && (e = this.isHorizontal() ? "x" : "y");
          const {
            params: t,
            rtlTranslate: r,
            translate: n,
            wrapperEl: o,
          } = this;
          if (t.virtualTranslate) return r ? -n : n;
          if (t.cssMode) return n;
          let i = p(o, e);
          return (i += this.cssOverflowAdjustment()), r && (i = -i), i || 0;
        },
        setTranslate: function (e, t) {
          const r = this,
            { rtlTranslate: n, params: o, wrapperEl: i, progress: s } = r;
          let a,
            l = 0,
            c = 0;
          r.isHorizontal() ? (l = n ? -e : e) : (c = e),
            o.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
            (r.previousTranslate = r.translate),
            (r.translate = r.isHorizontal() ? l : c),
            o.cssMode
              ? (i[r.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                  r.isHorizontal() ? -l : -c)
              : o.virtualTranslate ||
                (r.isHorizontal()
                  ? (l -= r.cssOverflowAdjustment())
                  : (c -= r.cssOverflowAdjustment()),
                (i.style.transform = `translate3d(${l}px, ${c}px, 0px)`));
          const u = r.maxTranslate() - r.minTranslate();
          (a = 0 === u ? 0 : (e - r.minTranslate()) / u),
            a !== s && r.updateProgress(e),
            r.emit("setTranslate", r.translate, t);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e, t, r, n, o) {
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === r && (r = !0),
            void 0 === n && (n = !0);
          const i = this,
            { params: s, wrapperEl: a } = i;
          if (i.animating && s.preventInteractionOnTransition) return !1;
          const l = i.minTranslate(),
            c = i.maxTranslate();
          let u;
          if (
            ((u = n && e > l ? l : n && e < c ? c : e),
            i.updateProgress(u),
            s.cssMode)
          ) {
            const e = i.isHorizontal();
            if (0 === t) a[e ? "scrollLeft" : "scrollTop"] = -u;
            else {
              if (!i.support.smoothScroll)
                return (
                  g({
                    swiper: i,
                    targetPosition: -u,
                    side: e ? "left" : "top",
                  }),
                  !0
                );
              a.scrollTo({ [e ? "left" : "top"]: -u, behavior: "smooth" });
            }
            return !0;
          }
          return (
            0 === t
              ? (i.setTransition(0),
                i.setTranslate(u),
                r &&
                  (i.emit("beforeTransitionStart", t, o),
                  i.emit("transitionEnd")))
              : (i.setTransition(t),
                i.setTranslate(u),
                r &&
                  (i.emit("beforeTransitionStart", t, o),
                  i.emit("transitionStart")),
                i.animating ||
                  ((i.animating = !0),
                  i.onTranslateToWrapperTransitionEnd ||
                    (i.onTranslateToWrapperTransitionEnd = function (e) {
                      i &&
                        !i.destroyed &&
                        e.target === this &&
                        (i.wrapperEl.removeEventListener(
                          "transitionend",
                          i.onTranslateToWrapperTransitionEnd
                        ),
                        (i.onTranslateToWrapperTransitionEnd = null),
                        delete i.onTranslateToWrapperTransitionEnd,
                        (i.animating = !1),
                        r && i.emit("transitionEnd"));
                    }),
                  i.wrapperEl.addEventListener(
                    "transitionend",
                    i.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      };
      function F(e) {
        let { swiper: t, runCallbacks: r, direction: n, step: o } = e;
        const { activeIndex: i, previousIndex: s } = t;
        let a = n;
        if (
          (a || (a = i > s ? "next" : i < s ? "prev" : "reset"),
          t.emit(`transition${o}`),
          r && i !== s)
        ) {
          if ("reset" === a) return void t.emit(`slideResetTransition${o}`);
          t.emit(`slideChangeTransition${o}`),
            "next" === a
              ? t.emit(`slideNextTransition${o}`)
              : t.emit(`slidePrevTransition${o}`);
        }
      }
      var N = {
        setTransition: function (e, t) {
          const r = this;
          r.params.cssMode ||
            ((r.wrapperEl.style.transitionDuration = `${e}ms`),
            (r.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : "")),
            r.emit("setTransition", e, t);
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0);
          const r = this,
            { params: n } = r;
          n.cssMode ||
            (n.autoHeight && r.updateAutoHeight(),
            F({ swiper: r, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0);
          const r = this,
            { params: n } = r;
          (r.animating = !1),
            n.cssMode ||
              (r.setTransition(0),
              F({ swiper: r, runCallbacks: e, direction: t, step: "End" }));
        },
      };
      var R = {
        slideTo: function (e, t, r, n, o) {
          void 0 === e && (e = 0),
            void 0 === r && (r = !0),
            "string" == typeof e && (e = parseInt(e, 10));
          const i = this;
          let s = e;
          s < 0 && (s = 0);
          const {
            params: a,
            snapGrid: l,
            slidesGrid: c,
            previousIndex: u,
            activeIndex: d,
            rtlTranslate: p,
            wrapperEl: f,
            enabled: h,
          } = i;
          if (
            (!h && !n && !o) ||
            i.destroyed ||
            (i.animating && a.preventInteractionOnTransition)
          )
            return !1;
          void 0 === t && (t = i.params.speed);
          const m = Math.min(i.params.slidesPerGroupSkip, s);
          let y = m + Math.floor((s - m) / i.params.slidesPerGroup);
          y >= l.length && (y = l.length - 1);
          const v = -l[y];
          if (a.normalizeSlideIndex)
            for (let e = 0; e < c.length; e += 1) {
              const t = -Math.floor(100 * v),
                r = Math.floor(100 * c[e]),
                n = Math.floor(100 * c[e + 1]);
              void 0 !== c[e + 1]
                ? t >= r && t < n - (n - r) / 2
                  ? (s = e)
                  : t >= r && t < n && (s = e + 1)
                : t >= r && (s = e);
            }
          if (i.initialized && s !== d) {
            if (
              !i.allowSlideNext &&
              (p
                ? v > i.translate && v > i.minTranslate()
                : v < i.translate && v < i.minTranslate())
            )
              return !1;
            if (
              !i.allowSlidePrev &&
              v > i.translate &&
              v > i.maxTranslate() &&
              (d || 0) !== s
            )
              return !1;
          }
          let w;
          s !== (u || 0) && r && i.emit("beforeSlideChangeStart"),
            i.updateProgress(v),
            (w = s > d ? "next" : s < d ? "prev" : "reset");
          const b = i.virtual && i.params.virtual.enabled;
          if (
            !(b && o) &&
            ((p && -v === i.translate) || (!p && v === i.translate))
          )
            return (
              i.updateActiveIndex(s),
              a.autoHeight && i.updateAutoHeight(),
              i.updateSlidesClasses(),
              "slide" !== a.effect && i.setTranslate(v),
              "reset" !== w && (i.transitionStart(r, w), i.transitionEnd(r, w)),
              !1
            );
          if (a.cssMode) {
            const e = i.isHorizontal(),
              r = p ? v : -v;
            if (0 === t)
              b &&
                ((i.wrapperEl.style.scrollSnapType = "none"),
                (i._immediateVirtual = !0)),
                b && !i._cssModeVirtualInitialSet && i.params.initialSlide > 0
                  ? ((i._cssModeVirtualInitialSet = !0),
                    requestAnimationFrame(() => {
                      f[e ? "scrollLeft" : "scrollTop"] = r;
                    }))
                  : (f[e ? "scrollLeft" : "scrollTop"] = r),
                b &&
                  requestAnimationFrame(() => {
                    (i.wrapperEl.style.scrollSnapType = ""),
                      (i._immediateVirtual = !1);
                  });
            else {
              if (!i.support.smoothScroll)
                return (
                  g({ swiper: i, targetPosition: r, side: e ? "left" : "top" }),
                  !0
                );
              f.scrollTo({ [e ? "left" : "top"]: r, behavior: "smooth" });
            }
            return !0;
          }
          const A = M().isSafari;
          return (
            b && !o && A && i.isElement && i.virtual.update(!1, !1, s),
            i.setTransition(t),
            i.setTranslate(v),
            i.updateActiveIndex(s),
            i.updateSlidesClasses(),
            i.emit("beforeTransitionStart", t, n),
            i.transitionStart(r, w),
            0 === t
              ? i.transitionEnd(r, w)
              : i.animating ||
                ((i.animating = !0),
                i.onSlideToWrapperTransitionEnd ||
                  (i.onSlideToWrapperTransitionEnd = function (e) {
                    i &&
                      !i.destroyed &&
                      e.target === this &&
                      (i.wrapperEl.removeEventListener(
                        "transitionend",
                        i.onSlideToWrapperTransitionEnd
                      ),
                      (i.onSlideToWrapperTransitionEnd = null),
                      delete i.onSlideToWrapperTransitionEnd,
                      i.transitionEnd(r, w));
                  }),
                i.wrapperEl.addEventListener(
                  "transitionend",
                  i.onSlideToWrapperTransitionEnd
                )),
            !0
          );
        },
        slideToLoop: function (e, t, r, n) {
          if (
            (void 0 === e && (e = 0),
            void 0 === r && (r = !0),
            "string" == typeof e)
          ) {
            e = parseInt(e, 10);
          }
          const o = this;
          if (o.destroyed) return;
          void 0 === t && (t = o.params.speed);
          const i = o.grid && o.params.grid && o.params.grid.rows > 1;
          let s = e;
          if (o.params.loop)
            if (o.virtual && o.params.virtual.enabled)
              s += o.virtual.slidesBefore;
            else {
              let e;
              if (i) {
                const t = s * o.params.grid.rows;
                e = o.slides.find(
                  (e) => 1 * e.getAttribute("data-swiper-slide-index") === t
                ).column;
              } else e = o.getSlideIndexByData(s);
              const t = i
                  ? Math.ceil(o.slides.length / o.params.grid.rows)
                  : o.slides.length,
                { centeredSlides: r } = o.params;
              let a = o.params.slidesPerView;
              "auto" === a
                ? (a = o.slidesPerViewDynamic())
                : ((a = Math.ceil(parseFloat(o.params.slidesPerView, 10))),
                  r && a % 2 == 0 && (a += 1));
              let l = t - e < a;
              if (
                (r && (l = l || e < Math.ceil(a / 2)),
                n && r && "auto" !== o.params.slidesPerView && !i && (l = !1),
                l)
              ) {
                const n = r
                  ? e < o.activeIndex
                    ? "prev"
                    : "next"
                  : e - o.activeIndex - 1 < o.params.slidesPerView
                  ? "next"
                  : "prev";
                o.loopFix({
                  direction: n,
                  slideTo: !0,
                  activeSlideIndex: "next" === n ? e + 1 : e - t + 1,
                  slideRealIndex: "next" === n ? o.realIndex : void 0,
                });
              }
              if (i) {
                const e = s * o.params.grid.rows;
                s = o.slides.find(
                  (t) => 1 * t.getAttribute("data-swiper-slide-index") === e
                ).column;
              } else s = o.getSlideIndexByData(s);
            }
          return (
            requestAnimationFrame(() => {
              o.slideTo(s, t, r, n);
            }),
            o
          );
        },
        slideNext: function (e, t, r) {
          void 0 === t && (t = !0);
          const n = this,
            { enabled: o, params: i, animating: s } = n;
          if (!o || n.destroyed) return n;
          void 0 === e && (e = n.params.speed);
          let a = i.slidesPerGroup;
          "auto" === i.slidesPerView &&
            1 === i.slidesPerGroup &&
            i.slidesPerGroupAuto &&
            (a = Math.max(n.slidesPerViewDynamic("current", !0), 1));
          const l = n.activeIndex < i.slidesPerGroupSkip ? 1 : a,
            c = n.virtual && i.virtual.enabled;
          if (i.loop) {
            if (s && !c && i.loopPreventsSliding) return !1;
            if (
              (n.loopFix({ direction: "next" }),
              (n._clientLeft = n.wrapperEl.clientLeft),
              n.activeIndex === n.slides.length - 1 && i.cssMode)
            )
              return (
                requestAnimationFrame(() => {
                  n.slideTo(n.activeIndex + l, e, t, r);
                }),
                !0
              );
          }
          return i.rewind && n.isEnd
            ? n.slideTo(0, e, t, r)
            : n.slideTo(n.activeIndex + l, e, t, r);
        },
        slidePrev: function (e, t, r) {
          void 0 === t && (t = !0);
          const n = this,
            {
              params: o,
              snapGrid: i,
              slidesGrid: s,
              rtlTranslate: a,
              enabled: l,
              animating: c,
            } = n;
          if (!l || n.destroyed) return n;
          void 0 === e && (e = n.params.speed);
          const u = n.virtual && o.virtual.enabled;
          if (o.loop) {
            if (c && !u && o.loopPreventsSliding) return !1;
            n.loopFix({ direction: "prev" }),
              (n._clientLeft = n.wrapperEl.clientLeft);
          }
          function d(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          const p = d(a ? n.translate : -n.translate),
            f = i.map((e) => d(e)),
            h = o.freeMode && o.freeMode.enabled;
          let m = i[f.indexOf(p) - 1];
          if (void 0 === m && (o.cssMode || h)) {
            let e;
            i.forEach((t, r) => {
              p >= t && (e = r);
            }),
              void 0 !== e && (m = h ? i[e] : i[e > 0 ? e - 1 : e]);
          }
          let g = 0;
          if (
            (void 0 !== m &&
              ((g = s.indexOf(m)),
              g < 0 && (g = n.activeIndex - 1),
              "auto" === o.slidesPerView &&
                1 === o.slidesPerGroup &&
                o.slidesPerGroupAuto &&
                ((g = g - n.slidesPerViewDynamic("previous", !0) + 1),
                (g = Math.max(g, 0)))),
            o.rewind && n.isBeginning)
          ) {
            const o =
              n.params.virtual && n.params.virtual.enabled && n.virtual
                ? n.virtual.slides.length - 1
                : n.slides.length - 1;
            return n.slideTo(o, e, t, r);
          }
          return o.loop && 0 === n.activeIndex && o.cssMode
            ? (requestAnimationFrame(() => {
                n.slideTo(g, e, t, r);
              }),
              !0)
            : n.slideTo(g, e, t, r);
        },
        slideReset: function (e, t, r) {
          void 0 === t && (t = !0);
          const n = this;
          if (!n.destroyed)
            return (
              void 0 === e && (e = n.params.speed),
              n.slideTo(n.activeIndex, e, t, r)
            );
        },
        slideToClosest: function (e, t, r, n) {
          void 0 === t && (t = !0), void 0 === n && (n = 0.5);
          const o = this;
          if (o.destroyed) return;
          void 0 === e && (e = o.params.speed);
          let i = o.activeIndex;
          const s = Math.min(o.params.slidesPerGroupSkip, i),
            a = s + Math.floor((i - s) / o.params.slidesPerGroup),
            l = o.rtlTranslate ? o.translate : -o.translate;
          if (l >= o.snapGrid[a]) {
            const e = o.snapGrid[a];
            l - e > (o.snapGrid[a + 1] - e) * n &&
              (i += o.params.slidesPerGroup);
          } else {
            const e = o.snapGrid[a - 1];
            l - e <= (o.snapGrid[a] - e) * n && (i -= o.params.slidesPerGroup);
          }
          return (
            (i = Math.max(i, 0)),
            (i = Math.min(i, o.slidesGrid.length - 1)),
            o.slideTo(i, e, t, r)
          );
        },
        slideToClickedSlide: function () {
          const e = this;
          if (e.destroyed) return;
          const { params: t, slidesEl: r } = e,
            n =
              "auto" === t.slidesPerView
                ? e.slidesPerViewDynamic()
                : t.slidesPerView;
          let o,
            i = e.clickedIndex;
          const s = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
          if (t.loop) {
            if (e.animating) return;
            (o = parseInt(
              e.clickedSlide.getAttribute("data-swiper-slide-index"),
              10
            )),
              t.centeredSlides
                ? i < e.loopedSlides - n / 2 ||
                  i > e.slides.length - e.loopedSlides + n / 2
                  ? (e.loopFix(),
                    (i = e.getSlideIndex(
                      y(r, `${s}[data-swiper-slide-index="${o}"]`)[0]
                    )),
                    u(() => {
                      e.slideTo(i);
                    }))
                  : e.slideTo(i)
                : i > e.slides.length - n
                ? (e.loopFix(),
                  (i = e.getSlideIndex(
                    y(r, `${s}[data-swiper-slide-index="${o}"]`)[0]
                  )),
                  u(() => {
                    e.slideTo(i);
                  }))
                : e.slideTo(i);
          } else e.slideTo(i);
        },
      };
      var G = {
        loopCreate: function (e) {
          const t = this,
            { params: r, slidesEl: n } = t;
          if (!r.loop || (t.virtual && t.params.virtual.enabled)) return;
          const o = () => {
              y(n, `.${r.slideClass}, swiper-slide`).forEach((e, t) => {
                e.setAttribute("data-swiper-slide-index", t);
              });
            },
            i = t.grid && r.grid && r.grid.rows > 1,
            s = r.slidesPerGroup * (i ? r.grid.rows : 1),
            a = t.slides.length % s != 0,
            l = i && t.slides.length % r.grid.rows != 0,
            c = (e) => {
              for (let n = 0; n < e; n += 1) {
                const e = t.isElement
                  ? w("swiper-slide", [r.slideBlankClass])
                  : w("div", [r.slideClass, r.slideBlankClass]);
                t.slidesEl.append(e);
              }
            };
          if (a) {
            if (r.loopAddBlankSlides) {
              c(s - (t.slides.length % s)), t.recalcSlides(), t.updateSlides();
            } else
              v(
                "Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
              );
            o();
          } else if (l) {
            if (r.loopAddBlankSlides) {
              c(r.grid.rows - (t.slides.length % r.grid.rows)),
                t.recalcSlides(),
                t.updateSlides();
            } else
              v(
                "Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
              );
            o();
          } else o();
          t.loopFix({
            slideRealIndex: e,
            direction: r.centeredSlides ? void 0 : "next",
          });
        },
        loopFix: function (e) {
          let {
            slideRealIndex: t,
            slideTo: r = !0,
            direction: n,
            setTranslate: o,
            activeSlideIndex: i,
            byController: s,
            byMousewheel: a,
          } = void 0 === e ? {} : e;
          const l = this;
          if (!l.params.loop) return;
          l.emit("beforeLoopFix");
          const {
              slides: c,
              allowSlidePrev: u,
              allowSlideNext: d,
              slidesEl: p,
              params: f,
            } = l,
            { centeredSlides: h } = f;
          if (
            ((l.allowSlidePrev = !0),
            (l.allowSlideNext = !0),
            l.virtual && f.virtual.enabled)
          )
            return (
              r &&
                (f.centeredSlides || 0 !== l.snapIndex
                  ? f.centeredSlides && l.snapIndex < f.slidesPerView
                    ? l.slideTo(
                        l.virtual.slides.length + l.snapIndex,
                        0,
                        !1,
                        !0
                      )
                    : l.snapIndex === l.snapGrid.length - 1 &&
                      l.slideTo(l.virtual.slidesBefore, 0, !1, !0)
                  : l.slideTo(l.virtual.slides.length, 0, !1, !0)),
              (l.allowSlidePrev = u),
              (l.allowSlideNext = d),
              void l.emit("loopFix")
            );
          let m = f.slidesPerView;
          "auto" === m
            ? (m = l.slidesPerViewDynamic())
            : ((m = Math.ceil(parseFloat(f.slidesPerView, 10))),
              h && m % 2 == 0 && (m += 1));
          const g = f.slidesPerGroupAuto ? m : f.slidesPerGroup;
          let y = g;
          y % g != 0 && (y += g - (y % g)),
            (y += f.loopAdditionalSlides),
            (l.loopedSlides = y);
          const w = l.grid && f.grid && f.grid.rows > 1;
          c.length < m + y
            ? v(
                "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"
              )
            : w &&
              "row" === f.grid.fill &&
              v(
                "Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`"
              );
          const b = [],
            A = [];
          let S = l.activeIndex;
          void 0 === i
            ? (i = l.getSlideIndex(
                c.find((e) => e.classList.contains(f.slideActiveClass))
              ))
            : (S = i);
          const E = "next" === n || !n,
            x = "prev" === n || !n;
          let T = 0,
            O = 0;
          const P = w ? Math.ceil(c.length / f.grid.rows) : c.length,
            j = (w ? c[i].column : i) + (h && void 0 === o ? -m / 2 + 0.5 : 0);
          if (j < y) {
            T = Math.max(y - j, g);
            for (let e = 0; e < y - j; e += 1) {
              const t = e - Math.floor(e / P) * P;
              if (w) {
                const e = P - t - 1;
                for (let t = c.length - 1; t >= 0; t -= 1)
                  c[t].column === e && b.push(t);
              } else b.push(P - t - 1);
            }
          } else if (j + m > P - y) {
            O = Math.max(j - (P - 2 * y), g);
            for (let e = 0; e < O; e += 1) {
              const t = e - Math.floor(e / P) * P;
              w
                ? c.forEach((e, r) => {
                    e.column === t && A.push(r);
                  })
                : A.push(t);
            }
          }
          if (
            ((l.__preventObserver__ = !0),
            requestAnimationFrame(() => {
              l.__preventObserver__ = !1;
            }),
            x &&
              b.forEach((e) => {
                (c[e].swiperLoopMoveDOM = !0),
                  p.prepend(c[e]),
                  (c[e].swiperLoopMoveDOM = !1);
              }),
            E &&
              A.forEach((e) => {
                (c[e].swiperLoopMoveDOM = !0),
                  p.append(c[e]),
                  (c[e].swiperLoopMoveDOM = !1);
              }),
            l.recalcSlides(),
            "auto" === f.slidesPerView
              ? l.updateSlides()
              : w &&
                ((b.length > 0 && x) || (A.length > 0 && E)) &&
                l.slides.forEach((e, t) => {
                  l.grid.updateSlide(t, e, l.slides);
                }),
            f.watchSlidesProgress && l.updateSlidesOffset(),
            r)
          )
            if (b.length > 0 && x) {
              if (void 0 === t) {
                const e = l.slidesGrid[S],
                  t = l.slidesGrid[S + T] - e;
                a
                  ? l.setTranslate(l.translate - t)
                  : (l.slideTo(S + Math.ceil(T), 0, !1, !0),
                    o &&
                      ((l.touchEventsData.startTranslate =
                        l.touchEventsData.startTranslate - t),
                      (l.touchEventsData.currentTranslate =
                        l.touchEventsData.currentTranslate - t)));
              } else if (o) {
                const e = w ? b.length / f.grid.rows : b.length;
                l.slideTo(l.activeIndex + e, 0, !1, !0),
                  (l.touchEventsData.currentTranslate = l.translate);
              }
            } else if (A.length > 0 && E)
              if (void 0 === t) {
                const e = l.slidesGrid[S],
                  t = l.slidesGrid[S - O] - e;
                a
                  ? l.setTranslate(l.translate - t)
                  : (l.slideTo(S - O, 0, !1, !0),
                    o &&
                      ((l.touchEventsData.startTranslate =
                        l.touchEventsData.startTranslate - t),
                      (l.touchEventsData.currentTranslate =
                        l.touchEventsData.currentTranslate - t)));
              } else {
                const e = w ? A.length / f.grid.rows : A.length;
                l.slideTo(l.activeIndex - e, 0, !1, !0);
              }
          if (
            ((l.allowSlidePrev = u),
            (l.allowSlideNext = d),
            l.controller && l.controller.control && !s)
          ) {
            const e = {
              slideRealIndex: t,
              direction: n,
              setTranslate: o,
              activeSlideIndex: i,
              byController: !0,
            };
            Array.isArray(l.controller.control)
              ? l.controller.control.forEach((t) => {
                  !t.destroyed &&
                    t.params.loop &&
                    t.loopFix({
                      ...e,
                      slideTo: t.params.slidesPerView === f.slidesPerView && r,
                    });
                })
              : l.controller.control instanceof l.constructor &&
                l.controller.control.params.loop &&
                l.controller.control.loopFix({
                  ...e,
                  slideTo:
                    l.controller.control.params.slidesPerView ===
                      f.slidesPerView && r,
                });
          }
          l.emit("loopFix");
        },
        loopDestroy: function () {
          const e = this,
            { params: t, slidesEl: r } = e;
          if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
          e.recalcSlides();
          const n = [];
          e.slides.forEach((e) => {
            const t =
              void 0 === e.swiperSlideIndex
                ? 1 * e.getAttribute("data-swiper-slide-index")
                : e.swiperSlideIndex;
            n[t] = e;
          }),
            e.slides.forEach((e) => {
              e.removeAttribute("data-swiper-slide-index");
            }),
            n.forEach((e) => {
              r.append(e);
            }),
            e.recalcSlides(),
            e.slideTo(e.realIndex, 0);
        },
      };
      var q = {
        setGrabCursor: function (e) {
          const t = this;
          if (
            !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode
          )
            return;
          const r =
            "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          t.isElement && (t.__preventObserver__ = !0),
            (r.style.cursor = "move"),
            (r.style.cursor = e ? "grabbing" : "grab"),
            t.isElement &&
              requestAnimationFrame(() => {
                t.__preventObserver__ = !1;
              });
        },
        unsetGrabCursor: function () {
          const e = this;
          (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.isElement && (e.__preventObserver__ = !0),
            (e[
              "container" === e.params.touchEventsTarget ? "el" : "wrapperEl"
            ].style.cursor = ""),
            e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
              }));
        },
      };
      function V(e, t, r) {
        const n = l(),
          { params: o } = e,
          i = o.edgeSwipeDetection,
          s = o.edgeSwipeThreshold;
        return (
          !i ||
          !(r <= s || r >= n.innerWidth - s) ||
          ("prevent" === i && (t.preventDefault(), !0))
        );
      }
      function U(e) {
        const t = this,
          r = s();
        let n = e;
        n.originalEvent && (n = n.originalEvent);
        const o = t.touchEventsData;
        if ("pointerdown" === n.type) {
          if (null !== o.pointerId && o.pointerId !== n.pointerId) return;
          o.pointerId = n.pointerId;
        } else
          "touchstart" === n.type &&
            1 === n.targetTouches.length &&
            (o.touchId = n.targetTouches[0].identifier);
        if ("touchstart" === n.type)
          return void V(t, n, n.targetTouches[0].pageX);
        const { params: i, touches: a, enabled: c } = t;
        if (!c) return;
        if (!i.simulateTouch && "mouse" === n.pointerType) return;
        if (t.animating && i.preventInteractionOnTransition) return;
        !t.animating && i.cssMode && i.loop && t.loopFix();
        let u = n.target;
        if (
          "wrapper" === i.touchEventsTarget &&
          !(function (e, t) {
            const r = l();
            let n = t.contains(e);
            !n &&
              r.HTMLSlotElement &&
              t instanceof HTMLSlotElement &&
              ((n = [...t.assignedElements()].includes(e)),
              n ||
                (n = (function (e, t) {
                  const r = [t];
                  for (; r.length > 0; ) {
                    const t = r.shift();
                    if (e === t) return !0;
                    r.push(
                      ...t.children,
                      ...(t.shadowRoot?.children || []),
                      ...(t.assignedElements?.() || [])
                    );
                  }
                })(e, t)));
            return n;
          })(u, t.wrapperEl)
        )
          return;
        if ("which" in n && 3 === n.which) return;
        if ("button" in n && n.button > 0) return;
        if (o.isTouched && o.isMoved) return;
        const p = !!i.noSwipingClass && "" !== i.noSwipingClass,
          f = n.composedPath ? n.composedPath() : n.path;
        p && n.target && n.target.shadowRoot && f && (u = f[0]);
        const h = i.noSwipingSelector
            ? i.noSwipingSelector
            : `.${i.noSwipingClass}`,
          m = !(!n.target || !n.target.shadowRoot);
        if (
          i.noSwiping &&
          (m
            ? (function (e, t) {
                return (
                  void 0 === t && (t = this),
                  (function t(r) {
                    if (!r || r === s() || r === l()) return null;
                    r.assignedSlot && (r = r.assignedSlot);
                    const n = r.closest(e);
                    return n || r.getRootNode
                      ? n || t(r.getRootNode().host)
                      : null;
                  })(t)
                );
              })(h, u)
            : u.closest(h))
        )
          return void (t.allowClick = !0);
        if (i.swipeHandler && !u.closest(i.swipeHandler)) return;
        (a.currentX = n.pageX), (a.currentY = n.pageY);
        const g = a.currentX,
          y = a.currentY;
        if (!V(t, n, g)) return;
        Object.assign(o, {
          isTouched: !0,
          isMoved: !1,
          allowTouchCallbacks: !0,
          isScrolling: void 0,
          startMoving: void 0,
        }),
          (a.startX = g),
          (a.startY = y),
          (o.touchStartTime = d()),
          (t.allowClick = !0),
          t.updateSize(),
          (t.swipeDirection = void 0),
          i.threshold > 0 && (o.allowThresholdMove = !1);
        let v = !0;
        u.matches(o.focusableElements) &&
          ((v = !1), "SELECT" === u.nodeName && (o.isTouched = !1)),
          r.activeElement &&
            r.activeElement.matches(o.focusableElements) &&
            r.activeElement !== u &&
            ("mouse" === n.pointerType ||
              ("mouse" !== n.pointerType && !u.matches(o.focusableElements))) &&
            r.activeElement.blur();
        const w = v && t.allowTouchMove && i.touchStartPreventDefault;
        (!i.touchStartForcePreventDefault && !w) ||
          u.isContentEditable ||
          n.preventDefault(),
          i.freeMode &&
            i.freeMode.enabled &&
            t.freeMode &&
            t.animating &&
            !i.cssMode &&
            t.freeMode.onTouchStart(),
          t.emit("touchStart", n);
      }
      function $(e) {
        const t = s(),
          r = this,
          n = r.touchEventsData,
          { params: o, touches: i, rtlTranslate: a, enabled: l } = r;
        if (!l) return;
        if (!o.simulateTouch && "mouse" === e.pointerType) return;
        let c,
          u = e;
        if (
          (u.originalEvent && (u = u.originalEvent), "pointermove" === u.type)
        ) {
          if (null !== n.touchId) return;
          if (u.pointerId !== n.pointerId) return;
        }
        if ("touchmove" === u.type) {
          if (
            ((c = [...u.changedTouches].find(
              (e) => e.identifier === n.touchId
            )),
            !c || c.identifier !== n.touchId)
          )
            return;
        } else c = u;
        if (!n.isTouched)
          return void (
            n.startMoving &&
            n.isScrolling &&
            r.emit("touchMoveOpposite", u)
          );
        const p = c.pageX,
          f = c.pageY;
        if (u.preventedByNestedSwiper)
          return (i.startX = p), void (i.startY = f);
        if (!r.allowTouchMove)
          return (
            u.target.matches(n.focusableElements) || (r.allowClick = !1),
            void (
              n.isTouched &&
              (Object.assign(i, {
                startX: p,
                startY: f,
                currentX: p,
                currentY: f,
              }),
              (n.touchStartTime = d()))
            )
          );
        if (o.touchReleaseOnEdges && !o.loop)
          if (r.isVertical()) {
            if (
              (f < i.startY && r.translate <= r.maxTranslate()) ||
              (f > i.startY && r.translate >= r.minTranslate())
            )
              return (n.isTouched = !1), void (n.isMoved = !1);
          } else if (
            (p < i.startX && r.translate <= r.maxTranslate()) ||
            (p > i.startX && r.translate >= r.minTranslate())
          )
            return;
        if (
          (t.activeElement &&
            t.activeElement.matches(n.focusableElements) &&
            t.activeElement !== u.target &&
            "mouse" !== u.pointerType &&
            t.activeElement.blur(),
          t.activeElement &&
            u.target === t.activeElement &&
            u.target.matches(n.focusableElements))
        )
          return (n.isMoved = !0), void (r.allowClick = !1);
        n.allowTouchCallbacks && r.emit("touchMove", u),
          (i.previousX = i.currentX),
          (i.previousY = i.currentY),
          (i.currentX = p),
          (i.currentY = f);
        const h = i.currentX - i.startX,
          m = i.currentY - i.startY;
        if (
          r.params.threshold &&
          Math.sqrt(h ** 2 + m ** 2) < r.params.threshold
        )
          return;
        if (void 0 === n.isScrolling) {
          let e;
          (r.isHorizontal() && i.currentY === i.startY) ||
          (r.isVertical() && i.currentX === i.startX)
            ? (n.isScrolling = !1)
            : h * h + m * m >= 25 &&
              ((e = (180 * Math.atan2(Math.abs(m), Math.abs(h))) / Math.PI),
              (n.isScrolling = r.isHorizontal()
                ? e > o.touchAngle
                : 90 - e > o.touchAngle));
        }
        if (
          (n.isScrolling && r.emit("touchMoveOpposite", u),
          void 0 === n.startMoving &&
            ((i.currentX === i.startX && i.currentY === i.startY) ||
              (n.startMoving = !0)),
          n.isScrolling ||
            ("touchmove" === u.type && n.preventTouchMoveFromPointerMove))
        )
          return void (n.isTouched = !1);
        if (!n.startMoving) return;
        (r.allowClick = !1),
          !o.cssMode && u.cancelable && u.preventDefault(),
          o.touchMoveStopPropagation && !o.nested && u.stopPropagation();
        let g = r.isHorizontal() ? h : m,
          y = r.isHorizontal()
            ? i.currentX - i.previousX
            : i.currentY - i.previousY;
        o.oneWayMovement &&
          ((g = Math.abs(g) * (a ? 1 : -1)), (y = Math.abs(y) * (a ? 1 : -1))),
          (i.diff = g),
          (g *= o.touchRatio),
          a && ((g = -g), (y = -y));
        const v = r.touchesDirection;
        (r.swipeDirection = g > 0 ? "prev" : "next"),
          (r.touchesDirection = y > 0 ? "prev" : "next");
        const w = r.params.loop && !o.cssMode,
          b =
            ("next" === r.touchesDirection && r.allowSlideNext) ||
            ("prev" === r.touchesDirection && r.allowSlidePrev);
        if (!n.isMoved) {
          if (
            (w && b && r.loopFix({ direction: r.swipeDirection }),
            (n.startTranslate = r.getTranslate()),
            r.setTransition(0),
            r.animating)
          ) {
            const e = new window.CustomEvent("transitionend", {
              bubbles: !0,
              cancelable: !0,
              detail: { bySwiperTouchMove: !0 },
            });
            r.wrapperEl.dispatchEvent(e);
          }
          (n.allowMomentumBounce = !1),
            !o.grabCursor ||
              (!0 !== r.allowSlideNext && !0 !== r.allowSlidePrev) ||
              r.setGrabCursor(!0),
            r.emit("sliderFirstMove", u);
        }
        if (
          (new Date().getTime(),
          !1 !== o._loopSwapReset &&
            n.isMoved &&
            n.allowThresholdMove &&
            v !== r.touchesDirection &&
            w &&
            b &&
            Math.abs(g) >= 1)
        )
          return (
            Object.assign(i, {
              startX: p,
              startY: f,
              currentX: p,
              currentY: f,
              startTranslate: n.currentTranslate,
            }),
            (n.loopSwapReset = !0),
            void (n.startTranslate = n.currentTranslate)
          );
        r.emit("sliderMove", u),
          (n.isMoved = !0),
          (n.currentTranslate = g + n.startTranslate);
        let A = !0,
          S = o.resistanceRatio;
        if (
          (o.touchReleaseOnEdges && (S = 0),
          g > 0
            ? (w &&
                b &&
                n.allowThresholdMove &&
                n.currentTranslate >
                  (o.centeredSlides
                    ? r.minTranslate() -
                      r.slidesSizesGrid[r.activeIndex + 1] -
                      ("auto" !== o.slidesPerView &&
                      r.slides.length - o.slidesPerView >= 2
                        ? r.slidesSizesGrid[r.activeIndex + 1] +
                          r.params.spaceBetween
                        : 0) -
                      r.params.spaceBetween
                    : r.minTranslate()) &&
                r.loopFix({
                  direction: "prev",
                  setTranslate: !0,
                  activeSlideIndex: 0,
                }),
              n.currentTranslate > r.minTranslate() &&
                ((A = !1),
                o.resistance &&
                  (n.currentTranslate =
                    r.minTranslate() -
                    1 +
                    (-r.minTranslate() + n.startTranslate + g) ** S)))
            : g < 0 &&
              (w &&
                b &&
                n.allowThresholdMove &&
                n.currentTranslate <
                  (o.centeredSlides
                    ? r.maxTranslate() +
                      r.slidesSizesGrid[r.slidesSizesGrid.length - 1] +
                      r.params.spaceBetween +
                      ("auto" !== o.slidesPerView &&
                      r.slides.length - o.slidesPerView >= 2
                        ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] +
                          r.params.spaceBetween
                        : 0)
                    : r.maxTranslate()) &&
                r.loopFix({
                  direction: "next",
                  setTranslate: !0,
                  activeSlideIndex:
                    r.slides.length -
                    ("auto" === o.slidesPerView
                      ? r.slidesPerViewDynamic()
                      : Math.ceil(parseFloat(o.slidesPerView, 10))),
                }),
              n.currentTranslate < r.maxTranslate() &&
                ((A = !1),
                o.resistance &&
                  (n.currentTranslate =
                    r.maxTranslate() +
                    1 -
                    (r.maxTranslate() - n.startTranslate - g) ** S))),
          A && (u.preventedByNestedSwiper = !0),
          !r.allowSlideNext &&
            "next" === r.swipeDirection &&
            n.currentTranslate < n.startTranslate &&
            (n.currentTranslate = n.startTranslate),
          !r.allowSlidePrev &&
            "prev" === r.swipeDirection &&
            n.currentTranslate > n.startTranslate &&
            (n.currentTranslate = n.startTranslate),
          r.allowSlidePrev ||
            r.allowSlideNext ||
            (n.currentTranslate = n.startTranslate),
          o.threshold > 0)
        ) {
          if (!(Math.abs(g) > o.threshold || n.allowThresholdMove))
            return void (n.currentTranslate = n.startTranslate);
          if (!n.allowThresholdMove)
            return (
              (n.allowThresholdMove = !0),
              (i.startX = i.currentX),
              (i.startY = i.currentY),
              (n.currentTranslate = n.startTranslate),
              void (i.diff = r.isHorizontal()
                ? i.currentX - i.startX
                : i.currentY - i.startY)
            );
        }
        o.followFinger &&
          !o.cssMode &&
          (((o.freeMode && o.freeMode.enabled && r.freeMode) ||
            o.watchSlidesProgress) &&
            (r.updateActiveIndex(), r.updateSlidesClasses()),
          o.freeMode &&
            o.freeMode.enabled &&
            r.freeMode &&
            r.freeMode.onTouchMove(),
          r.updateProgress(n.currentTranslate),
          r.setTranslate(n.currentTranslate));
      }
      function Y(e) {
        const t = this,
          r = t.touchEventsData;
        let n,
          o = e;
        o.originalEvent && (o = o.originalEvent);
        if ("touchend" === o.type || "touchcancel" === o.type) {
          if (
            ((n = [...o.changedTouches].find(
              (e) => e.identifier === r.touchId
            )),
            !n || n.identifier !== r.touchId)
          )
            return;
        } else {
          if (null !== r.touchId) return;
          if (o.pointerId !== r.pointerId) return;
          n = o;
        }
        if (
          [
            "pointercancel",
            "pointerout",
            "pointerleave",
            "contextmenu",
          ].includes(o.type)
        ) {
          if (
            !(
              ["pointercancel", "contextmenu"].includes(o.type) &&
              (t.browser.isSafari || t.browser.isWebView)
            )
          )
            return;
        }
        (r.pointerId = null), (r.touchId = null);
        const {
          params: i,
          touches: s,
          rtlTranslate: a,
          slidesGrid: l,
          enabled: c,
        } = t;
        if (!c) return;
        if (!i.simulateTouch && "mouse" === o.pointerType) return;
        if (
          (r.allowTouchCallbacks && t.emit("touchEnd", o),
          (r.allowTouchCallbacks = !1),
          !r.isTouched)
        )
          return (
            r.isMoved && i.grabCursor && t.setGrabCursor(!1),
            (r.isMoved = !1),
            void (r.startMoving = !1)
          );
        i.grabCursor &&
          r.isMoved &&
          r.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const p = d(),
          f = p - r.touchStartTime;
        if (t.allowClick) {
          const e = o.path || (o.composedPath && o.composedPath());
          t.updateClickedSlide((e && e[0]) || o.target, e),
            t.emit("tap click", o),
            f < 300 &&
              p - r.lastClickTime < 300 &&
              t.emit("doubleTap doubleClick", o);
        }
        if (
          ((r.lastClickTime = d()),
          u(() => {
            t.destroyed || (t.allowClick = !0);
          }),
          !r.isTouched ||
            !r.isMoved ||
            !t.swipeDirection ||
            (0 === s.diff && !r.loopSwapReset) ||
            (r.currentTranslate === r.startTranslate && !r.loopSwapReset))
        )
          return (
            (r.isTouched = !1), (r.isMoved = !1), void (r.startMoving = !1)
          );
        let h;
        if (
          ((r.isTouched = !1),
          (r.isMoved = !1),
          (r.startMoving = !1),
          (h = i.followFinger
            ? a
              ? t.translate
              : -t.translate
            : -r.currentTranslate),
          i.cssMode)
        )
          return;
        if (i.freeMode && i.freeMode.enabled)
          return void t.freeMode.onTouchEnd({ currentPos: h });
        const m = h >= -t.maxTranslate() && !t.params.loop;
        let g = 0,
          y = t.slidesSizesGrid[0];
        for (
          let e = 0;
          e < l.length;
          e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup
        ) {
          const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
          void 0 !== l[e + t]
            ? (m || (h >= l[e] && h < l[e + t])) &&
              ((g = e), (y = l[e + t] - l[e]))
            : (m || h >= l[e]) &&
              ((g = e), (y = l[l.length - 1] - l[l.length - 2]));
        }
        let v = null,
          w = null;
        i.rewind &&
          (t.isBeginning
            ? (w =
                i.virtual && i.virtual.enabled && t.virtual
                  ? t.virtual.slides.length - 1
                  : t.slides.length - 1)
            : t.isEnd && (v = 0));
        const b = (h - l[g]) / y,
          A = g < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
        if (f > i.longSwipesMs) {
          if (!i.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection &&
            (b >= i.longSwipesRatio
              ? t.slideTo(i.rewind && t.isEnd ? v : g + A)
              : t.slideTo(g)),
            "prev" === t.swipeDirection &&
              (b > 1 - i.longSwipesRatio
                ? t.slideTo(g + A)
                : null !== w && b < 0 && Math.abs(b) > i.longSwipesRatio
                ? t.slideTo(w)
                : t.slideTo(g));
        } else {
          if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
          t.navigation &&
          (o.target === t.navigation.nextEl || o.target === t.navigation.prevEl)
            ? o.target === t.navigation.nextEl
              ? t.slideTo(g + A)
              : t.slideTo(g)
            : ("next" === t.swipeDirection && t.slideTo(null !== v ? v : g + A),
              "prev" === t.swipeDirection && t.slideTo(null !== w ? w : g));
        }
      }
      function H() {
        const e = this,
          { params: t, el: r } = e;
        if (r && 0 === r.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: n, allowSlidePrev: o, snapGrid: i } = e,
          s = e.virtual && e.params.virtual.enabled;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses();
        const a = s && t.loop;
        !("auto" === t.slidesPerView || t.slidesPerView > 1) ||
        !e.isEnd ||
        e.isBeginning ||
        e.params.centeredSlides ||
        a
          ? e.params.loop && !s
            ? e.slideToLoop(e.realIndex, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0)
          : e.slideTo(e.slides.length - 1, 0, !1, !0),
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            (clearTimeout(e.autoplay.resizeTimeout),
            (e.autoplay.resizeTimeout = setTimeout(() => {
              e.autoplay &&
                e.autoplay.running &&
                e.autoplay.paused &&
                e.autoplay.resume();
            }, 500))),
          (e.allowSlidePrev = o),
          (e.allowSlideNext = n),
          e.params.watchOverflow && i !== e.snapGrid && e.checkOverflow();
      }
      function W(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function X() {
        const e = this,
          { wrapperEl: t, rtlTranslate: r, enabled: n } = e;
        if (!n) return;
        let o;
        (e.previousTranslate = e.translate),
          e.isHorizontal()
            ? (e.translate = -t.scrollLeft)
            : (e.translate = -t.scrollTop),
          0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const i = e.maxTranslate() - e.minTranslate();
        (o = 0 === i ? 0 : (e.translate - e.minTranslate()) / i),
          o !== e.progress && e.updateProgress(r ? -e.translate : e.translate),
          e.emit("setTranslate", e.translate, !1);
      }
      function Q(e) {
        const t = this;
        L(t, e.target),
          t.params.cssMode ||
            ("auto" !== t.params.slidesPerView && !t.params.autoHeight) ||
            t.update();
      }
      function Z() {
        const e = this;
        e.documentTouchHandlerProceeded ||
          ((e.documentTouchHandlerProceeded = !0),
          e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
      }
      const J = (e, t) => {
        const r = s(),
          { params: n, el: o, wrapperEl: i, device: a } = e,
          l = !!n.nested,
          c = "on" === t ? "addEventListener" : "removeEventListener",
          u = t;
        o &&
          "string" != typeof o &&
          (r[c]("touchstart", e.onDocumentTouchStart, {
            passive: !1,
            capture: l,
          }),
          o[c]("touchstart", e.onTouchStart, { passive: !1 }),
          o[c]("pointerdown", e.onTouchStart, { passive: !1 }),
          r[c]("touchmove", e.onTouchMove, { passive: !1, capture: l }),
          r[c]("pointermove", e.onTouchMove, { passive: !1, capture: l }),
          r[c]("touchend", e.onTouchEnd, { passive: !0 }),
          r[c]("pointerup", e.onTouchEnd, { passive: !0 }),
          r[c]("pointercancel", e.onTouchEnd, { passive: !0 }),
          r[c]("touchcancel", e.onTouchEnd, { passive: !0 }),
          r[c]("pointerout", e.onTouchEnd, { passive: !0 }),
          r[c]("pointerleave", e.onTouchEnd, { passive: !0 }),
          r[c]("contextmenu", e.onTouchEnd, { passive: !0 }),
          (n.preventClicks || n.preventClicksPropagation) &&
            o[c]("click", e.onClick, !0),
          n.cssMode && i[c]("scroll", e.onScroll),
          n.updateOnWindowResize
            ? e[u](
                a.ios || a.android
                  ? "resize orientationchange observerUpdate"
                  : "resize observerUpdate",
                H,
                !0
              )
            : e[u]("observerUpdate", H, !0),
          o[c]("load", e.onLoad, { capture: !0 }));
      };
      var K = {
        attachEvents: function () {
          const e = this,
            { params: t } = e;
          (e.onTouchStart = U.bind(e)),
            (e.onTouchMove = $.bind(e)),
            (e.onTouchEnd = Y.bind(e)),
            (e.onDocumentTouchStart = Z.bind(e)),
            t.cssMode && (e.onScroll = X.bind(e)),
            (e.onClick = W.bind(e)),
            (e.onLoad = Q.bind(e)),
            J(e, "on");
        },
        detachEvents: function () {
          J(this, "off");
        },
      };
      const ee = (e, t) => e.grid && t.grid && t.grid.rows > 1;
      var te = {
        setBreakpoint: function () {
          const e = this,
            { realIndex: t, initialized: r, params: n, el: o } = e,
            i = n.breakpoints;
          if (!i || (i && 0 === Object.keys(i).length)) return;
          const a = s(),
            l =
              "window" !== n.breakpointsBase && n.breakpointsBase
                ? "container"
                : n.breakpointsBase,
            c =
              ["window", "container"].includes(n.breakpointsBase) ||
              !n.breakpointsBase
                ? e.el
                : a.querySelector(n.breakpointsBase),
            u = e.getBreakpoint(i, l, c);
          if (!u || e.currentBreakpoint === u) return;
          const d = (u in i ? i[u] : void 0) || e.originalParams,
            p = ee(e, n),
            f = ee(e, d),
            m = e.params.grabCursor,
            g = d.grabCursor,
            y = n.enabled;
          p && !f
            ? (o.classList.remove(
                `${n.containerModifierClass}grid`,
                `${n.containerModifierClass}grid-column`
              ),
              e.emitContainerClasses())
            : !p &&
              f &&
              (o.classList.add(`${n.containerModifierClass}grid`),
              ((d.grid.fill && "column" === d.grid.fill) ||
                (!d.grid.fill && "column" === n.grid.fill)) &&
                o.classList.add(`${n.containerModifierClass}grid-column`),
              e.emitContainerClasses()),
            m && !g ? e.unsetGrabCursor() : !m && g && e.setGrabCursor(),
            ["navigation", "pagination", "scrollbar"].forEach((t) => {
              if (void 0 === d[t]) return;
              const r = n[t] && n[t].enabled,
                o = d[t] && d[t].enabled;
              r && !o && e[t].disable(), !r && o && e[t].enable();
            });
          const v = d.direction && d.direction !== n.direction,
            w = n.loop && (d.slidesPerView !== n.slidesPerView || v),
            b = n.loop;
          v && r && e.changeDirection(), h(e.params, d);
          const A = e.params.enabled,
            S = e.params.loop;
          Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            y && !A ? e.disable() : !y && A && e.enable(),
            (e.currentBreakpoint = u),
            e.emit("_beforeBreakpoint", d),
            r &&
              (w
                ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides())
                : !b && S
                ? (e.loopCreate(t), e.updateSlides())
                : b && !S && e.loopDestroy()),
            e.emit("breakpoint", d);
        },
        getBreakpoint: function (e, t, r) {
          if ((void 0 === t && (t = "window"), !e || ("container" === t && !r)))
            return;
          let n = !1;
          const o = l(),
            i = "window" === t ? o.innerHeight : r.clientHeight,
            s = Object.keys(e).map((e) => {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                const t = parseFloat(e.substr(1));
                return { value: i * t, point: e };
              }
              return { value: e, point: e };
            });
          s.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
          for (let e = 0; e < s.length; e += 1) {
            const { point: i, value: a } = s[e];
            "window" === t
              ? o.matchMedia(`(min-width: ${a}px)`).matches && (n = i)
              : a <= r.clientWidth && (n = i);
          }
          return n || "max";
        },
      };
      var re = {
        addClasses: function () {
          const e = this,
            { classNames: t, params: r, rtl: n, el: o, device: i } = e,
            s = (function (e, t) {
              const r = [];
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((n) => {
                        e[n] && r.push(t + n);
                      })
                    : "string" == typeof e && r.push(t + e);
                }),
                r
              );
            })(
              [
                "initialized",
                r.direction,
                { "free-mode": e.params.freeMode && r.freeMode.enabled },
                { autoheight: r.autoHeight },
                { rtl: n },
                { grid: r.grid && r.grid.rows > 1 },
                {
                  "grid-column":
                    r.grid && r.grid.rows > 1 && "column" === r.grid.fill,
                },
                { android: i.android },
                { ios: i.ios },
                { "css-mode": r.cssMode },
                { centered: r.cssMode && r.centeredSlides },
                { "watch-progress": r.watchSlidesProgress },
              ],
              r.containerModifierClass
            );
          t.push(...s), o.classList.add(...t), e.emitContainerClasses();
        },
        removeClasses: function () {
          const { el: e, classNames: t } = this;
          e &&
            "string" != typeof e &&
            (e.classList.remove(...t), this.emitContainerClasses());
        },
      };
      var ne = {
          checkOverflow: function () {
            const e = this,
              { isLocked: t, params: r } = e,
              { slidesOffsetBefore: n } = r;
            if (n) {
              const t = e.slides.length - 1,
                r = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * n;
              e.isLocked = e.size > r;
            } else e.isLocked = 1 === e.snapGrid.length;
            !0 === r.allowSlideNext && (e.allowSlideNext = !e.isLocked),
              !0 === r.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
              t && t !== e.isLocked && (e.isEnd = !1),
              t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
          },
        },
        oe = {
          init: !0,
          direction: "horizontal",
          oneWayMovement: !1,
          swiperElementNodeName: "SWIPER-CONTAINER",
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          eventsPrefix: "swiper",
          enabled: !0,
          focusableElements:
            "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 5,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          loop: !1,
          loopAddBlankSlides: !0,
          loopAdditionalSlides: 0,
          loopPreventsSliding: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-blank",
          slideActiveClass: "swiper-slide-active",
          slideVisibleClass: "swiper-slide-visible",
          slideFullyVisibleClass: "swiper-slide-fully-visible",
          slideNextClass: "swiper-slide-next",
          slidePrevClass: "swiper-slide-prev",
          wrapperClass: "swiper-wrapper",
          lazyPreloaderClass: "swiper-lazy-preloader",
          lazyPreloadPrevNext: 0,
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function ie(e, t) {
        return function (r) {
          void 0 === r && (r = {});
          const n = Object.keys(r)[0],
            o = r[n];
          "object" == typeof o && null !== o
            ? (!0 === e[n] && (e[n] = { enabled: !0 }),
              "navigation" === n &&
                e[n] &&
                e[n].enabled &&
                !e[n].prevEl &&
                !e[n].nextEl &&
                (e[n].auto = !0),
              ["pagination", "scrollbar"].indexOf(n) >= 0 &&
                e[n] &&
                e[n].enabled &&
                !e[n].el &&
                (e[n].auto = !0),
              n in e && "enabled" in o
                ? ("object" != typeof e[n] ||
                    "enabled" in e[n] ||
                    (e[n].enabled = !0),
                  e[n] || (e[n] = { enabled: !1 }),
                  h(t, r))
                : h(t, r))
            : h(t, r);
        };
      }
      const se = {
          eventsEmitter: k,
          update: _,
          translate: z,
          transition: N,
          slide: R,
          loop: G,
          grabCursor: q,
          events: K,
          breakpoints: te,
          checkOverflow: ne,
          classes: re,
        },
        ae = {};
      class le {
        constructor() {
          let e, t;
          for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
            n[o] = arguments[o];
          1 === n.length &&
          n[0].constructor &&
          "Object" === Object.prototype.toString.call(n[0]).slice(8, -1)
            ? (t = n[0])
            : ([e, t] = n),
            t || (t = {}),
            (t = h({}, t)),
            e && !t.el && (t.el = e);
          const i = s();
          if (
            t.el &&
            "string" == typeof t.el &&
            i.querySelectorAll(t.el).length > 1
          ) {
            const e = [];
            return (
              i.querySelectorAll(t.el).forEach((r) => {
                const n = h({}, t, { el: r });
                e.push(new le(n));
              }),
              e
            );
          }
          const a = this;
          (a.__swiper__ = !0),
            (a.support = P()),
            (a.device = j({ userAgent: t.userAgent })),
            (a.browser = M()),
            (a.eventsListeners = {}),
            (a.eventsAnyListeners = []),
            (a.modules = [...a.__modules__]),
            t.modules &&
              Array.isArray(t.modules) &&
              a.modules.push(...t.modules);
          const l = {};
          a.modules.forEach((e) => {
            e({
              params: t,
              swiper: a,
              extendParams: ie(t, l),
              on: a.on.bind(a),
              once: a.once.bind(a),
              off: a.off.bind(a),
              emit: a.emit.bind(a),
            });
          });
          const c = h({}, oe, l);
          return (
            (a.params = h({}, c, ae, t)),
            (a.originalParams = h({}, a.params)),
            (a.passedParams = h({}, t)),
            a.params &&
              a.params.on &&
              Object.keys(a.params.on).forEach((e) => {
                a.on(e, a.params.on[e]);
              }),
            a.params && a.params.onAny && a.onAny(a.params.onAny),
            Object.assign(a, {
              enabled: a.params.enabled,
              el: e,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: () => "horizontal" === a.params.direction,
              isVertical: () => "vertical" === a.params.direction,
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              allowSlideNext: a.params.allowSlideNext,
              allowSlidePrev: a.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: a.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null,
              },
              allowClick: !0,
              allowTouchMove: a.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            a.emit("_swiper"),
            a.params.init && a.init(),
            a
          );
        }
        getDirectionLabel(e) {
          return this.isHorizontal()
            ? e
            : {
                width: "height",
                "margin-top": "margin-left",
                "margin-bottom ": "margin-right",
                "margin-left": "margin-top",
                "margin-right": "margin-bottom",
                "padding-left": "padding-top",
                "padding-right": "padding-bottom",
                marginRight: "marginBottom",
              }[e];
        }
        getSlideIndex(e) {
          const { slidesEl: t, params: r } = this,
            n = A(y(t, `.${r.slideClass}, swiper-slide`)[0]);
          return A(e) - n;
        }
        getSlideIndexByData(e) {
          return this.getSlideIndex(
            this.slides.find(
              (t) => 1 * t.getAttribute("data-swiper-slide-index") === e
            )
          );
        }
        recalcSlides() {
          const { slidesEl: e, params: t } = this;
          this.slides = y(e, `.${t.slideClass}, swiper-slide`);
        }
        enable() {
          const e = this;
          e.enabled ||
            ((e.enabled = !0),
            e.params.grabCursor && e.setGrabCursor(),
            e.emit("enable"));
        }
        disable() {
          const e = this;
          e.enabled &&
            ((e.enabled = !1),
            e.params.grabCursor && e.unsetGrabCursor(),
            e.emit("disable"));
        }
        setProgress(e, t) {
          const r = this;
          e = Math.min(Math.max(e, 0), 1);
          const n = r.minTranslate(),
            o = (r.maxTranslate() - n) * e + n;
          r.translateTo(o, void 0 === t ? 0 : t),
            r.updateActiveIndex(),
            r.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(" ")
            .filter(
              (t) =>
                0 === t.indexOf("swiper") ||
                0 === t.indexOf(e.params.containerModifierClass)
            );
          e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
          const t = this;
          return t.destroyed
            ? ""
            : e.className
                .split(" ")
                .filter(
                  (e) =>
                    0 === e.indexOf("swiper-slide") ||
                    0 === e.indexOf(t.params.slideClass)
                )
                .join(" ");
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.forEach((r) => {
            const n = e.getSlideClasses(r);
            t.push({ slideEl: r, classNames: n }), e.emit("_slideClass", r, n);
          }),
            e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e, t) {
          void 0 === e && (e = "current"), void 0 === t && (t = !1);
          const {
            params: r,
            slides: n,
            slidesGrid: o,
            slidesSizesGrid: i,
            size: s,
            activeIndex: a,
          } = this;
          let l = 1;
          if ("number" == typeof r.slidesPerView) return r.slidesPerView;
          if (r.centeredSlides) {
            let e,
              t = n[a] ? Math.ceil(n[a].swiperSlideSize) : 0;
            for (let r = a + 1; r < n.length; r += 1)
              n[r] &&
                !e &&
                ((t += Math.ceil(n[r].swiperSlideSize)),
                (l += 1),
                t > s && (e = !0));
            for (let r = a - 1; r >= 0; r -= 1)
              n[r] &&
                !e &&
                ((t += n[r].swiperSlideSize), (l += 1), t > s && (e = !0));
          } else if ("current" === e)
            for (let e = a + 1; e < n.length; e += 1) {
              (t ? o[e] + i[e] - o[a] < s : o[e] - o[a] < s) && (l += 1);
            }
          else
            for (let e = a - 1; e >= 0; e -= 1) {
              o[a] - o[e] < s && (l += 1);
            }
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: r } = e;
          function n() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              r = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(r), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let o;
          if (
            (r.breakpoints && e.setBreakpoint(),
            [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
              t.complete && L(e, t);
            }),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            r.freeMode && r.freeMode.enabled && !r.cssMode)
          )
            n(), r.autoHeight && e.updateAutoHeight();
          else {
            if (
              ("auto" === r.slidesPerView || r.slidesPerView > 1) &&
              e.isEnd &&
              !r.centeredSlides
            ) {
              const t =
                e.virtual && r.virtual.enabled ? e.virtual.slides : e.slides;
              o = e.slideTo(t.length - 1, 0, !1, !0);
            } else o = e.slideTo(e.activeIndex, 0, !1, !0);
            o || n();
          }
          r.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
        }
        changeDirection(e, t) {
          void 0 === t && (t = !0);
          const r = this,
            n = r.params.direction;
          return (
            e || (e = "horizontal" === n ? "vertical" : "horizontal"),
            e === n ||
              ("horizontal" !== e && "vertical" !== e) ||
              (r.el.classList.remove(`${r.params.containerModifierClass}${n}`),
              r.el.classList.add(`${r.params.containerModifierClass}${e}`),
              r.emitContainerClasses(),
              (r.params.direction = e),
              r.slides.forEach((t) => {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              r.emit("changeDirection"),
              t && r.update()),
            r
          );
        }
        changeLanguageDirection(e) {
          const t = this;
          (t.rtl && "rtl" === e) ||
            (!t.rtl && "ltr" === e) ||
            ((t.rtl = "rtl" === e),
            (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
            t.rtl
              ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
                (t.el.dir = "rtl"))
              : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
                (t.el.dir = "ltr")),
            t.update());
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          let r = e || t.params.el;
          if (("string" == typeof r && (r = document.querySelector(r)), !r))
            return !1;
          (r.swiper = t),
            r.parentNode &&
              r.parentNode.host &&
              r.parentNode.host.nodeName ===
                t.params.swiperElementNodeName.toUpperCase() &&
              (t.isElement = !0);
          const n = () =>
            `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let o = (() => {
            if (r && r.shadowRoot && r.shadowRoot.querySelector) {
              return r.shadowRoot.querySelector(n());
            }
            return y(r, n())[0];
          })();
          return (
            !o &&
              t.params.createElements &&
              ((o = w("div", t.params.wrapperClass)),
              r.append(o),
              y(r, `.${t.params.slideClass}`).forEach((e) => {
                o.append(e);
              })),
            Object.assign(t, {
              el: r,
              wrapperEl: o,
              slidesEl:
                t.isElement && !r.parentNode.host.slideSlots
                  ? r.parentNode.host
                  : o,
              hostEl: t.isElement ? r.parentNode.host : r,
              mounted: !0,
              rtl: "rtl" === r.dir.toLowerCase() || "rtl" === b(r, "direction"),
              rtlTranslate:
                "horizontal" === t.params.direction &&
                ("rtl" === r.dir.toLowerCase() || "rtl" === b(r, "direction")),
              wrongRTL: "-webkit-box" === b(o, "display"),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          if (t.initialized) return t;
          if (!1 === t.mount(e)) return t;
          t.emit("beforeInit"),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.enabled && t.setGrabCursor(),
            t.params.loop && t.virtual && t.params.virtual.enabled
              ? t.slideTo(
                  t.params.initialSlide + t.virtual.slidesBefore,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0
                )
              : t.slideTo(
                  t.params.initialSlide,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0
                ),
            t.params.loop && t.loopCreate(),
            t.attachEvents();
          const r = [...t.el.querySelectorAll('[loading="lazy"]')];
          return (
            t.isElement &&
              r.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
            r.forEach((e) => {
              e.complete
                ? L(t, e)
                : e.addEventListener("load", (e) => {
                    L(t, e.target);
                  });
            }),
            D(t),
            (t.initialized = !0),
            D(t),
            t.emit("init"),
            t.emit("afterInit"),
            t
          );
        }
        destroy(e, t) {
          void 0 === e && (e = !0), void 0 === t && (t = !0);
          const r = this,
            { params: n, el: o, wrapperEl: i, slides: s } = r;
          return (
            void 0 === r.params ||
              r.destroyed ||
              (r.emit("beforeDestroy"),
              (r.initialized = !1),
              r.detachEvents(),
              n.loop && r.loopDestroy(),
              t &&
                (r.removeClasses(),
                o && "string" != typeof o && o.removeAttribute("style"),
                i && i.removeAttribute("style"),
                s &&
                  s.length &&
                  s.forEach((e) => {
                    e.classList.remove(
                      n.slideVisibleClass,
                      n.slideFullyVisibleClass,
                      n.slideActiveClass,
                      n.slideNextClass,
                      n.slidePrevClass
                    ),
                      e.removeAttribute("style"),
                      e.removeAttribute("data-swiper-slide-index");
                  })),
              r.emit("destroy"),
              Object.keys(r.eventsListeners).forEach((e) => {
                r.off(e);
              }),
              !1 !== e &&
                (r.el && "string" != typeof r.el && (r.el.swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) {}
                    try {
                      delete t[e];
                    } catch (e) {}
                  });
                })(r)),
              (r.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          h(ae, e);
        }
        static get extendedDefaults() {
          return ae;
        }
        static get defaults() {
          return oe;
        }
        static installModule(e) {
          le.prototype.__modules__ || (le.prototype.__modules__ = []);
          const t = le.prototype.__modules__;
          "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e)
            ? (e.forEach((e) => le.installModule(e)), le)
            : (le.installModule(e), le);
        }
      }
      function ce(e) {
        let { swiper: t, extendParams: r, on: n, emit: o } = e;
        function i(e) {
          let r;
          return e &&
            "string" == typeof e &&
            t.isElement &&
            ((r = t.el.querySelector(e) || t.hostEl.querySelector(e)), r)
            ? r
            : (e &&
                ("string" == typeof e &&
                  (r = [...document.querySelectorAll(e)]),
                t.params.uniqueNavElements &&
                "string" == typeof e &&
                r &&
                r.length > 1 &&
                1 === t.el.querySelectorAll(e).length
                  ? (r = t.el.querySelector(e))
                  : r && 1 === r.length && (r = r[0])),
              e && !r ? e : r);
        }
        function s(e, r) {
          const n = t.params.navigation;
          (e = E(e)).forEach((e) => {
            e &&
              (e.classList[r ? "add" : "remove"](...n.disabledClass.split(" ")),
              "BUTTON" === e.tagName && (e.disabled = r),
              t.params.watchOverflow &&
                t.enabled &&
                e.classList[t.isLocked ? "add" : "remove"](n.lockClass));
          });
        }
        function a() {
          const { nextEl: e, prevEl: r } = t.navigation;
          if (t.params.loop) return s(r, !1), void s(e, !1);
          s(r, t.isBeginning && !t.params.rewind),
            s(e, t.isEnd && !t.params.rewind);
        }
        function l(e) {
          e.preventDefault(),
            (!t.isBeginning || t.params.loop || t.params.rewind) &&
              (t.slidePrev(), o("navigationPrev"));
        }
        function c(e) {
          e.preventDefault(),
            (!t.isEnd || t.params.loop || t.params.rewind) &&
              (t.slideNext(), o("navigationNext"));
        }
        function u() {
          const e = t.params.navigation;
          if (
            ((t.params.navigation = (function (e, t, r, n) {
              return (
                e.params.createElements &&
                  Object.keys(n).forEach((o) => {
                    if (!r[o] && !0 === r.auto) {
                      let i = y(e.el, `.${n[o]}`)[0];
                      i ||
                        ((i = w("div", n[o])),
                        (i.className = n[o]),
                        e.el.append(i)),
                        (r[o] = i),
                        (t[o] = i);
                    }
                  }),
                r
              );
            })(t, t.originalParams.navigation, t.params.navigation, {
              nextEl: "swiper-button-next",
              prevEl: "swiper-button-prev",
            })),
            !e.nextEl && !e.prevEl)
          )
            return;
          let r = i(e.nextEl),
            n = i(e.prevEl);
          Object.assign(t.navigation, { nextEl: r, prevEl: n }),
            (r = E(r)),
            (n = E(n));
          const o = (r, n) => {
            r && r.addEventListener("click", "next" === n ? c : l),
              !t.enabled && r && r.classList.add(...e.lockClass.split(" "));
          };
          r.forEach((e) => o(e, "next")), n.forEach((e) => o(e, "prev"));
        }
        function d() {
          let { nextEl: e, prevEl: r } = t.navigation;
          (e = E(e)), (r = E(r));
          const n = (e, r) => {
            e.removeEventListener("click", "next" === r ? c : l),
              e.classList.remove(
                ...t.params.navigation.disabledClass.split(" ")
              );
          };
          e.forEach((e) => n(e, "next")), r.forEach((e) => n(e, "prev"));
        }
        r({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled",
          },
        }),
          (t.navigation = { nextEl: null, prevEl: null }),
          n("init", () => {
            !1 === t.params.navigation.enabled ? p() : (u(), a());
          }),
          n("toEdge fromEdge lock unlock", () => {
            a();
          }),
          n("destroy", () => {
            d();
          }),
          n("enable disable", () => {
            let { nextEl: e, prevEl: r } = t.navigation;
            (e = E(e)),
              (r = E(r)),
              t.enabled
                ? a()
                : [...e, ...r]
                    .filter((e) => !!e)
                    .forEach((e) =>
                      e.classList.add(t.params.navigation.lockClass)
                    );
          }),
          n("click", (e, r) => {
            let { nextEl: n, prevEl: i } = t.navigation;
            (n = E(n)), (i = E(i));
            const s = r.target;
            let a = i.includes(s) || n.includes(s);
            if (t.isElement && !a) {
              const e = r.path || (r.composedPath && r.composedPath());
              e && (a = e.find((e) => n.includes(e) || i.includes(e)));
            }
            if (t.params.navigation.hideOnClick && !a) {
              if (
                t.pagination &&
                t.params.pagination &&
                t.params.pagination.clickable &&
                (t.pagination.el === s || t.pagination.el.contains(s))
              )
                return;
              let e;
              n.length
                ? (e = n[0].classList.contains(t.params.navigation.hiddenClass))
                : i.length &&
                  (e = i[0].classList.contains(
                    t.params.navigation.hiddenClass
                  )),
                o(!0 === e ? "navigationShow" : "navigationHide"),
                [...n, ...i]
                  .filter((e) => !!e)
                  .forEach((e) =>
                    e.classList.toggle(t.params.navigation.hiddenClass)
                  );
            }
          });
        const p = () => {
          t.el.classList.add(
            ...t.params.navigation.navigationDisabledClass.split(" ")
          ),
            d();
        };
        Object.assign(t.navigation, {
          enable: () => {
            t.el.classList.remove(
              ...t.params.navigation.navigationDisabledClass.split(" ")
            ),
              u(),
              a();
          },
          disable: p,
          update: a,
          init: u,
          destroy: d,
        });
      }
      Object.keys(se).forEach((e) => {
        Object.keys(se[e]).forEach((t) => {
          le.prototype[t] = se[e][t];
        });
      }),
        le.use([
          function (e) {
            let { swiper: t, on: r, emit: n } = e;
            const o = l();
            let i = null,
              s = null;
            const a = () => {
                t &&
                  !t.destroyed &&
                  t.initialized &&
                  (n("beforeResize"), n("resize"));
              },
              c = () => {
                t && !t.destroyed && t.initialized && n("orientationchange");
              };
            r("init", () => {
              t.params.resizeObserver && void 0 !== o.ResizeObserver
                ? t &&
                  !t.destroyed &&
                  t.initialized &&
                  ((i = new ResizeObserver((e) => {
                    s = o.requestAnimationFrame(() => {
                      const { width: r, height: n } = t;
                      let o = r,
                        i = n;
                      e.forEach((e) => {
                        let {
                          contentBoxSize: r,
                          contentRect: n,
                          target: s,
                        } = e;
                        (s && s !== t.el) ||
                          ((o = n ? n.width : (r[0] || r).inlineSize),
                          (i = n ? n.height : (r[0] || r).blockSize));
                      }),
                        (o === r && i === n) || a();
                    });
                  })),
                  i.observe(t.el))
                : (o.addEventListener("resize", a),
                  o.addEventListener("orientationchange", c));
            }),
              r("destroy", () => {
                s && o.cancelAnimationFrame(s),
                  i && i.unobserve && t.el && (i.unobserve(t.el), (i = null)),
                  o.removeEventListener("resize", a),
                  o.removeEventListener("orientationchange", c);
              });
          },
          function (e) {
            let { swiper: t, extendParams: r, on: n, emit: o } = e;
            const i = [],
              s = l(),
              a = function (e, r) {
                void 0 === r && (r = {});
                const n = new (s.MutationObserver || s.WebkitMutationObserver)(
                  (e) => {
                    if (t.__preventObserver__) return;
                    if (1 === e.length) return void o("observerUpdate", e[0]);
                    const r = function () {
                      o("observerUpdate", e[0]);
                    };
                    s.requestAnimationFrame
                      ? s.requestAnimationFrame(r)
                      : s.setTimeout(r, 0);
                  }
                );
                n.observe(e, {
                  attributes: void 0 === r.attributes || r.attributes,
                  childList:
                    t.isElement || (void 0 === r.childList || r).childList,
                  characterData: void 0 === r.characterData || r.characterData,
                }),
                  i.push(n);
              };
            r({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              n("init", () => {
                if (t.params.observer) {
                  if (t.params.observeParents) {
                    const e = (function (e, t) {
                      const r = [];
                      let n = e.parentElement;
                      for (; n; )
                        t ? n.matches(t) && r.push(n) : r.push(n),
                          (n = n.parentElement);
                      return r;
                    })(t.hostEl);
                    for (let t = 0; t < e.length; t += 1) a(e[t]);
                  }
                  a(t.hostEl, { childList: t.params.observeSlideChildren }),
                    a(t.wrapperEl, { attributes: !1 });
                }
              }),
              n("destroy", () => {
                i.forEach((e) => {
                  e.disconnect();
                }),
                  i.splice(0, i.length);
              });
          },
        ]);
      var ue = r(5072),
        de = r.n(ue),
        pe = r(7825),
        fe = r.n(pe),
        he = r(7659),
        me = r.n(he),
        ge = r(5056),
        ye = r.n(ge),
        ve = r(540),
        we = r.n(ve),
        be = r(1113),
        Ae = r.n(be),
        Se = r(2870),
        Ee = {};
      (Ee.styleTagTransform = Ae()),
        (Ee.setAttributes = ye()),
        (Ee.insert = me().bind(null, "head")),
        (Ee.domAPI = fe()),
        (Ee.insertStyleElement = we());
      de()(Se.A, Ee);
      Se.A && Se.A.locals && Se.A.locals;
      le.use([ce]),
        document.addEventListener("DOMContentLoaded", () => {
          const e = new le(".product-slider__swiper", {
            allowTouchMove: !0,
            loop: !0,
            modules: [ce],
            navigation: {
              nextEl: ".product-slider__arrow-next",
              prevEl: ".product-slider__arrow-prev",
            },
            watchOverflow: !0,
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesVisibility: !0,
            slideClass: "product-slider__slide",
            wrapperClass: "product-slider__swiper-wrapper",
          });
          document.addEventListener("productMobileSlidesUpdated", () => {
            e.update();
          });
        });
      var xe = r(8974);
      const Te = async (e, t, r = "", n = "") => {
          const o = { items: [{ id: e, quantity: t }] };
          r
            ? ((o.items[0].selling_plan = r),
              (o.items[0].properties = { Note: "Preorder" }))
            : "true" === n && (o.items[0].properties = { Note: "Preorder" });
          return await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(o),
          })
            .then((e) => e.json())
            .catch((e) => {
              xe.error("Add to cart Error:", e);
            });
        },
        Oe = (e, t) => {
          let r = e,
            n = !1;
          for (; null !== r; )
            r.classList.contains(t) && (n = !0), (r = r.parentElement);
          return n;
        };
      var Pe = r(8974);
      class je extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.fetchProductRecommendations();
        }
        fetchProductRecommendations() {
          fetch(this.dataset.url)
            .then((e) => e.text())
            .then((e) => {
              const t = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(`.${this.classList}`);
              t &&
                t.innerHTML.trim().length &&
                ((this.innerHTML = t.innerHTML),
                this.watchShowMore(),
                this.watchRecommendedQuickAdd(),
                this.changeSize(),
                this.watchShowQuickAddButtons(),
                this.watchDocumentClickTarget());
            });
        }
        changeSize() {
          this.querySelectorAll(
            '.product-recommendations [name="recommended-product-size"]'
          ).forEach((e) => {
            e.addEventListener("change", (t) => {
              t.preventDefault();
              const r = "product__size-label--checked",
                n = "product__size-item--checked",
                o = this.querySelector(`label[for="${e.id}"]`),
                i = t.target,
                s = e.closest(".product__size-variants").querySelector(`.${r}`),
                a = i
                  .closest(".product__quick-add-panel")
                  .querySelector(".product__add-to-cart"),
                l = e.closest(".product__size-variants").querySelector(`.${n}`);
              i.classList.contains(n) ||
                (o.classList.add(r),
                i.classList.add(n),
                s.classList.remove(r),
                l.classList.remove(n)),
                a.click();
            });
          });
        }
        watchShowMore() {
          const e = this.querySelector(".recommendations-list"),
            t = this.querySelector(".show-more-btn");
          t &&
            t.addEventListener(
              "click",
              this.watchShowMoreHandler.bind(this, e)
            );
        }
        watchShowMoreHandler(e) {
          const t = e.querySelectorAll(".product.hidden"),
            r = e
              .closest("[data-rec-products]")
              .querySelector(".show-more-btn");
          t.forEach((e, t) => {
            e.classList.remove("hidden"), (r.style.display = "none");
          });
        }
        watchRecommendedQuickAdd() {
          this.querySelectorAll(".product__add-to-cart").forEach((e) => {
            e.addEventListener("click", () => {
              const t = this.querySelector(
                  `#${e.dataset.quickAddPanel}`
                ).querySelectorAll("input"),
                r = Array.from(t).find((e) =>
                  e.classList.contains("product__size-item--checked")
                );
              if (r) {
                const e = r.value;
                e
                  ? (async () => {
                      const t = await Te(e, 1);
                      if (t) {
                        if (!!t.items) {
                          const e = document.getElementById(
                            "CartDrawerEmptyState"
                          );
                          e.classList.contains("disp-none-imp") ||
                            e.classList.add("disp-none-imp");
                        }
                        document.dispatchEvent(
                          new CustomEvent("updateCartDrawerRecommendedProducts")
                        ),
                          ((e) => {
                            const t = document.querySelector(
                                ".cart-flyover-you-may-also-like"
                              ),
                              r = document.querySelector(
                                ".cart-flyover-shipping-bar"
                              ),
                              n = document.querySelector(
                                ".cart-flyover-footer"
                              );
                            t &&
                              "hide" === e &&
                              t.classList.add("disp-none-imp"),
                              r &&
                                ("hide" === e &&
                                  r.classList.add("disp-none-imp"),
                                "show" === e &&
                                  r.classList.remove("disp-none-imp")),
                              n &&
                                ("hide" === e &&
                                  n.classList.add("disp-none-imp"),
                                "show" === e &&
                                  n.classList.remove("disp-none-imp"));
                          })("show");
                        const e = new CustomEvent(
                          "dispatch:cart-flyover:refresh",
                          { bubbles: !0 }
                        );
                        document.dispatchEvent(e);
                        const r = new CustomEvent("dispatch:cart-drawer:open", {
                          bubbles: !0,
                        });
                        document.dispatchEvent(r);
                      }
                    })()
                  : Pe.error(
                      "Variant ID not found. Ensure that the size variant has a valid ID."
                    );
              } else
                Pe.error(
                  "No size variant selected. Please select a size before adding to the cart."
                );
            });
          });
        }
        watchShowQuickAddButtons() {
          this.querySelectorAll("[data-show-quick-add-button]").forEach((e) => {
            e.addEventListener("click", () => {
              const t = document.getElementById(e.dataset.showQuickAddButton);
              (e.style.opacity = 0),
                (t.style.visibility = "visible"),
                (t.style.opacity = 1);
            });
          });
        }
        watchDocumentClickTarget() {
          document.addEventListener("click", function (e) {
            const t = !Oe(e.target, "product"),
              r = !Oe(e.target, "product__size-variants");
            t &&
              r &&
              (this.querySelectorAll(".product__quick-add-panel").forEach(
                (e) => {
                  (1 !== e.style.opacity && "visible" !== e.style.visibility) ||
                    ((e.style.visibility = "hidden"),
                    e.removeAttribute("style"));
                }
              ),
              this.querySelectorAll(".product[data-product-id]").forEach(
                (e) => {
                  e.querySelector(
                    "[data-show-quick-add-button]"
                  ).style.opacity = 1;
                }
              ));
          });
        }
      }
      r(3052);
      customElements.define("single-product", t),
        customElements.define("recommendation-products", je);
    })();
})();
